/* @revflare
  {
      "id": "revflare",
      "name": "Revflare",
      "version": "1.7.0",
      "description": "Core RevFlare framework \u2014 global utilities, custom element base, and component initialisation."
  }
*/
if (window.__REV_FLARE_LOADED__) { /* duplicate load — skip */ } else {
  window.__REV_FLARE_LOADED__ = true;

  const REV_DEBUG = false;

  // ================================
  // Version: 1.0.1
  // ================================
  // Universal Scripting
  // ================================
  // ================================
  // Media
  // ================================

  // Custom video button - scoped to closest video in the same parent element
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rev-play');
    if (!btn) return;
    const wrap = btn.closest('.rev-media');
    if (!wrap) return;
    const video = wrap.querySelector('video');
    if (!video) return;
    if (!video.hasAttribute('controls')) video.setAttribute('controls', 'controls');
    try { video.muted = false; } catch (_) { }
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => { /* ignore autoplay-policy errors */ });
    btn.style.display = 'none';
    video.addEventListener('ended', function handleEnd() {
      video.removeAttribute('controls');
      btn.hidden = false;
      video.currentTime = 0;
      video.pause();
      video.removeEventListener('ended', handleEnd);
    }, { once: true });
  }, { passive: true });

  // ================================
  // Arrives By Date Calculator
  // Supports two modes:
  //   range  — simple "today + X days" with earliest/latest span
  //   cutoff — timezone-aware daily cutoff with business-day skip
  // ================================
  function updateArrivesByDates() {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    function formatDate(date) {
      const d = new Date(date);
      return monthNames[d.getMonth()] + ' ' + d.getDate();
    }

    function formatDateWithDay(date) {
      const d = new Date(date);
      return dayNames[d.getDay()] + ', ' + monthNames[d.getMonth()] + ' ' + d.getDate();
    }

    // Add N business days (Mon-Fri) to a Date, skipping weekends
    function addBusinessDays(startDate, days) {
      var result = new Date(startDate);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dow = result.getDay();
        if (dow !== 0 && dow !== 6) { // skip Sat (6) and Sun (0)
          added++;
        }
      }
      return result;
    }

    // Get current date parts in a specific timezone using Intl
    function getZonedNow(tz) {
      var now = new Date();
      var dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      });
      var parts = dtf.formatToParts(now);
      var out = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'year') out.year = Number(parts[i].value);
        if (parts[i].type === 'month') out.month = Number(parts[i].value);
        if (parts[i].type === 'day') out.day = Number(parts[i].value);
        if (parts[i].type === 'hour') out.hour = Number(parts[i].value);
        if (parts[i].type === 'minute') out.minute = Number(parts[i].value);
      }
      // Construct a local Date from the zoned parts so day-of-week is correct
      out.date = new Date(out.year, out.month - 1, out.day);
      out.dow = out.date.getDay(); // 0=Sun .. 6=Sat
      return out;
    }

    document.querySelectorAll('.rev-arrives-by').forEach(function (el) {
      var mode = el.dataset.arrivesByMode || 'range';

      if (mode === 'range') {
        // Original range mode
        var daysDelivery = parseInt(el.dataset.arrivesByDaysDelivery, 10);
        var daysLatest = parseInt(el.dataset.arrivesByDaysLatest, 10);
        if (isNaN(daysDelivery) || isNaN(daysLatest)) return;

        var dateEst = new Date();
        dateEst.setDate(dateEst.getDate() + daysDelivery);

        var dateLatest = new Date();
        dateLatest.setDate(dateLatest.getDate() + daysLatest);

        var estSpan = el.querySelector('.rev-arrives-date-est');
        var latestSpan = el.querySelector('.rev-arrives-date-latest');
        if (estSpan) estSpan.textContent = formatDate(dateEst);
        if (latestSpan) latestSpan.textContent = formatDate(dateLatest);

      } else if (mode === 'cutoff') {
        // Cutoff mode — timezone-aware with business day skip
        var tz = el.dataset.arrivesByCutoffTz || 'America/New_York';
        var cutoffTime = el.dataset.arrivesByCutoffTime || '10:00';
        var expeditedDays = parseInt(el.dataset.arrivesByCutoffExpedited, 10) || 1;
        var standardDays = parseInt(el.dataset.arrivesByCutoffStandard, 10) || 2;

        var cutoffParts = cutoffTime.split(':');
        var cutoffHour = parseInt(cutoffParts[0], 10) || 10;
        var cutoffMinute = parseInt(cutoffParts[1], 10) || 0;

        var zoned = getZonedNow(tz);
        var currentMinutes = zoned.hour * 60 + zoned.minute;
        var cutoffMinutes = cutoffHour * 60 + cutoffMinute;

        var isBeforeCutoff = currentMinutes < cutoffMinutes;
        var businessDays = isBeforeCutoff ? expeditedDays : standardDays;

        var arrivalDate = addBusinessDays(zoned.date, businessDays);

        // Convert cutoff time from merchant's tz to visitor's local time for display.
        // Build today's cutoff wall-time as a UTC ms value, then format locally.
        var cutoffUtcMs = (function () {
          // Construct the cutoff moment: today's date in the merchant's tz + cutoff hour/min
          var guess = Date.UTC(zoned.year, zoned.month - 1, zoned.day, cutoffHour, cutoffMinute, 0);
          // Find the offset between UTC and the merchant's tz at that instant
          var probe = new Date(guess);
          var dtf2 = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
          });
          var pp = dtf2.formatToParts(probe);
          var pv = {};
          for (var j = 0; j < pp.length; j++) {
            if (pp[j].type === 'year') pv.year = Number(pp[j].value);
            if (pp[j].type === 'month') pv.month = Number(pp[j].value);
            if (pp[j].type === 'day') pv.day = Number(pp[j].value);
            if (pp[j].type === 'hour') pv.hour = Number(pp[j].value);
            if (pp[j].type === 'minute') pv.minute = Number(pp[j].value);
          }
          var zonedAsUtc = Date.UTC(pv.year, pv.month - 1, pv.day, pv.hour, pv.minute, 0);
          var offset = zonedAsUtc - guess;
          return Date.UTC(zoned.year, zoned.month - 1, zoned.day, cutoffHour, cutoffMinute, 0) - offset;
        })();

        // Format the cutoff instant in the visitor's local timezone
        var cutoffLocal = new Date(cutoffUtcMs);
        var cutoffDisplay = cutoffLocal.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

        var msgSpan = el.querySelector('.rev-arrives-cutoff-msg');
        if (msgSpan) {
          if (isBeforeCutoff) {
            // Check if arrival is tomorrow (1 business day from today)
            var tomorrow = new Date(zoned.date);
            tomorrow.setDate(tomorrow.getDate() + 1);
            var isTomorrow = arrivalDate.getTime() === tomorrow.getTime();
            if (isTomorrow) {
              msgSpan.textContent = 'Order by ' + cutoffDisplay + ' to get it tomorrow';
            } else {
              msgSpan.textContent = 'Order by ' + cutoffDisplay + ' to get it by ' + formatDateWithDay(arrivalDate);
            }
          } else {
            msgSpan.textContent = 'Arrives by ' + formatDateWithDay(arrivalDate);
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateArrivesByDates);
  } else {
    requestAnimationFrame(updateArrivesByDates);
  }

  // ================================
  // Generic Partial Rerender
  // Can rerender anything as long as:
  // - server HTML contains the same selectors
  // - caller provides a URL
  // ================================

  const RevRerender = (() => {
    const abortMap = new WeakMap();

    async function rerender({
      contextEl,
      targets = [],
      url,
      params = {},
      incomingScopeSelector = null,
    }) {
      if (!contextEl || !targets.length) return;

      const controller = new AbortController();
      abortMap.get(contextEl)?.abort();
      abortMap.set(contextEl, controller);

      const finalUrl = buildUrl(url, params);
      if (!finalUrl) return;

      const res = await fetch(finalUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      });
      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const incomingRoot = incomingScopeSelector
        ? doc.querySelector(incomingScopeSelector)
        : doc;

      if (!incomingRoot) return;

      targets.forEach(selector => {
        const current = contextEl.querySelector(selector);
        if (!current) return;

        const incoming = incomingRoot.querySelector(selector);
        if (!incoming) return;

        current.replaceWith(incoming);
      });
    }

    function buildUrl(url, params) {
      if (!url) return null;

      if (typeof url === 'function') return url(params);

      const u = new URL(url, window.location.origin);
      Object.entries(params).forEach(([k, v]) => {
        if (v != null) u.searchParams.set(k, v);
      });
      return u.toString();
    }

    return { rerender };
  })();

  // ================================
  // Client-Side Variant Updates
  // Handles component updates without server rerender
  // ================================

  const RevClientUpdate = (() => {
    function price(contextEl, variant, parentSelector = '') {
      if (!contextEl || !variant) return;
      const selector = parentSelector ? `${parentSelector} .rev-price-wrapper` : '.rev-price-wrapper';
      const wrapper = contextEl.querySelector(selector);
      if (!wrapper) return;
      const cfgScript = wrapper.querySelector('script.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      const variantData = cfg.variants.find(v => v.id === variant.id);
      if (!variantData) return;
      const priceValue = wrapper.querySelector('.rev-price-value');
      if (priceValue) {
        priceValue.textContent = variantData.price;
        priceValue.classList.toggle('rev-price-sale', variantData.slash);
      }
      const slashEl = wrapper.querySelector('.rev-price-slash');
      if (slashEl) {
        slashEl.textContent = variantData.compare_at;
        slashEl.style.display = variantData.slash ? '' : 'none';
      }
      const savingsEl = wrapper.querySelector('.rev-savings');
      if (savingsEl) {
        const showSaving = variantData.slash && cfg.showSaving;
        savingsEl.style.display = showSaving ? '' : 'none';
        savingsEl.textContent = variantData.saving;
      }
    }

    function inventory(contextEl, variant, parentSelector = '') {
      if (!contextEl || !variant) return;
      const selector = parentSelector ? `${parentSelector} .rev-inventory` : '.rev-inventory';
      const wrapper = contextEl.querySelector(selector);
      if (!wrapper) return;
      const cfgScript = wrapper.querySelector('script.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      const variantData = cfg.variants.find(v => v.id === variant.id);
      if (!variantData) return;
      const allStatuses = ['in-stock', 'med', 'low', 'preorder', 'oos'];
      allStatuses.forEach(s => wrapper.classList.remove(`rev-inventory-${s}`));
      wrapper.classList.add(`rev-inventory-${variantData.status}`);
      const textEl = wrapper.querySelector('.rev-inventory-text');
      if (textEl) textEl.textContent = variantData.text;
      const progressBar = wrapper.querySelector('.rev-inventory-bar');
      if (progressBar) {
        progressBar.value = variantData.qty;
        progressBar.textContent = variantData.qty;
      }
    }

    function klaviyoBis(contextEl, variant) {
      if (!contextEl || !variant) return;
      const wrapper = contextEl.querySelector('.rev-kl-bis');
      if (!wrapper) return;
      const cfgScript = wrapper.querySelector('script.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      const variantData = cfg.variants.find(v => v.id === variant.id);
      if (!variantData) return;
      const trigger = wrapper.querySelector('.klaviyo-bis-trigger');
      if (!trigger) return;
      trigger.dataset.variant = variant.id;
      if (variantData.show) {
        trigger.style.setProperty('display', 'block', 'important');
      } else {
        trigger.style.setProperty('display', 'none', 'important');
      }
    }

    function buyButtons(contextEl, variant, parentSelector = '') {
      if (!contextEl) return;
      const selector = parentSelector ? `${parentSelector} .rev-buy-buttons` : '.rev-buy-buttons';
      const wrapper = contextEl.querySelector(selector);
      if (!wrapper) return;
      const cfgScript = wrapper.querySelector('script.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      const variantData = cfg.variants.find(v => v.id === variant.id);
      if (!variantData) return;
      const status = variantData.status;
      const label = variantData.label;
      const button = wrapper.querySelector('.rev-atc-button');
      if (button) {
        const labelSpan = button.querySelector('span');
        if (labelSpan) {
          labelSpan.textContent = label;
        }
        button.setAttribute('aria-label', label);
        button.classList.remove('rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos');
        button.classList.add(`rev-button-status-${status}`);
        button.disabled = (status === 'oos');
        button.classList.toggle('rev-button-oos', status === 'oos');
        button.dataset.variantId = variant.id;
      }
      const dynamicCheckout = wrapper.querySelector('.rev-dynamic-checkout');
      if (dynamicCheckout) {
        dynamicCheckout.style.display = (status === 'oos') ? 'none' : '';
      }
      const subtextEl = wrapper.querySelector('[data-rev-button-subtext-preorder]');
      if (subtextEl) {
        const subtext = variantData.subtext || '';
        if (subtext) {
          subtextEl.textContent = subtext;
          subtextEl.style.display = '';
        } else {
          subtextEl.textContent = '';
          subtextEl.style.display = 'none';
        }
      }
      const recs = wrapper.querySelector('.rev-oos-recommendations');
      if (recs) {
        recs.style.display = (status === 'oos') ? 'block' : 'none';
      }
    }

    function gallery(contextEl, variant) {
      if (!contextEl || !variant) return;
      const galleryEl = contextEl.querySelector('.rev-product-gallery');
      if (!galleryEl) return;
      const cfgScript = galleryEl.querySelector('.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      const variantData = cfg.variants.find(v => v.id === variant.id);
      if (!variantData || !variantData.media) return;
      const playButtonSvg = `<span class="rev-play-button"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" class="rev-icon rev-icon-play" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L6 22.3923L6 1.60769L24 12Z" fill="currentColor"/></svg></span>`;
      const thumbnails = galleryEl.querySelector('.rev-gallery-thumbnails');
      if (thumbnails) {
        thumbnails.innerHTML = variantData.media.map((m, i) => `
        <div class="rev-gallery-thumbnail-item rev-media${i === 0 ? ' rev-gallery-thumbnail-active' : ''}" data-index="${i}" data-media-id="${m.id}">
          ${m.type === 'video' ? playButtonSvg : ''}
          ${m.thumbnail}
        </div>
      `).join('');
      }
      const track = galleryEl.querySelector('.rev-gallery-track');
      if (track) {
        track.innerHTML = variantData.media.map((m, i) => `
        <div class="rev-media" data-index="${i}" data-media-id="${m.id}">
          ${m.main}
          ${m.type === 'video' ? `<button type="button" class="rev-play" aria-label="Play video">${playButtonSvg}</button>` : ''}
        </div>
      `).join('');
      }
      const bulletContainer = galleryEl.querySelector('.rev-gallery-slide-indicator');
      if (bulletContainer) {
        bulletContainer.innerHTML = variantData.media.map((m, i) => `
        <button type="button" class="rev-gallery-slide-bullet${i === 0 ? ' rev-gallery-slide-bullet-active' : ''}" data-index="${i}" data-media-id="${m.id}" aria-label="Go to slide ${i + 1}"></button>
      `).join('');
      }
      // Rebuild zoom modal images for the new variant
      const zoomImagesContainer = galleryEl.querySelector('.rev-gallery-zoom-images');
      if (zoomImagesContainer) {
        zoomImagesContainer.innerHTML = variantData.media.map((m) => `
        <div class="rev-gallery-zoom-item rev-media">
          ${m.type === 'video' ? playButtonSvg : ''}
          ${m.main}
        </div>
      `).join('');
      }
      // Reset gallery initialization, including zoom if present
      galleryEl.removeAttribute('data-rev-gallery-init');
      galleryEl.removeAttribute('data-rev-zoom-init');
      galleryEl._revGalleryInstance = null;
      if (window.RevGallery?.init) {
        window.RevGallery.init(galleryEl);
      }
      if (window.RevGalleryZoom?.init) {
        const wrapper = galleryEl.closest('.rev-product-gallery-wrapper') || galleryEl.closest('[data-section-id]') || galleryEl.parentElement;
        if (wrapper) window.RevGalleryZoom.init(wrapper);
      }
    }

    function sku(contextEl, variant) {
      if (!contextEl || !variant) return;
      const skuEl = contextEl.querySelector('[data-rev-sku]');
      if (!skuEl) return;
      skuEl.textContent = variant.sku || '';
    }

    return { price, inventory, klaviyoBis, buyButtons, gallery, sku };
  })();
  window.RevClientUpdate = RevClientUpdate;

  // ================================
  // Variant Selector
  // ================================



  // Pageload Triggers: Product Page URL Variant Parameter Set and disable invalid variant options
  document.addEventListener('DOMContentLoaded', () => {

    const main = document.querySelector('.rev-product-main');
    if (!main) return;
    if (!window.location.pathname.includes('/products/')) return;

    const form = main.querySelector('.rev-block-buy-buttons form.rev-product-form');
    const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
    const variantId = idInput?.value;
    if (!variantId) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.get('variant')) {
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    }

    initVariantSelectorState(document);
    // Trigger gallery autoscroll
    const selectorEl = main.querySelector('.rev-variant-selector[data-context="main"]');
    const cfgScript = selectorEl?.querySelector('.rev-cfg');
    if (cfgScript) {
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent.trim());
      } catch (e) {
        return;
      }
      const variant = cfg.variants.find(v => v.id === parseInt(variantId, 10));
      if (variant?.feat_media) {
        setTimeout(() => {
          const gallery = main.querySelector('.rev-product-gallery');
          if (!gallery) return;

          const targetMediaId = variant.feat_media.toString();
          const mediaElements = gallery.querySelectorAll('[data-media-id]');

          let targetIndex = -1;
          for (let i = 0; i < mediaElements.length; i++) {
            if (mediaElements[i].dataset.mediaId === targetMediaId) {
              targetIndex = parseInt(mediaElements[i].dataset.index, 10);
              break;
            }
          }
          if (targetIndex === -1) return;

          const galleryInstance = gallery._revGalleryInstance;
          if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
            galleryInstance.scrollToIndex(targetIndex, 'auto');
          }
        }, 150);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // product main: gallery selected variant autoscroll (for non-product pages)
    const mains = document.querySelectorAll('.rev-product-main');
    mains.forEach(main => {
      const form = main.querySelector('.rev-block-buy-buttons form.rev-product-form');
      const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
      const variantId = idInput?.value;
      if (!variantId) return;
      const selectorEl = main.querySelector('.rev-variant-selector[data-context="main"]');
      const cfgScript = selectorEl?.querySelector('.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent.trim());
      } catch (e) {
        return;
      }
      const variant = cfg.variants.find(v => v.id === parseInt(variantId, 10));
      if (!variant?.feat_media) return;
      const waitForGallery = (attempts = 0) => {
        if (attempts > 50) return; // Give up after ~2.5 seconds
        const gallery = main.querySelector('.rev-product-gallery');
        if (!gallery || !gallery._revGalleryInstance) {
          setTimeout(() => waitForGallery(attempts + 1), 50);
          return;
        }
        // Gallery is ready, do the autoscroll
        const targetMediaId = variant.feat_media.toString();
        const mediaElements = gallery.querySelectorAll('[data-media-id]');
        let targetIndex = -1;
        for (let i = 0; i < mediaElements.length; i++) {
          if (mediaElements[i].dataset.mediaId === targetMediaId) {
            targetIndex = parseInt(mediaElements[i].dataset.index, 10);
            break;
          }
        }
        if (targetIndex === -1) return;
        const galleryInstance = gallery._revGalleryInstance;
        if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
          galleryInstance.scrollToIndex(targetIndex, 'auto');
        }
      };
      // Start polling after brief delay
      setTimeout(() => waitForGallery(), 50);
    });
  });

  // Variant Combination Helpers
  function variantMatches(v, selected) {
    return selected.every((val, idx) => {
      if (!val) return true;
      return v[`option${idx + 1}`] === val;
    });
  }

  function getValidValuesByOption(variants, selected) {
    const valid = [new Set(), new Set(), new Set()];

    for (let optIdx = 0; optIdx < 3; optIdx++) {
      const partial = selected.slice();
      partial[optIdx] = null;

      variants.forEach(v => {
        if (!variantMatches(v, partial)) return;
        const val = v[`option${optIdx + 1}`];
        if (val != null) valid[optIdx].add(val);
      });
    }

    return valid;
  }

  function updateOptionDisables(selectorEl, validSets) {
    // Radios / swatches
    selectorEl.querySelectorAll('input[data-option-position]').forEach(input => {
      const idx = parseInt(input.dataset.optionPosition, 10) - 1;
      const isValid = validSets[idx]?.has(input.value);

      input.dataset.revInvalid = (!isValid).toString();

      const wrap = input.closest('.rev-swatch-option');
      if (wrap) {
        wrap.classList.toggle('rev-swatch-disabled', !isValid);
        wrap.setAttribute('aria-disabled', (!isValid).toString());
      }
    });

    // Select dropdowns: never disable option1 (position 1 / idx 0)
    selectorEl.querySelectorAll('select[data-option-position]').forEach(select => {
      const idx = parseInt(select.dataset.optionPosition, 10) - 1;
      const isPrimary = idx === 0;

      Array.from(select.options).forEach(opt => {
        if (!opt.value) return;
        const isValid = validSets[idx]?.has(opt.value);

        // Primary dropdown stays selectable; others get disabled normally
        opt.disabled = !isPrimary && !isValid;
      });
    });
  }

  function findBestVariant(variants, selected, changedIdx) {
    const wantedValue = selected[changedIdx];
    if (!wantedValue) return null;

    // Only consider variants that match what the user just changed
    const candidates = variants.filter(v => v[`option${changedIdx + 1}`] === wantedValue);
    if (!candidates.length) return null;

    // Hierarchy: preserve earlier option positions first (excluding changedIdx)
    // Example:
    // changedIdx = 0 => prefer option2, then option3
    // changedIdx = 1 => prefer option1, then option3
    // changedIdx = 2 => prefer option1, then option2
    const priority = [0, 1, 2].filter(i => i !== changedIdx);

    const matchesAt = (v, idx) => {
      const want = selected[idx];
      if (!want) return false; // if nothing selected there, don't use it to rank
      return v[`option${idx + 1}`] === want;
    };

    const compare = (a, b) => {
      // 1) Lexicographic hierarchy on options
      for (const idx of priority) {
        const aMatch = matchesAt(a, idx);
        const bMatch = matchesAt(b, idx);
        if (aMatch !== bMatch) return aMatch ? -1 : 1; // match wins
      }

      // 2) Optional: prefer available
      if (Boolean(a.available) !== Boolean(b.available)) return a.available ? -1 : 1;

      // 3) Deterministic tie-breaker: lowest id wins
      return (a.id || 0) - (b.id || 0);
    };

    return candidates.slice().sort(compare)[0];
  }

  function applyVariantToUI(selectorEl, variant) {
    const vals = [variant.option1, variant.option2, variant.option3];

    selectorEl.querySelectorAll('input[type="radio"][data-option-position]').forEach(inp => {
      const idx = parseInt(inp.dataset.optionPosition, 10) - 1;
      inp.checked = inp.value === vals[idx];
    });

    selectorEl.querySelectorAll('select[data-option-position]').forEach(sel => {
      const idx = parseInt(sel.dataset.optionPosition, 10) - 1;
      if (vals[idx] != null) sel.value = vals[idx];
    });

    selectorEl.querySelectorAll('.rev-swatch-option')
      .forEach(el => el.classList.remove('rev-option-active'));

    selectorEl.querySelectorAll('input[type="radio"]:checked')
      .forEach(inp => inp.closest('.rev-swatch-option')?.classList.add('rev-option-active'));
  }

  function readSelectedFromUI(selectorEl) {
    const selected = [];
    selectorEl.querySelectorAll('[data-option-position]').forEach(el => {
      const idx = parseInt(el.dataset.optionPosition, 10) - 1;
      if (el.type === 'radio' && el.checked) selected[idx] = el.value;
      if (el.tagName === 'SELECT') selected[idx] = el.value;
    });
    return selected;
  }

  function recomputeAndApplyDisables(selectorEl, variants) {
    const selected = readSelectedFromUI(selectorEl);
    const validSets = getValidValuesByOption(variants, selected);
    updateOptionDisables(selectorEl, validSets);
  }

  // Resolve stock status for each option value relative to current selection
  function updateOptionStockStatus(selectorEl, variants, selected) {
    const allStatuses = ['in-stock', 'preorder', 'oos'];

    // Swatches (radio inputs)
    selectorEl.querySelectorAll('input[data-option-position]').forEach(input => {
      const idx = parseInt(input.dataset.optionPosition, 10) - 1;
      const testSelected = selected.slice();
      testSelected[idx] = input.value;

      const match = variants.find(v =>
        testSelected.every((val, i) => val == null || v[`option${i + 1}`] === val)
      );

      const status = match ? (match.stock_status || 'in-stock') : 'oos';

      const wrap = input.closest('.rev-swatch-option');
      if (wrap) {
        allStatuses.forEach(s => wrap.classList.remove(`rev-option-stock-status-${s}`));
        wrap.classList.add(`rev-option-stock-status-${status}`);
      }
    });

    // Select dropdowns
    selectorEl.querySelectorAll('select[data-option-position]').forEach(select => {
      const idx = parseInt(select.dataset.optionPosition, 10) - 1;
      Array.from(select.options).forEach(opt => {
        if (!opt.value) return;
        const testSelected = selected.slice();
        testSelected[idx] = opt.value;

        const match = variants.find(v =>
          testSelected.every((val, i) => val == null || v[`option${i + 1}`] === val)
        );

        opt.dataset.stockStatus = match ? (match.stock_status || 'in-stock') : 'oos';
      });
    });
  }

  function initVariantSelectorState(root = document) {
    root.querySelectorAll('.rev-variant-selector').forEach(selectorEl => {
      const cfgScript = selectorEl.querySelector('.rev-cfg');
      if (!cfgScript) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgScript.textContent.trim());
      } catch {
        return;
      }
      recomputeAndApplyDisables(selectorEl, cfg.variants);
      const initSelected = readSelectedFromUI(selectorEl);
      updateOptionStockStatus(selectorEl, cfg.variants, initSelected);
    });
  }

  // Active Class Change
  document.addEventListener('change', function (e) {
    if (e.target.type === 'radio' && e.target.closest('.rev-variant-selector')) {
      const radioInput = e.target;
      const variantSelector = radioInput.closest('.rev-variant-selector');
      const radioName = radioInput.name;

      const relatedSwatches = variantSelector.querySelectorAll(
        `input[type="radio"][name="${radioName}"]`
      );

      relatedSwatches.forEach(function (radio) {
        const swatchOption = radio.closest('.rev-swatch-option');
        if (swatchOption) {
          swatchOption.classList.remove('rev-option-active');
        }
      });

      const selectedSwatchOption = radioInput.closest('.rev-swatch-option');
      if (selectedSwatchOption) {
        selectedSwatchOption.classList.add('rev-option-active');
      }
    }
  });

  // Change ATC Variant ID
  document.addEventListener('change', function (e) {
    const selector = e.target.closest('.rev-variant-selector');
    if (!selector) return;

    const context = selector.dataset.context;
    if (!context) return;

    const isMainContext = context === 'main';
    const isQuickview = context === 'quickview';
    const isBundle = context === 'bundle';
    let contextEl;
    if (isMainContext) {
      contextEl = selector.closest('.rev-product-main');
    } else if (isQuickview) {
      contextEl = selector.closest('[data-rev-quickview]');
    } else if (isBundle) {
      contextEl = selector.closest('.rev-bundle-builder__variant-wrap');
    } else {
      contextEl = selector.closest('.rev-product-card');
    }

    if (!contextEl) return;

    const cfgScript = selector.querySelector('.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent.trim());
    } catch {
      return;
    }
    const variants = cfg.variants;

    const selected = [];

    selector.querySelectorAll('[data-option-position]').forEach(el => {
      const pos = parseInt(el.dataset.optionPosition, 10) - 1;
      if (el.type === 'radio' && el.checked) selected[pos] = el.value;
      if (el.tagName === 'SELECT') selected[pos] = el.value;
    });

    const changedEl = e.target.closest('[data-option-position]');
    const changedIdx = changedEl
      ? parseInt(changedEl.dataset.optionPosition, 10) - 1
      : 0;

    // Always record the value just changed, even if other options aren't checked yet
    if (changedEl) {
      if (changedEl.type === 'radio') selected[changedIdx] = changedEl.value;
      if (changedEl.tagName === 'SELECT') selected[changedIdx] = changedEl.value;
    }

    if (selected.every(v => v == null)) return;

    // 1) Disable impossible option values
    const validSets = getValidValuesByOption(variants, selected);
    updateOptionDisables(selector, validSets);

    // 2) Resolve variant
    let variant = variants.find(v =>
      v.option1 === selected[0] &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    );

    // 3) Snap if invalid
    if (!variant) {
      variant = findBestVariant(variants, selected, changedIdx);
      if (!variant) return;

      applyVariantToUI(selector, variant);

      selected[0] = variant.option1;
      selected[1] = variant.option2;
      selected[2] = variant.option3;

      const validSetsAfter = getValidValuesByOption(variants, selected);
      updateOptionDisables(selector, validSetsAfter);
    }

    // 4) Update form variant ID — scoped by context
    if (isBundle) {
      // Bundle builder handles its own form/variant tracking via approval.js
    } else if (isMainContext) {
      const form = contextEl.querySelector('.rev-block-buy-buttons form.rev-product-form');
      const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
      if (idInput) idInput.value = variant.id;
    } else if (isQuickview) {
      const form = contextEl.querySelector('.rev-quickview__actions form.rev-product-form');
      const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
      if (idInput) idInput.value = variant.id;
    } else {
      const form = contextEl.querySelector('form.rev-product-form');
      const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
      if (idInput) idInput.value = variant.id;
    }

    // 5) URL update (main PDP only)
    if (isMainContext && window.location.pathname.includes('/products/')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // 6) Legend text update (scoped to this selector)
    selector.querySelectorAll('.rev-legend span').forEach((span, idx) => {
      if (selected[idx]) {
        span.textContent = selected[idx];
      }
    });

    // 6.5) Stock status classes on option items
    updateOptionStockStatus(selector, variants, selected);

    // 7) Client updates — scoped by context using block selectors
    if (isBundle) {
      // Bundle: update price within the variant-wrap
      RevClientUpdate.price(contextEl, variant);

      // Update the item preview image (same pattern as quickview)
      if (variant.feat_media_url) {
        const bundleItem = contextEl.closest('[data-bundle-item]');
        const cfgScript = bundleItem?.querySelector('.rev-bundle-item-cfg');

        let itemCfg = null;
        if (cfgScript) {
          try {
            itemCfg = JSON.parse(cfgScript.textContent.trim());
          } catch (_) { }
        }

        const overlayEnabled = !!itemCfg?.customInput?.overlayEnabled;
        const overlayMedia = itemCfg?.customInput?.overlayMedia;

        if (!(overlayEnabled && overlayMedia)) {
          const itemImg = bundleItem?.querySelector('[id^="bundle-item-img-"]');
          if (itemImg) {
            const makeSrc = (url, w) => url.replace(/width=\d+/, `width=${w}`);
            itemImg.srcset = `${makeSrc(variant.feat_media_url, 200)} 200w, ${makeSrc(variant.feat_media_url, 400)} 400w`;
            itemImg.src = makeSrc(variant.feat_media_url, 400);
          }
        }
      }
    } else if (isMainContext) {
      RevClientUpdate.price(contextEl, variant, '.rev-block-price');
      RevClientUpdate.buyButtons(contextEl, variant, '.rev-block-buy-buttons');
      RevClientUpdate.inventory(contextEl, variant, '.rev-block-inventory');
      RevClientUpdate.klaviyoBis(contextEl, variant);
      RevClientUpdate.sku(contextEl, variant);

      // Update all price wrappers inside subscription block
      const subPlan = contextEl.querySelector('[data-subscription-plan]');
      if (subPlan) {
        subPlan.querySelectorAll('[data-rev-sub-option]').forEach(opt => {
          RevClientUpdate.price(opt, variant);
        });
      }

      // Sync sticky ATC bar with main button state
      const stickyBtn = contextEl.querySelector('[data-rev-sticky-atc] .rev-atc-button');
      if (stickyBtn) {
        const mainBtn = contextEl.querySelector('.rev-block-buy-buttons .rev-atc-button');
        if (mainBtn) {
          stickyBtn.dataset.variantId = mainBtn.dataset.variantId;
          stickyBtn.disabled = mainBtn.disabled;
          stickyBtn.setAttribute('aria-label', mainBtn.getAttribute('aria-label'));
          stickyBtn.classList.remove('rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos');
          ['rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos'].forEach(cls => {
            if (mainBtn.classList.contains(cls)) stickyBtn.classList.add(cls);
          });
          stickyBtn.classList.toggle('rev-button-oos', mainBtn.classList.contains('rev-button-oos'));
          const mainLabel = mainBtn.querySelector('span');
          const stickyLabel = stickyBtn.querySelector('span');
          if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
        }

        // Sync price from the freshly-updated main price block
        const stickyPrice = contextEl.querySelector('[data-rev-sticky-price]');
        const mainPrice = contextEl.querySelector('.rev-block-price .rev-price-value');
        if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent;
      }
    } else if (isQuickview) {
      RevClientUpdate.price(contextEl, variant, '.rev-quickview__price');
      RevClientUpdate.buyButtons(contextEl, variant, '.rev-quickview__actions');

      if (variant.feat_media_url) {
        const qvMedia = contextEl.querySelector('.rev-quickview__media img');
        if (qvMedia) {
          const makeSrc = (url, w) => url.replace(/width=\d+/, `width=${w}`);
          qvMedia.srcset = `${makeSrc(variant.feat_media_url, 180)} 180w, ${makeSrc(variant.feat_media_url, 360)} 360w`;
          qvMedia.src = makeSrc(variant.feat_media_url, 360);
        }
      }
    } else {
      RevClientUpdate.price(contextEl, variant);
      RevClientUpdate.buyButtons(contextEl, variant);
    }

    // 8) Gallery update (main and card only, not quickview or bundle)
    if (!isQuickview && !isBundle) {
      const gallery = contextEl.querySelector('.rev-product-gallery');
      const variantMetadata = gallery?.dataset.variantMetadata === 'true';

      let shouldAutoscrollGallery = false;
      if (variantMetadata) {
        RevClientUpdate.gallery(contextEl, variant);
      } else {
        if (variant.feat_media) {
          shouldAutoscrollGallery = true;
        }
      }

      if (shouldAutoscrollGallery) {
        setTimeout(() => {
          const gallery = contextEl.querySelector('.rev-product-gallery');
          if (gallery && variant.feat_media) {
            const isSlider = gallery.classList.contains('rev-product-gallery-slider');
            const isMobile = window.matchMedia('(max-width: 749px)').matches;
            const targetMediaId = variant.feat_media.toString();
            const mediaElements = gallery.querySelectorAll('[data-media-id]');
            let targetIndex = -1;
            let targetElement = null;
            for (let i = 0; i < mediaElements.length; i++) {
              if (mediaElements[i].dataset.mediaId === targetMediaId) {
                targetIndex = parseInt(mediaElements[i].dataset.index, 10);
                targetElement = mediaElements[i];
                break;
              }
            }
            if (targetIndex === -1) return;
            if (isMobile || isSlider) {
              const galleryInstance = gallery._revGalleryInstance;
              if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
                galleryInstance.scrollToIndex(targetIndex, 'smooth');
              }
            } else {
              if (targetElement) {
                const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
                const scrollTarget = elementTop - 250;
                window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
              }
            }
          }
        }, 150);
      }
    }
  });

  // ================================
  // PDP Checkbox Upsell
  // Prevent default theme JS interactions
  // ================================
  document.addEventListener('click', function (e) {
    const upsell = e.target.closest('.rev-checkbox');
    if (!upsell) return;
    e.preventDefault();
    e.stopPropagation();
    const input = upsell.querySelector('.rev-checkbox__toggle');
    if (!input) return;
    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ================================
  // Card Quick-Add (Icon Button)
  // Smart ATC: direct add for single/resolved variants,
  // navigate to PDP for unresolved variants
  // ================================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rev-card-quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.revBusy) return;
    btn.dataset.revBusy = '1';

    const card = btn.closest('.rev-product-card');
    if (!card) { delete btn.dataset.revBusy; return; }

    const isSingle = btn.dataset.singleVariant === 'true';
    const variantId = btn.dataset.variantId;

    // Read the card's JSON config for variant data
    const cfgScript = card.querySelector('script.rev-card-cfg');
    let cfg = null;
    if (cfgScript) {
      try { cfg = JSON.parse(cfgScript.textContent.trim()); } catch (_) { }
    }

    // Determine if all options are resolved
    let resolvedVariantId = null;

    if (isSingle) {
      // Single variant — always direct ATC
      resolvedVariantId = variantId;
    } else if (cfg) {
      // Check swatches: gather selected option values from active card swatches
      const swatchGroups = card.querySelectorAll('.rev-card-swatches');
      const selected = {};

      swatchGroups.forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const active = group.querySelector('.rev-card-swatch-active');
        if (active && pos) selected[pos] = active.dataset.optionValue;
      });

      // Count how many option types the product has (from variants data)
      const optionCount = cfg.v[0].o.length;
      const selectedCount = Object.keys(selected).length;

      if (selectedCount >= optionCount) {
        // All options resolved — find the matching available variant
        const match = cfg.v.find(v =>
          v.o.every((opt, i) => !selected[i + 1] || opt === selected[i + 1]) && v.a
        );
        if (match) resolvedVariantId = String(match.id);
      } else if (optionCount === 1) {
        // Only one option type and there's an active swatch — use it
        const activeSwatch = card.querySelector('.rev-card-swatch-active');
        if (activeSwatch) {
          const optVal = activeSwatch.dataset.optionValue;
          const match = cfg.v.find(v => v.o[0] === optVal && v.a);
          if (match) resolvedVariantId = String(match.id);
        }
      }
    }

    if (resolvedVariantId) {
      // Delegate to the universal addToCart (handles discount, drawer, errors)
      const atcBtn = card.querySelector('.rev-atc-button');
      addToCart({
        variantId: resolvedVariantId,
        quantity: 1,
        btn: atcBtn || btn,
        contextEl: card,
        isMainContext: false,
        action: 'add_to_cart'
      }).finally(() => {
        delete btn.dataset.revBusy;
      });
    } else {
      // Open quickview modal for unresolved multi-variant products
      delete btn.dataset.revBusy;
      const productUrl = card.dataset.productUrl;
      if (!productUrl) return;

      // Find the quickview overlay within the same section
      const section = card.closest('[data-section-id]');
      const qvOverlay = section?.querySelector('[data-rev-quickview]');
      if (!qvOverlay) {
        // No quickview available — fall back to PDP
        window.location.href = productUrl;
        return;
      }

      revQuickview.open(qvOverlay, productUrl);
    }
  });

  // ================================
  // Quickview Modal Controller
  // Opens modal, fetches product via section rerender,
  // handles close + ATC events
  // ================================
  const revQuickview = (() => {
    let activeOverlay = null;
    let _overlayOriginalParent = null;
    let _scrollbarWidth = 0;

    function lockScroll() {
      _scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (_scrollbarWidth > 0) {
        document.body.style.paddingRight = _scrollbarWidth + 'px';
      }
    }

    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    async function open(overlay, productUrl) {
      activeOverlay = overlay;

      // Move overlay to body to escape any stacking context
      if (overlay.parentElement !== document.body) {
        _overlayOriginalParent = overlay.parentElement;
        document.body.appendChild(overlay);
      }

      overlay.classList.add('active');
      lockScroll();

      // Show skeleton immediately while fetch is in flight
      const body = overlay.querySelector('[data-rev-quickview-body]');
      if (body) {
        body.style.transition = 'none';
        body.style.opacity = '1';
        body.innerHTML = `
        <div class="rev-quickview__skeleton">
          <div class="rev-quickview__skeleton-row">
            <div class="rev-quickview__skeleton-media"></div>
            <div class="rev-quickview__skeleton-info">
              <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--title"></div>
              <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--type"></div>
              <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--price"></div>
            </div>
          </div>
          <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--options"></div>
          <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--options"></div>
          <div class="rev-quickview__skeleton-line rev-quickview__skeleton-line--btn"></div>
        </div>
      `;
      }

      // Fetch product content via section rerender
      const sectionId = overlay.dataset.sectionId;
      if (!sectionId || !productUrl) return;

      await RevRerender.rerender({
        contextEl: overlay,
        targets: ['[data-rev-quickview-body]'],
        url: productUrl,
        params: { section_id: sectionId },
        incomingScopeSelector: '[data-rev-quickview]'
      });

      // Fade in fresh content
      const freshBody = overlay.querySelector('[data-rev-quickview-body]');
      if (freshBody) {
        freshBody.style.transition = 'none';
        freshBody.style.opacity = '0';
        requestAnimationFrame(() => {
          freshBody.style.transition = 'opacity 0.25s ease';
          freshBody.style.opacity = '1';
        });
      }

      // Initialize variant selector state (disables, etc.) on fresh content
      initVariantSelectorState(overlay);
    }

    function close() {
      if (!activeOverlay) return;
      activeOverlay.classList.remove('active');
      unlockScroll();

      // Move overlay back to its original parent after transition
      const overlayToReturn = activeOverlay;
      const parentToReturn = _overlayOriginalParent;
      setTimeout(() => {
        if (parentToReturn && overlayToReturn.parentElement === document.body) {
          parentToReturn.appendChild(overlayToReturn);
        }
      }, 350);

      activeOverlay = null;
      _overlayOriginalParent = null;
    }

    function getActive() {
      return activeOverlay;
    }

    return { open, close, getActive };
  })();

  // Close quickview: close button
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rev-quickview-close]')) {
      e.preventDefault();
      revQuickview.close();
    }
  });

  // Close quickview: overlay click (outside modal)
  document.addEventListener('click', function (e) {
    const overlay = e.target.closest('[data-rev-quickview]');
    if (overlay && overlay.classList.contains('active') && e.target === overlay) {
      revQuickview.close();
    }
  });

  // Close quickview: escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      revQuickview.close();
    }
  });

  // Quickview ATC: close modal after successful add
  document.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('.rev-quickview__actions .rev-atc-button');
    if (!atcBtn) return;

    const overlay = atcBtn.closest('[data-rev-quickview]');
    if (!overlay) return;

    let closed = false;
    function doClose() {
      if (closed) return;
      closed = true;
      document.documentElement.removeEventListener('cart:updated', onCartUpdated);
      if (observer) observer.disconnect();
      revQuickview.close();
    }

    // Primary: cart:updated custom event (fired by most cart drawer themes)
    function onCartUpdated() { doClose(); }
    document.documentElement.addEventListener('cart:updated', onCartUpdated);

    // Fallback: watch for the loading class being removed from the button
    let observer = null;
    if (typeof MutationObserver !== 'undefined') {
      observer = new MutationObserver(() => {
        if (!atcBtn.classList.contains('loading') && !atcBtn.disabled) {
          // Small delay to let any cart animation start before closing
          setTimeout(doClose, 300);
        }
      });
      observer.observe(atcBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
    }

    // Safety net: close after 8s regardless
    setTimeout(doClose, 8000);
  });

  // ================================
  // Card Swatch Interaction
  // Hover = select. Shows image layer + updates variant.
  // Click kept for mobile/accessibility.
  // ================================
  function revShowSwatchMedia(card, optionValue) {
    const cardMedia = card.querySelector('.rev-card-media');
    if (!cardMedia) return;
    cardMedia.querySelectorAll('.rev-card-swatch-media').forEach(m => m.classList.remove('active'));
    if (optionValue) {
      const target = cardMedia.querySelector(`.rev-card-swatch-media[data-swatch-value="${CSS.escape(optionValue)}"]`);
      if (target) target.classList.add('active');
    }
  }

  function revSelectCardSwatch(swatch) {
    const card = swatch.closest('.rev-product-card');
    if (!card) return;
    const group = swatch.closest('.rev-card-swatches');
    if (!group) return;

    // Already active — skip
    if (swatch.classList.contains('rev-card-swatch-active')) return;

    // Update active state
    group.querySelectorAll('.rev-card-swatch').forEach(s => s.classList.remove('rev-card-swatch-active'));
    swatch.classList.add('rev-card-swatch-active');

    // Show matching image layer
    revShowSwatchMedia(card, swatch.dataset.optionValue);

    // Update quick-add variant ID
    const cfgScript = card.querySelector('script.rev-card-cfg');
    if (!cfgScript) return;
    let cfg;
    try { cfg = JSON.parse(cfgScript.textContent.trim()); } catch (_) { return; }

    const selected = {};
    card.querySelectorAll('.rev-card-swatches').forEach(g => {
      const pos = parseInt(g.dataset.optionPosition, 10);
      const active = g.querySelector('.rev-card-swatch-active');
      if (active && pos) selected[pos] = active.dataset.optionValue;
    });

    const match = cfg.v.find(v =>
      v.o.every((opt, i) => !selected[i + 1] || opt === selected[i + 1])
    );
    if (match) {
      const quickAddBtn = card.querySelector('.rev-card-quick-add');
      if (quickAddBtn) quickAddBtn.dataset.variantId = String(match.id);
    }
  }

  // Hover selects (desktop)
  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.rev-card-swatch');
    if (swatch) revSelectCardSwatch(swatch);
  });

  // Click selects (mobile + accessibility)
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.rev-card-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    revSelectCardSwatch(swatch);
  });

  // ================================
  // Subscription Helper
  // ================================
  function getSubscriptionSelection(contextEl) {
    const fieldset = contextEl.querySelector('[data-subscription-plan]');
    if (!fieldset) {
      return { hasSubscriptionUI: false, purchaseOption: 'onetime', sellingPlanId: null };
    }

    const checked = fieldset.querySelector('input[name="purchase_option"]:checked');
    const purchaseOption = (checked?.value || 'onetime').toLowerCase();

    // Only needed if subscription is selected
    let sellingPlanId = null;
    if (purchaseOption === 'subscription') {
      const select = fieldset.querySelector('select[name="selling_plan"]');
      sellingPlanId = select?.value ? String(select.value) : null;
    }

    return { hasSubscriptionUI: true, purchaseOption, sellingPlanId };
  }

  // ================================
  // Sticky Add to Cart
  // ================================
  document.addEventListener('DOMContentLoaded', () => {
    const main = document.querySelector('.rev-product-main');
    if (!main) return;

    const stickyBar = main.querySelector('[data-rev-sticky-atc]');
    if (!stickyBar) return;

    const buyBlock = main.querySelector('.rev-block-buy-buttons');
    if (!buyBlock) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('rev-sticky-atc-visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(buyBlock);
  });

  // Sync sticky ATC when the subscription purchase option or selling plan changes
  document.addEventListener('change', function (e) {
    const isPurchaseOption = e.target.matches('input[name="purchase_option"]');
    const isSellingPlan = e.target.matches('select[name="selling_plan"]');
    if (!isPurchaseOption && !isSellingPlan) return;

    const main = e.target.closest('.rev-product-main');
    if (!main) return;

    const stickyBtn = main.querySelector('[data-rev-sticky-atc] .rev-atc-button');
    if (!stickyBtn) return;

    // rAF lets subscription block JS update the main button/price first
    requestAnimationFrame(() => {
      const mainBtn = main.querySelector('.rev-block-buy-buttons .rev-atc-button');
      if (mainBtn) {
        stickyBtn.dataset.variantId = mainBtn.dataset.variantId;
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.setAttribute('aria-label', mainBtn.getAttribute('aria-label'));
        stickyBtn.classList.remove('rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos');
        ['rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos'].forEach(cls => {
          if (mainBtn.classList.contains(cls)) stickyBtn.classList.add(cls);
        });
        stickyBtn.classList.toggle('rev-button-oos', mainBtn.classList.contains('rev-button-oos'));
        const mainLabel = mainBtn.querySelector('span');
        const stickyLabel = stickyBtn.querySelector('span');
        if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
      }

      // Sync price — reads whichever price is currently visible in the main price block
      const stickyPrice = main.querySelector('[data-rev-sticky-price]');
      if (stickyPrice) {
        const mainPrice = main.querySelector('.rev-block-price .rev-price-value');
        if (mainPrice) stickyPrice.textContent = mainPrice.textContent;
      }
    });
  });

  // ================================
  // Universal Add To Cart Handler
  // ================================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rev-atc-button');
    if (!btn) return;

    if (REV_DEBUG) console.log('[REV ATC] fired | product:', btn.getAttribute('data-product-title'), '| discountCode:', JSON.stringify(btn.dataset.discountCode));

    const card = btn.closest('.rev-product-card');
    const main = btn.closest('.rev-product-main');
    const qv = btn.closest('.rev-quickview');
    const contextEl = card || main || qv;
    const isMainContext = !!main;
    const isPopupContext = !!btn.closest('.rev-popup-overlay');

    if (REV_DEBUG) console.log('[REV ATC] context:', contextEl?.className, '| isMain:', isMainContext, '| isPopup:', isPopupContext);

    if (!contextEl) return;

    // prevent double-click/double-fire from native theme listeners
    if (btn.dataset.revBusy === '1') return;
    btn.dataset.revBusy = '1';

    let form;
    if (qv) {
      form = contextEl.querySelector('.rev-quickview__actions form.rev-product-form');
    } else if (main) {
      form = contextEl.querySelector('.rev-block-buy-buttons form.rev-product-form');
    } else {
      form = contextEl.querySelector('form.rev-product-form');
    }
    const idInput = form?.querySelector('input[name="id"]');
    const variantId = idInput?.value || btn.dataset.variantId;
    if (!variantId) {
      delete btn.dataset.revBusy;
      return;
    }

    const action = (btn.dataset.action || 'add_to_cart').toLowerCase();

    // Validate required custom inputs (main context only)
    if (isMainContext) {
      const requiredInputs = main.querySelectorAll('.rev-custom-input__field[data-rev-required="true"]');
      let hasValidationError = false;

      requiredInputs.forEach(input => {
        const wrapper = input.closest('.rev-custom-input');
        const isEmpty = !input.value || input.value.trim() === '';

        if (isEmpty) {
          hasValidationError = true;
          wrapper.classList.add('rev-validation-error');

          // Remove error state when user starts typing
          input.addEventListener('input', function clearError() {
            wrapper.classList.remove('rev-validation-error');
            input.removeEventListener('input', clearError);
          }, { once: true });
        }
      });

      if (hasValidationError) {
        console.warn('Please fill in all required fields');
        delete btn.dataset.revBusy;
        return;
      }
    }

    let quantity = 1;
    if (isMainContext) {
      const qtySelector = main.querySelector('.rev-qty-selector');
      if (qtySelector) {
        const qtyInput = qtySelector.querySelector('input[type="number"]');
        if (qtyInput) {
          quantity = parseInt(qtyInput.value, 10) || 1;
        }
      }
    }

    addToCart({
      variantId,
      quantity,
      btn,
      contextEl,
      isMainContext,
      isPopupContext,
      action,
    });
  }, { passive: false });

  async function addToCart({ variantId, quantity, btn, contextEl, isMainContext, isPopupContext, action }) {
    try {
      btn.disabled = true;
      btn.classList.add('loading');

      const items = [{ id: variantId, quantity }];

      const { hasSubscriptionUI, purchaseOption, sellingPlanId } = getSubscriptionSelection(contextEl);
      if (hasSubscriptionUI && purchaseOption === 'subscription') {
        if (!sellingPlanId) {
          console.warn('Subscription selected but no selling plan found.');
        } else {
          items[0].selling_plan = sellingPlanId;
        }
      }

      // Add custom input properties (main context only)
      if (isMainContext) {
        const mainProductProperties = {};
        const customInputs = contextEl.querySelectorAll('.rev-custom-input__field');

        customInputs.forEach(input => {
          if (input.value && input.value.trim() !== '') {
            // Extract property name from name="properties[PropertyName]"
            const nameAttr = input.getAttribute('name') || '';
            const match = nameAttr.match(/properties\[([^\]]+)\]/);
            if (match && match[1]) {
              const propertyName = match[1];
              mainProductProperties[propertyName] = input.value.trim();
            }
          }
        });

        // Add properties to main product item if any exist
        if (Object.keys(mainProductProperties).length > 0) {
          items[0].properties = mainProductProperties;
        }

        // Add upsell products with their line item properties
        const mainProductTitle = contextEl.querySelector('.rev-block-title, h1[class*="heading"]');
        const mainProductTitleText = mainProductTitle ? mainProductTitle.textContent.trim() : 'Product';

        const checkedUpsells = contextEl.querySelectorAll('.rev-checkbox-upsell input[type="checkbox"]:checked');
        checkedUpsells.forEach(checkbox => {
          const upsellVariantId = checkbox.dataset.variantId;
          if (upsellVariantId) {
            items.push({
              id: upsellVariantId,
              quantity: 1,
              properties: {
                'Added with': mainProductTitleText
              }
            });
          }
        });

        // Add confirmed bundle-item-selector products
        const selectedBundleItems = contextEl.querySelectorAll(
          '.rev-bundle-builder__item[data-bundle-selected="true"][data-bundle-variant-id]'
        );

        selectedBundleItems.forEach(bundleItem => {
          const bundleVariantId = bundleItem.dataset.bundleVariantId;
          if (!bundleVariantId) return;

          const bundleCartItem = {
            id: Number(bundleVariantId),
            quantity: 1,
            properties: {
              'Added with': mainProductTitleText,
              '_bundle_selector': 'true'
            }
          };

          const customValue = bundleItem.dataset.bundleCustomInput;
          const customPropName = bundleItem.dataset.bundleCustomInputPropertyName;

          if (customValue && customPropName) {
            bundleCartItem.properties[customPropName] = customValue;
          }

          // Flag items that represent strict customizations (like engraving)
          if (bundleItem.classList.contains('rev-bundle-buy-box__engraving-item') || bundleItem.hasAttribute('data-is-customization')) {
            bundleCartItem._isCustomization = true;
          }

          items.push(bundleCartItem);
        });

        // Add bundle buy box products (legacy fallbacks for engraving, display, touches)
        const engravingCheckbox = contextEl.querySelector('.rev-bundle-buy-box__engraving-checkbox:checked');
        if (engravingCheckbox) {
          const engravingVariantId = engravingCheckbox.dataset.variantId;
          const engravingTextInput = contextEl.querySelector('.rev-bundle-buy-box__engraving-input');
          const engravingText = engravingTextInput ? engravingTextInput.value.trim() : '';
          
          if (engravingVariantId) {
            items.push({
              id: Number(engravingVariantId),
              quantity: 1,
              properties: {
                'Added with': mainProductTitleText,
                'Engraving': engravingText || 'Yes'
              },
              _isCustomization: true
            });
            if (engravingText) {
              if (!items[0].properties) items[0].properties = {};
              items[0].properties['Engraving Text'] = engravingText;
            }
          }
        }

        const displayRadio = contextEl.querySelector('.rev-bundle-buy-box__display-radio:checked');
        if (displayRadio) {
          const displayVariantId = displayRadio.value;
          if (displayVariantId) {
            items.push({
              id: Number(displayVariantId),
              quantity: 1,
              properties: {
                'Added with': mainProductTitleText,
                '_bundle_display': 'true'
              }
            });
          }
        }

        const touchesCheckboxes = contextEl.querySelectorAll('.rev-bundle-buy-box__touch-checkbox:checked');
        touchesCheckboxes.forEach(checkbox => {
          const touchVariantId = checkbox.value;
          if (touchVariantId) {
            items.push({
              id: Number(touchVariantId),
              quantity: 1,
              properties: {
                'Added with': mainProductTitleText,
                '_bundle_touch': 'true'
              }
            });
          }
        });
      }

      if (items.length > 1) {
        const bundleGroupId = `group_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
        
        // Check if any added item is a strict customization
        const hasCustomization = items.some(item => item._isCustomization);
        const customizationId = hasCustomization ? `cust_${Date.now()}_${Math.floor(Math.random() * 1000000)}` : null;

        if (hasCustomization) {
          if (!items[0].properties) items[0].properties = {};
          items[0].properties['_customization_id'] = customizationId;
        }

        items.forEach((item, index) => {
          if (!item.properties) {
            item.properties = {};
          }
          
          // All items get the bundle group ID
          item.properties['_bundle_group_id'] = bundleGroupId;
          
          // Mark parent role explicitly
          if (index === 0) {
            item.properties['_bundle_role'] = 'parent';
          } else {
            item.properties['_bundle_role'] = 'child';
          }

          // Bind strict customizations
          if (item._isCustomization) {
            item.properties['_customization_parent_id'] = customizationId;
            delete item._isCustomization;
          }
        });
      }

      // Find the cart drawer section ID so Shopify can return rendered HTML in one roundtrip
      const cartDrawerSectionId = getCartDrawerSectionId();

      const body = { items };
      if (cartDrawerSectionId) {
        body.sections = [cartDrawerSectionId];
        body.sections_url = window.location.pathname;
      }

      const fetchHeaders = { 'Content-Type': 'application/json' };
      if (isPopupContext) {
        fetchHeaders['X-REV-POPUP-ATC'] = '1';
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: fetchHeaders,
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || 'Could not add item to cart.');
      }

      const parsedState = await res.json();

      // Check for amazon coupon checkbox and apply discount after adding to cart
      const couponCheckbox = contextEl.querySelector('.amazon-coupon-checkbox:checked[data-discount-code]');
      if (couponCheckbox) {
        const discountCode = couponCheckbox.dataset.discountCode;
        if (discountCode && discountCode.trim() !== '') {
          try {
            // Apply discount via Shopify's discount URL
            const discountUrl = `/discount/${encodeURIComponent(discountCode.trim())}?redirect=${encodeURIComponent(window.location.pathname)}`;
            await fetch(discountUrl, {
              method: 'GET',
              credentials: 'include',
              redirect: 'follow'
            });
            // Small delay to ensure discount is applied to cart
            await new Promise(resolve => setTimeout(resolve, 150));
          } catch (err) {
            console.warn('Failed to apply discount code:', err);
          }
        }
      }

      // Check for buy button auto-discount and apply after coupon (if any)
      const btnDiscountCode = btn.dataset.discountCode;
      if (REV_DEBUG) console.log('[REV ATC] discount check | code:', JSON.stringify(btnDiscountCode));
      if (btnDiscountCode && btnDiscountCode.trim() !== '') {
        if (REV_DEBUG) console.log('[REV ATC] applying discount:', btnDiscountCode.trim());
        try {
          const discountCode = btnDiscountCode.trim();
          if (REV_DEBUG) console.log('[REV ATC] applying discount via cart/update.js:', discountCode);
          const discRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-REV-Internal': 'true'
            },
            body: JSON.stringify({ discount: discountCode })
          });
          if (REV_DEBUG) console.log('[REV ATC] discount update response — status:', discRes.status, 'ok:', discRes.ok);
          if (!discRes.ok) {
            const text = await discRes.text().catch(() => '');
            throw new Error(text || 'Failed to apply discount code.');
          }
          // Small delay to ensure discount is applied to cart
          await new Promise(resolve => setTimeout(resolve, 150));

          if (REV_DEBUG) {
            try {
              const cartAfterDiscount = await fetch('/cart.js', { credentials: 'include' }).then(r => r.json());
              console.log('[REV ATC] cart after discount:', {
                total_discount: cartAfterDiscount.total_discount,
                total_price: cartAfterDiscount.total_price,
                original_total_price: cartAfterDiscount.original_total_price,
                cart_level_discount_applications: cartAfterDiscount.cart_level_discount_applications,
                discount_applications: cartAfterDiscount.discount_applications,
                items: (cartAfterDiscount.items || []).map(item => ({
                  title: item.title,
                  quantity: item.quantity,
                  original_line_price: item.original_line_price,
                  final_line_price: item.final_line_price,
                  discounts: item.discounts,
                  discount_allocations: item.discount_allocations
                }))
              });
            } catch (err) {
              console.warn('[REV ATC] failed to fetch cart after discount:', err);
            }
          }

          // Re-fetch cart drawer section with discount applied
          if (REV_DEBUG) console.log('[REV ATC] cartDrawerSectionId:', cartDrawerSectionId);
          if (cartDrawerSectionId) {
            try {
              const root = window.Shopify?.routes?.root || '/';
              const resp = await fetch(`${root}?section_id=${cartDrawerSectionId}`);
              const freshHtml = await resp.text();
              if (parsedState.sections) parsedState.sections[cartDrawerSectionId] = freshHtml;
              else parsedState.sections = { [cartDrawerSectionId]: freshHtml };
              if (REV_DEBUG) console.log('[REV ATC] re-fetched cart drawer section with discount');
            } catch (_) {
              if (REV_DEBUG) console.warn('[REV ATC] failed to re-fetch cart drawer section');
            }
          } else {
            // No section ID found — strip sections so revOpenCartDrawer re-fetches fresh
            parsedState.sections = null;
            if (REV_DEBUG) console.warn('[REV ATC] no cartDrawerSectionId, forcing re-fetch in revOpenCartDrawer');
          }
        } catch (err) {
          if (REV_DEBUG) console.error('[REV ATC] discount fetch failed:', err);
        }
      } else {
        if (REV_DEBUG) console.warn('[REV ATC] skipping discount — code empty/missing');
      }

      document.body.classList.add('rev-item-added');

      // Dispatch cart events for theme integrations (header cart count, badges, etc.)
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('product-ajax:added', { bubbles: true }));

      // Non-blocking: fetch cart state for pubsub events (doesn't delay drawer opening)
      fetch('/cart.js').then(r => r.json()).then(cartJson => {
        if (parsedState.sections) cartJson.sections = parsedState.sections;
        document.dispatchEvent(new CustomEvent('cart-update', {
          bubbles: true,
          detail: { cart: cartJson, source: 'product-form', productVariantId: variantId }
        }));
      }).catch(() => { });

      if (action === 'buy_now') {
        window.location.assign('/checkout');
      } else {
        // Pass the sections we already got from /cart/add.js — no extra fetch needed
        await revOpenCartDrawer(parsedState.sections);
      }

      if (isPopupContext) {
        const popupOverlay = contextEl.closest('.rev-popup-overlay');
        if (popupOverlay) {
          const sectionId = popupOverlay.getAttribute('data-section-id');
          if (sectionId) {
            setTimeout(() => window.RevFlarePopups?.[sectionId]?.close?.(), 150);
          }
        }
      }

    } catch (err) {
      console.error('Error adding to cart:', err);
      revShowCartError(err.message);
    } finally {
      delete btn.dataset.revBusy;
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  }

  // ================================
  // Cart Drawer Section ID Helper
  // Finds the theme's cart drawer section ID for Shopify's Section Rendering API.
  // ================================
  function getCartDrawerSectionId() {
    const CART_DRAWER_SELECTORS = [
      'cart-drawer',
      'cart-drawer-drawer',
      '#CartDrawer',
      '[id*="CartDrawer"]',
      '[data-cart-drawer]',
    ];

    for (const sel of CART_DRAWER_SELECTORS) {
      const el = document.querySelector(sel);
      if (!el) continue;
      // Try data-id first (Dawn pattern), then extract from parent section wrapper
      if (el.dataset.id) return el.dataset.id;
      const wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) return wrapper.id.replace('shopify-section-', '');
    }
    return null;
  }

  // ================================
  // Open Cart Drawer - Theme Agnostic
  // ================================
  // Cart Error Toast
  // Shows a user-facing error notification when add-to-cart fails
  // ================================
  function revShowCartError(message) {
    var defaultMsg = 'Something went wrong. Please try again.';
    var text = (typeof message === 'string' && message.trim()) ? message.trim() : defaultMsg;

    // Reuse existing toast or create one
    var toast = document.getElementById('rev-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'rev-cart-toast';
      toast.className = 'rev-cart-toast';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.innerHTML =
        '<svg class="rev-cart-toast__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>' +
        '<path d="M12 8v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<circle cx="12" cy="16" r="1" fill="currentColor"/>' +
        '</svg>' +
        '<span class="rev-cart-toast__message"></span>' +
        '<button type="button" class="rev-cart-toast__close" aria-label="Dismiss">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
        '</button>';
      document.body.appendChild(toast);

      toast.querySelector('.rev-cart-toast__close').addEventListener('click', function () {
        toast.classList.remove('rev-cart-toast--visible');
      });
    }

    // Update message + show
    toast.querySelector('.rev-cart-toast__message').textContent = text;

    // Clear any pending auto-dismiss
    if (toast._dismissTimer) clearTimeout(toast._dismissTimer);

    // Force reflow for re-animation
    toast.classList.remove('rev-cart-toast--visible');
    void toast.offsetWidth;
    toast.classList.add('rev-cart-toast--visible');

    // Auto-dismiss after 5s
    toast._dismissTimer = setTimeout(function () {
      toast.classList.remove('rev-cart-toast--visible');
    }, 5000);
  }

  // Helper: extract error message from a failed /cart/add.js response
  async function revParseCartError(res) {
    try {
      var data = await res.json();
      return data.description || data.message || 'Could not add item to cart.';
    } catch (e) {
      return 'Could not add item to cart.';
    }
  }

  // ================================
  // Character Counter — Universal (Event Delegation)
  // Uses a single delegated listener on document so it works regardless
  // of when the script loads (theme asset OR app extension).
  // Catches all input events from [data-rev-char-input] elements.
  // ================================
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-rev-char-input]');
    if (!input) return;

    var wrapper = input.closest('.rev-bundle-builder__custom-input-wrapper')
      || input.parentElement;
    if (!wrapper) return;

    var countEl = wrapper.querySelector('[data-rev-char-count]');
    if (!countEl) return;

    countEl.textContent = input.value.length;
  });

  // Kept for backwards compatibility (bundle builder auto-init calls this)
  function revInitCharCounters() { }

  // ================================
  // Placeholder Cycling — Universal
  // Auto-discovers inputs with [data-rev-suggestions] and cycles placeholder
  // text with a typewriter effect. Each input runs independently.
  // ================================
  function revInitPlaceholderCycle(scope) {
    var root = scope || document;
    var inputs = root.querySelectorAll('[data-rev-suggestions]');
    inputs.forEach(function (input) {
      if (input._revCycleBound) return;
      input._revCycleBound = true;

      var raw = input.getAttribute('data-rev-suggestions');
      if (!raw) return;

      var suggestions = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (suggestions.length === 0) return;

      var currentIndex = 0;
      var charIndex = 0;
      var isTyping = true;
      var isPaused = false;
      var fallbackPlaceholder = input.placeholder || 'Type here...';

      input.addEventListener('focus', function () {
        isPaused = true;
        input.placeholder = fallbackPlaceholder;
      });

      input.addEventListener('blur', function () {
        if (input.value.length === 0) {
          isPaused = false;
        }
      });

      function tick() {
        if (isPaused) {
          requestAnimationFrame(function () { setTimeout(tick, 200); });
          return;
        }

        var word = suggestions[currentIndex];

        if (isTyping) {
          charIndex++;
          input.placeholder = word.substring(0, charIndex);

          if (charIndex >= word.length) {
            isTyping = false;
            setTimeout(tick, 2000);
            return;
          }
          setTimeout(tick, 80);
        } else {
          charIndex--;
          if (charIndex <= 0) {
            isTyping = true;
            currentIndex = (currentIndex + 1) % suggestions.length;
            setTimeout(tick, 300);
            return;
          }
          input.placeholder = word.substring(0, charIndex);
          setTimeout(tick, 40);
        }
      }

      setTimeout(tick, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { revInitPlaceholderCycle(); });
  } else {
    // Script may have loaded after DOMContentLoaded (e.g. app extension).
    // Use rAF to ensure the browser has finished painting before querying.
    requestAnimationFrame(function () { revInitPlaceholderCycle(); });
  }

  // ================================
  // Cart Drawer
  // Only runs native-theme strategies when RevFlare's own cart is NOT present.
  // Replaces the entire section wrapper so the custom element re-initializes properly.
  // ================================
  async function revOpenCartDrawer(sections) {
    // If RevFlare's own cart drawer exists, it handles everything — bail out
    if (document.getElementById('ufl-cart')) return true;

    const CART_DRAWER_SELECTORS = [
      'cart-drawer',
      'cart-drawer-drawer',
      '#CartDrawer',
      '[id*="CartDrawer"]',
      '[data-cart-drawer]',
    ];

    // 1) Find the cart drawer and refresh its section
    let drawerEl = null;
    for (const sel of CART_DRAWER_SELECTORS) {
      drawerEl = document.querySelector(sel);
      if (drawerEl) break;
    }

    if (drawerEl) {
      const sectionId = getCartDrawerSectionId();
      if (sectionId) {
        try {
          // Use pre-fetched section HTML from /cart/add.js response if available
          let html = sections?.[sectionId];
          if (!html) {
            // Fallback: fetch it (e.g. when called without sections data)
            const root = window.Shopify?.routes?.root || '/';
            html = await (await fetch(`${root}?section_id=${sectionId}`)).text();
          }

          // Replace the entire section wrapper — creates a fresh custom element
          // that re-initializes via connectedCallback (close button etc. bind properly)
          const sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
          if (sectionWrapper && html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newWrapper = doc.getElementById(`shopify-section-${sectionId}`);
            sectionWrapper.innerHTML = newWrapper ? newWrapper.innerHTML : html;

            // Re-find the drawer element (old reference is gone)
            drawerEl = null;
            for (const sel of CART_DRAWER_SELECTORS) {
              drawerEl = document.querySelector(sel);
              if (drawerEl) break;
            }
          }
        } catch (_) { /* non-critical — try to show drawer anyway */ }
      }

      // Show the drawer
      if (drawerEl) {
        try {
          if (typeof drawerEl.show === 'function') { drawerEl.show(); return true; }
          if (typeof drawerEl.open === 'function') { drawerEl.open(); return true; }
        } catch (_) { /* silent */ }
      }
      return true;
    }

    // 2) Click common cart-toggle BUTTONS (not links — links navigate to /cart)
    const triggers = [
      'button[aria-controls="CartDrawer"]',
      'button[aria-controls="cart-drawer"]',
      'button[data-cart-toggle]',
      'button[data-drawer-trigger="cart"]',
      'button[name="cart"]',
      'button.header__icon--cart',
      'button.site-header__cart',
      'button.cart-link',
    ];

    for (const sel of triggers) {
      const el = document.querySelector(sel);
      if (!el) continue;
      el.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, cancelable: true }));
      el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
      el.click();
      return true;
    }

    // 3) Last resort: go to cart page
    window.location.href = '/cart';
    return false;
  }

  // ================================
  // Currency Conversion Helper
  // ================================
  let __revCurrencyLibPromise = null;

  function ensureCurrencyLib() {
    if (window.Currency?.convert) return Promise.resolve();

    if (__revCurrencyLibPromise) return __revCurrencyLibPromise;

    __revCurrencyLibPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load currencies.js'));
      document.head.appendChild(script);
    });

    return __revCurrencyLibPromise;
  }

  async function convertCents(cents, from, to) {
    // no-op cases
    const amount = Number(cents || 0);
    if (!from || !to || from === to) return amount;

    // ensure lib
    await ensureCurrencyLib();

    // guard if rates missing
    if (!window.Currency?.rates?.[from] || !window.Currency?.rates?.[to]) return amount;

    // currencies.js works in "major" units
    const major = amount / 100;
    const convertedMajor = Currency.convert(major, from, to);
    return Math.round(convertedMajor * 100);
  }

  // Micro-cache for shop->cart conversions (per currency pair)
  const __revFxCache = new Map(); // key: "USD->GBP:5000" or for more general: "USD->GBP:rate"
  async function convertCentsCached(cents, from, to) {
    const key = `${from}->${to}:${cents}`;
    if (__revFxCache.has(key)) return __revFxCache.get(key);
    const v = await convertCents(cents, from, to);
    __revFxCache.set(key, v);
    return v;
  }

  // ================================
  // Triggered Popups Engine
  // ================================
  (function () {
    if (window.__REV_POPUP_ENGINE__) return; // prevent double-init
    window.__REV_POPUP_ENGINE__ = true;

    const instances = new Map();
    const triggers = new Map();
    let globalListenersBound = false;

    function parseConfig(overlay) {
      const cfgEl = overlay.querySelector('.rev-popup-config');
      if (!cfgEl) return null;
      try {
        const cfg = JSON.parse(cfgEl.textContent.trim());
        if (!cfg.sectionId) return null;
        return cfg;
      } catch {
        return null;
      }
    }

    function makeStorageKeys(sectionId) {
      return {
        popupShown: `revPopupShown_${sectionId}`,
        pageviews: `revPopupPageviews_${sectionId}`,
        visitorFirstSeen: 'revPopupFirstVisit',
        trafficSource: 'revPopupTrafficSource'
      };
    }

    function getTrafficSource(cfg) {
      const keys = makeStorageKeys(cfg.sectionId);
      const stored = localStorage.getItem(keys.trafficSource);
      if (stored) return stored;

      const params = new URLSearchParams(window.location.search);
      const utm_source = (params.get('utm_source') || '').toLowerCase();
      const utm_medium = (params.get('utm_medium') || '').toLowerCase();
      const referrer = (document.referrer || '').toLowerCase();

      let source = 'unknown';

      if (utm_source || utm_medium) {
        if (utm_source.includes('facebook') || utm_source.includes('instagram') || utm_source.includes('fb') || utm_source.includes('ig')) source = 'meta';
        else if (utm_source.includes('google') || utm_medium.includes('cpc') || utm_medium.includes('ppc')) source = 'google';
        else if (utm_source.includes('klaviyo') || utm_source.includes('email')) source = 'klaviyo';
        else if (utm_source.includes('tiktok')) source = 'tiktok';
        else if (utm_source.includes('snapchat') || utm_source.includes('snap')) source = 'snapchat';
      }

      if (source === 'unknown') {
        if (!referrer) source = 'direct';
        else if (referrer.includes('facebook.com') || referrer.includes('instagram.com')) source = 'meta';
        else if (referrer.includes('google.com') || referrer.includes('google.')) source = 'google';
        else if (referrer.includes('tiktok.com')) source = 'tiktok';
        else if (referrer.includes('snapchat.com')) source = 'snapchat';
      }

      localStorage.setItem(keys.trafficSource, source);
      return source;
    }

    function passesFilters(inst) {
      const cfg = inst.config;
      if (!cfg.filteringEnabled) return true;

      if (cfg.filterDevice && cfg.filterDevice !== 'all') {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (cfg.filterDevice === 'mobile' && !isMobile) return false;
        if (cfg.filterDevice === 'desktop' && isMobile) return false;
      }

      if (cfg.filterVisitorStatus && cfg.filterVisitorStatus !== 'all') {
        const keys = inst.storageKeys;
        const firstVisit = localStorage.getItem(keys.visitorFirstSeen);
        const isNew = !firstVisit;
        if (!firstVisit) localStorage.setItem(keys.visitorFirstSeen, Date.now().toString());

        if (cfg.filterVisitorStatus === 'new' && !isNew) return false;
        if (cfg.filterVisitorStatus === 'returning' && isNew) return false;
      }

      if (cfg.filterTrafficSource) {
        const source = getTrafficSource(cfg);
        const allowed = [];
        if (cfg.filterTrafficUnknown) allowed.push('unknown');
        if (cfg.filterTrafficDirect) allowed.push('direct');
        if (cfg.filterTrafficMeta) allowed.push('meta');
        if (cfg.filterTrafficGoogle) allowed.push('google');
        if (cfg.filterTrafficKlaviyo) allowed.push('klaviyo');
        if (cfg.filterTrafficTikTok) allowed.push('tiktok');
        if (cfg.filterTrafficSnapchat) allowed.push('snapchat');
        if (allowed.length && !allowed.includes(source)) return false;
      }

      return true;
    }

    async function getCartInfo() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        return {
          total: Number(cart.total_price || 0),
          currency: cart.currency || null
        };
      } catch {
        return { total: 0, currency: null };
      }
    }

    async function getPopupThresholdInCartCurrency(inst, cartCurrency) {
      // Only apply to ATC-triggered popups with a non-zero threshold
      if (!inst?.config?.triggerATC) return null;

      const raw = Number(inst.config.cartThreshold || 0);
      if (!raw || raw <= 0) return null;

      const from = inst.config.shopCurrency;
      const to = cartCurrency;

      if (from && to && from !== to) {
        return await convertCentsCached(raw, from, to);
      }
      return raw;
    }

    async function refreshThresholdTriggerButtons() {
      const els = document.querySelectorAll('[data-rev-popup-open][data-rev-popup-requires-threshold]');
      if (!els.length) return;
      const { total, currency: cartCurrency } = await getCartInfo();

      // cache threshold calc per trigger key per refresh run
      const thresholdCache = new Map();

      for (const el of els) {
        const key = (el.getAttribute('data-rev-popup-open') || '').trim();
        if (!key) continue;

        const sectionId = triggers.get(key);
        const inst = instances.get(sectionId);

        if (!inst) {
          el.style.display = 'none';
          continue;
        }

        // Get threshold for this popup in cart currency
        let threshold = thresholdCache.get(key);
        if (threshold === undefined) {
          threshold = await getPopupThresholdInCartCurrency(inst, cartCurrency);
          thresholdCache.set(key, threshold);
        }

        // If popup has no threshold requirement, show button
        if (threshold === null) {
          el.style.display = 'block';
          continue;
        }

        // Show only if cart meets threshold
        el.style.display = total >= threshold ? 'block' : 'none';
      }
    }

    function debounce(fn, wait = 150) {
      let t = null;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }

    function observeTriggerRerenders() {
      // Debounced so a big cart re-render doesn’t spam /cart.js
      const refreshDebounced = debounce(() => {
        refreshThresholdTriggerButtons();
      }, 200);

      // Run once immediately in case cart re-render happened before observer
      refreshDebounced();

      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          // New nodes inserted (cart re-render commonly does this)
          if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
            for (const node of m.addedNodes) {
              if (node.nodeType !== 1) continue;

              // Node itself is a trigger
              if (node.matches?.('[data-rev-popup-open][data-rev-popup-requires-threshold]')) {
                refreshDebounced();
                return;
              }

              // Or contains triggers
              if (node.querySelector?.('[data-rev-popup-open][data-rev-popup-requires-threshold]')) {
                refreshDebounced();
                return;
              }
            }
          }

          // Some themes toggle attributes/styles instead of replacing nodes
          if (m.type === 'attributes') {
            const el = m.target;
            if (
              el?.matches?.('[data-rev-popup-open][data-rev-popup-requires-threshold]') &&
              (m.attributeName === 'style' ||
                m.attributeName === 'class' ||
                m.attributeName === 'data-rev-popup-open' ||
                m.attributeName === 'data-rev-popup-requires-threshold')
            ) {
              refreshDebounced();
              return;
            }
          }
        }
      });

      observer.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          'style',
          'class',
          'data-rev-popup-open',
          'data-rev-popup-requires-threshold'
        ]
      });

      // Optional: expose for debugging / teardown
      window.__REV_POPUP_TRIGGER_OBSERVER__ = observer;
    }

    function hasBeenShown(inst) {
      if (!inst.config.showOnce) return false;
      return localStorage.getItem(inst.storageKeys.popupShown) === 'true';
    }

    function markShown(inst) {
      if (!inst.config.showOnce) return;
      localStorage.setItem(inst.storageKeys.popupShown, 'true');
    }

    function log(inst, msg, data) {
      if (inst.config.enableConsoleLog) {
        console.log(`[RevFlare Popup ${inst.config.sectionId}] ${msg}`, data || '');
      }
    }

    function show(inst, force = false) {
      if (!force && hasBeenShown(inst)) return;
      const overlay = inst.overlay;
      if (!overlay) return;

      overlay.style.display = 'flex';
      void overlay.offsetWidth;

      // If AB test css hide the popup (e.g. display:none !important) it remains hidden
      const cs = window.getComputedStyle(overlay);
      if (cs.display === 'none' || cs.visibility === 'hidden') {
        log(inst, 'Popup suppressed by CSS (A/B test). Skipping show.');
        overlay.style.display = 'none';
        return;
      }

      const delay = force ? 0 : (inst.config.displayDelay || 0);

      window.setTimeout(() => {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Re-check after activation in case CSS hides it when .active is applied
        const cs2 = window.getComputedStyle(overlay);
        if (cs2.display === 'none' || cs2.visibility === 'hidden') {
          log(inst, 'Popup suppressed after activation. Reverting.');
          overlay.classList.remove('active');
          overlay.style.display = 'none';

          const anyOpen = document.querySelectorAll('.rev-popup-overlay.active').length > 0;
          if (!anyOpen) document.body.style.overflow = '';
          return;
        }

        if (!force) markShown(inst);
        log(inst, 'Popup displayed', force ? '(forced)' : '');
      }, delay);
    }


    function hide(inst) {
      const overlay = inst.overlay;
      if (!overlay) return;

      overlay.classList.add('closing');
      overlay.classList.remove('active');

      window.setTimeout(() => {
        overlay.classList.remove('closing');
        overlay.style.display = 'none';

        const anyOpen = document.querySelectorAll('.rev-popup-overlay.active').length > 0;
        if (!anyOpen) document.body.style.overflow = '';
      }, 600);
    }

    function revealThresholdButtonsForKey(triggerKey) {
      const key = (triggerKey || '').trim();
      if (!key) return;

      document
        .querySelectorAll(`[data-rev-popup-open="${CSS.escape(key)}"][data-rev-popup-requires-threshold]`)
        .forEach((el) => {
          el.style.display = 'block';
        });
    }

    async function checkAndShow(inst, triggerSource) {
      log(inst, 'Checking popup conditions', { triggerSource });

      if (hasBeenShown(inst)) return;
      if (!passesFilters(inst)) return;

      if ((triggerSource === 'atc' || triggerSource === 'cart_change') && inst.config.triggerATC) {
        const { total, currency: cartCurrency } = await getCartInfo();

        let threshold = Number(inst.config.cartThreshold || 0);
        const from = inst.config.shopCurrency;
        const to = cartCurrency;

        if (from && to && from !== to) {
          threshold = await convertCentsCached(threshold, from, to);
        }

        if (total < threshold) return;
        revealThresholdButtonsForKey(inst.config.triggerKey);
      }

      show(inst, false);
    }

    function bindPerInstanceUI(inst) {
      const sectionId = inst.config.sectionId;

      const closeBtn = inst.overlay.querySelector(`#revPopupClose-${CSS.escape(sectionId)}`);
      if (closeBtn) closeBtn.addEventListener('click', () => hide(inst));

      inst.overlay.addEventListener('click', (e) => {
        if (e.target === inst.overlay) hide(inst);
      });
    }

    function registerAll() {
      document.querySelectorAll('.rev-popup-overlay[data-section-id]').forEach((overlay) => {
        const cfg = parseConfig(overlay);
        if (!cfg) return;

        const sectionId = cfg.sectionId;
        if (instances.has(sectionId)) return;

        const inst = {
          overlay,
          config: cfg,
          storageKeys: makeStorageKeys(sectionId),
          state: {
            scrollTriggered: false,
            exitIntentTriggered: false,
            timeTriggered: false
          }
        };

        instances.set(sectionId, inst);
        const key = (cfg.triggerKey || '').trim();
        if (key) {
          triggers.set(key, sectionId);
        }
        bindPerInstanceUI(inst);

        // per-instance triggers (not gloabl)
        if (cfg.triggerPageview) {
          const key = inst.storageKeys.pageviews;
          const count = (parseInt(localStorage.getItem(key) || '0', 10) || 0) + 1;
          localStorage.setItem(key, String(count));
          if (count >= (cfg.pageviewThreshold || 0)) checkAndShow(inst, 'pageview');
        }

        if (cfg.triggerTime && (cfg.timeThreshold || 0) > 0) {
          window.setTimeout(() => {
            if (inst.state.timeTriggered) return;
            inst.state.timeTriggered = true;
            checkAndShow(inst, 'time_delay');
          }, cfg.timeThreshold);
        }
      });

      // global API
      if (!window.RevFlarePopups) window.RevFlarePopups = {};
      instances.forEach((inst, sectionId) => {
        window.RevFlarePopups[sectionId] = {
          open: () => show(inst, true),
          close: () => hide(inst),
          reset: () => {
            localStorage.removeItem(inst.storageKeys.popupShown);
            inst.state.scrollTriggered = false;
            inst.state.exitIntentTriggered = false;
            inst.state.timeTriggered = false;
          },
          resetPageviews: () => localStorage.removeItem(inst.storageKeys.pageviews),
          getSectionId: () => sectionId
        };
      });

      if (!window.RevFlarePopup) {
        window.RevFlarePopup = {
          get: (sectionId) => window.RevFlarePopups?.[sectionId],
          getAll: () => window.RevFlarePopups,
          openById: (sectionId) => window.RevFlarePopups?.[sectionId]?.open?.(),
          closeAll: () => Object.values(window.RevFlarePopups || {}).forEach(p => p.close?.()),
          resetAll: () => Object.values(window.RevFlarePopups || {}).forEach(p => p.reset?.())
        };
      }
    }

    function bindGlobalListenersOnce() {
      if (globalListenersBound) return;
      globalListenersBound = true;

      document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-rev-popup-open]');
        if (!el) return;
        const key = (el.getAttribute('data-rev-popup-open') || '').trim();
        if (!key) return;
        const sectionId = triggers.get(key);
        // Allow fallback to direct sectionId passed intentionally
        const popup = window.RevFlarePopups?.[sectionId] || window.RevFlarePopups?.[key];
        popup?.open?.();
      });

      let scrollTimeout;
      window.addEventListener('scroll', () => {
        if (scrollTimeout) return;
        scrollTimeout = window.setTimeout(() => {
          const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

          instances.forEach((inst) => {
            const cfg = inst.config;

            if (cfg.triggerScrollDepth && !inst.state.scrollTriggered) {
              if (scrollPercent >= (cfg.scrollDepthThreshold || 0)) {
                inst.state.scrollTriggered = true;
                checkAndShow(inst, 'scroll_depth');
              }
            }

            if (cfg.triggerExitIntent && !inst.state.exitIntentTriggered) {
              const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
              if (isMobile) {
                inst._lastScrollY = inst._lastScrollY ?? window.scrollY;
                const last = inst._lastScrollY;
                const current = window.scrollY;
                if (last - current > 60 && current < 150) {
                  inst.state.exitIntentTriggered = true;
                  checkAndShow(inst, 'exit_intent');
                }
                inst._lastScrollY = current;
              }
            }
          });

          scrollTimeout = null;
        }, 200);
      });

      document.addEventListener('mouseout', (e) => {
        if (!(e.clientY <= 0 && e.relatedTarget === null)) return;
        instances.forEach((inst) => {
          if (inst.config.triggerExitIntent && !inst.state.exitIntentTriggered) {
            inst.state.exitIntentTriggered = true;
            checkAndShow(inst, 'exit_intent');
          }
        });
      });

      document.addEventListener('cart:updated', () => {
        instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
        refreshThresholdTriggerButtons();
      });
      document.addEventListener('product:added', () => {
        instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
        refreshThresholdTriggerButtons();
      });

      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const url = args?.[0];
        const opts = args?.[1];

        // capture variant id if this is /cart/add
        let addedVariantId = null;
        try {
          if (typeof url === 'string' && url.includes('/cart/add') && opts?.body) {
            const body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
            const id = body?.items?.[0]?.id || body?.id;
            if (id) addedVariantId = String(id);
          }
        } catch (_) { }

        return originalFetch.apply(this, args).then((res) => {
          try {
            if (typeof url === 'string' && res && res.ok) {
              const cleanUrl = url.split('?')[0];
              const isCartAdd = cleanUrl.includes('/cart/add');
              const isCartChange =
                cleanUrl.includes('/cart/change') ||
                cleanUrl.includes('/cart/update') ||
                cleanUrl.includes('/cart/clear');

              if (isCartAdd || isCartChange) {
                let isPopupATC = false;
                const isRevInternal = !!(opts?.headers && (
                  (opts.headers.get && opts.headers.get('X-REV-Internal')) ||
                  opts.headers['X-REV-Internal'] ||
                  opts.headers['x-rev-internal']
                ));

                if (isCartAdd) {
                  isPopupATC = !!(opts?.headers && (
                    (opts.headers.get && opts.headers.get('X-REV-POPUP-ATC')) ||
                    opts.headers['X-REV-POPUP-ATC'] ||
                    opts.headers['x-rev-popup-atc']
                  ));
                }

                window.setTimeout(() => {
                  if (!isRevInternal && (!isCartAdd || !isPopupATC)) {
                    instances.forEach(inst =>
                      inst.config.triggerATC &&
                      checkAndShow(inst, isCartChange ? 'cart_change' : 'atc')
                    );
                  }

                  refreshThresholdTriggerButtons();
                }, 400);
              }
            }
          } catch (_) { }
          return res;
        });

      };

      if (window.jQuery && !window.__REV_POPUP_JQ_BOUND__) {
        window.__REV_POPUP_JQ_BOUND__ = true;
        window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
          if (settings?.url && settings.url.includes('/cart/add')) {
            window.setTimeout(() => {
              instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
              refreshThresholdTriggerButtons();
            }, 500);
          }
        });
      }
    }

    function init() {
      registerAll();
      bindGlobalListenersOnce();
      refreshThresholdTriggerButtons();
      observeTriggerRerenders();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ================================
  // Scrolling Content
  // ================================
  (function () {
    const MOBILE_BREAKPOINT = 989;

    function initScroller(root) {
      if (!root || root.dataset.revInit === "1") return;

      const track = root.querySelector('[data-rev-track]');
      const viewport = root.querySelector('.rev-scroll-viewport');
      const baseGroup = root.querySelector('[data-rev-group="base"]');
      const cloneGroup = root.querySelector('[data-rev-group="clone"]');
      if (!track || !viewport || !baseGroup || !cloneGroup) return;

      root.dataset.revInit = "1";

      const maxDupes = 40;

      function clearBaseDupes() {
        baseGroup.querySelectorAll('[data-rev-item-dupe="1"]').forEach(n => n.remove());
      }

      function ensureFilled() {
        clearBaseDupes();

        const baseItems = Array.from(baseGroup.querySelectorAll('[data-rev-item]'))
          .filter(el => el.getAttribute('data-rev-item-dupe') !== '1');

        if (!baseItems.length) return;
        let i = 0;
        while (baseGroup.scrollWidth < viewport.clientWidth * 1.2 && i < maxDupes) {
          baseItems.forEach(item => {
            const dupe = item.cloneNode(true);
            dupe.setAttribute('aria-hidden', 'true');
            dupe.setAttribute('data-rev-item-dupe', '1');
            baseGroup.appendChild(dupe);
          });
          i++;
        }
        cloneGroup.innerHTML = baseGroup.innerHTML;
        cloneGroup.setAttribute('aria-hidden', 'true');
      }

      function updateDuration() {
        const loopDistance = baseGroup.scrollWidth;
        if (!loopDistance) return;

        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
        const pxPerSec = parseFloat(
          getComputedStyle(root).getPropertyValue(
            isMobile ? '--rev-speed-mob' : '--rev-speed-desk'
          )
        );

        if (!pxPerSec || pxPerSec <= 0) return;

        const duration = loopDistance / pxPerSec;
        const varName = isMobile ? '--rev-duration-mob' : '--rev-duration-desk';
        root.style.setProperty(varName, duration + 's');
      }

      function refresh() {
        ensureFilled();
        updateDuration();
      }

      refresh();

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(refresh);
        ro.observe(viewport);
      } else {
        window.addEventListener('resize', refresh);
      }

      // Recalculate when crossing the mobile/desktop breakpoint
      // (ResizeObserver on viewport may not fire if only window resizes without viewport change)
      window.addEventListener('resize', refresh);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rev-scroller]').forEach(initScroller);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  // ================================
  // Product Gallery
  // ================================
  window.RevGallery = window.RevGallery || (() => {
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

    function resetVideoInSlide(slideEl) {
      if (!slideEl) return;
      const video = slideEl.querySelector('video');
      if (!video) return;

      try { video.pause(); } catch (_) { }
      try { video.currentTime = 0; } catch (_) { }
      video.removeAttribute('controls');

      const btn = slideEl.querySelector('.rev-play');
      if (btn) {
        btn.style.display = '';
        btn.hidden = false;
      }
    }

    function setActiveUI({ thumbs, bullets, counterEl, totalSlides, index }) {
      if (thumbs?.length) {
        thumbs.forEach(t => t.classList.toggle('is-active', Number(t.dataset.index) === index));
      }
      if (bullets?.length) {
        bullets.forEach(b => b.classList.toggle('rev-gallery-slide-bullet-active', Number(b.dataset.index) === index));
        setNextBulletUI({ bullets, index });
      }
      if (counterEl) {
        counterEl.textContent = `${index + 1} / ${totalSlides}`;
      }
    }

    function nearestIndexByScrollLeft(main, slides) {
      const x = main.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      for (let i = 0; i < slides.length; i++) {
        const d = Math.abs(slides[i].offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function applyThumbsHeightAndReveal(root) {
      const thumbsWrap = root.querySelector('.rev-gallery-thumbnails');
      if (!thumbsWrap) return;
      if (!isDesktop()) {
        thumbsWrap.classList.remove('is-ready');
        thumbsWrap.style.removeProperty('--rev-thumbs-h');
        return;
      }

      // Bottom thumbnails: no height matching needed, just reveal
      const isBottom = root.classList.contains('rev-thumbnails-bottom');
      if (isBottom) {
        if (!thumbsWrap.classList.contains('is-ready')) {
          requestAnimationFrame(() => thumbsWrap.classList.add('is-ready'));
        }
        return;
      }

      const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
      if (!mainViewport) return;

      const h = Math.round(mainViewport.getBoundingClientRect().height);
      if (!h || h < 60) return;

      const prev = parseInt(getComputedStyle(thumbsWrap).getPropertyValue('--rev-thumbs-h')) || 0;
      if (prev && Math.abs(prev - h) < 6) {
        if (!thumbsWrap.classList.contains('is-ready')) {
          requestAnimationFrame(() => thumbsWrap.classList.add('is-ready'));
        }
        return;
      }

      thumbsWrap.style.setProperty('--rev-thumbs-h', `${h}px`);

      if (!thumbsWrap.classList.contains('is-ready')) {
        requestAnimationFrame(() => thumbsWrap.classList.add('is-ready'));
      }
    }

    function scrollThumbToIndex({ thumbsWrap, thumbByIndex, index, behavior = 'smooth' }) {
      if (!thumbsWrap) return;
      const el = thumbByIndex.get(index);
      if (!el) return;

      // Detect horizontal (bottom) vs vertical (left) layout
      const isHorizontal = thumbsWrap.closest('.rev-thumbnails-bottom') !== null;

      if (isHorizontal) {
        const wrapW = thumbsWrap.clientWidth;
        if (!wrapW) return;
        const elLeft = el.offsetLeft;
        const elW = el.offsetWidth || 0;
        const target = elLeft - (wrapW * 0.45) + (elW / 2);
        const maxScroll = thumbsWrap.scrollWidth - wrapW;
        const nextLeft = clamp(target, 0, Math.max(0, maxScroll));
        if (Math.abs(thumbsWrap.scrollLeft - nextLeft) < 2) return;
        thumbsWrap.scrollTo({ left: nextLeft, behavior });
      } else {
        const wrapH = thumbsWrap.clientHeight;
        if (!wrapH) return;
        const elTop = el.offsetTop;
        const elH = el.offsetHeight || 0;
        const target = elTop - (wrapH * 0.45) + (elH / 2);
        const maxScroll = thumbsWrap.scrollHeight - wrapH;
        const nextTop = clamp(target, 0, Math.max(0, maxScroll));
        if (Math.abs(thumbsWrap.scrollTop - nextTop) < 2) return;
        thumbsWrap.scrollTo({ top: nextTop, behavior });
      }
    }

    function setNextBulletUI({ bullets, index }) {
      if (!bullets?.length) return;
      bullets.forEach(b => b.classList.remove('rev-bullet-next'));
      const nextIndex = (index + 1) % bullets.length;
      const nextBullet = bullets.find(b => Number(b.dataset.index) === nextIndex) || bullets[0];

      if (nextBullet) nextBullet.classList.add('rev-bullet-next');
    }

    function init(root) {
      if (!root) return;
      if (root.dataset.revGalleryInit === '1') return;

      const main = root.querySelector('[data-rev-main]');
      const track = root.querySelector('[data-rev-track-main]');
      if (!main || !track) return;

      const slides = Array.from(track.querySelectorAll('.rev-media[data-index]'));
      if (!slides.length) return;

      const thumbsWrap = root.querySelector('.rev-gallery-thumbnails');
      const thumbs = Array.from(root.querySelectorAll('.rev-gallery-thumbnail-item[data-index]'));
      const bullets = Array.from(root.querySelectorAll('.rev-gallery-slide-bullet[data-index]'));
      const counterEl = root.querySelector('[data-rev-gallery-counter]');
      const btnPrev = root.querySelector('.rev-gallery-button-prev');
      const btnNext = root.querySelector('.rev-gallery-button-next');

      const thumbByIndex = new Map();
      thumbs.forEach(t => thumbByIndex.set(Number(t.dataset.index), t));

      root.dataset.revGalleryInit = '1';
      root._revGalleryInstance = { setActive, scrollToIndex };

      let index = 0;
      let prevIndex = 0;

      let isProgrammaticScroll = false;
      let progTimer = null;

      function lockProgrammaticScroll(ms = 350) {
        isProgrammaticScroll = true;
        window.clearTimeout(progTimer);
        progTimer = window.setTimeout(() => { isProgrammaticScroll = false; }, ms);
      }

      function setActive(i, { thumbBehavior = 'smooth' } = {}) {
        prevIndex = index;
        index = clamp(i, 0, slides.length - 1);

        if (prevIndex !== index) resetVideoInSlide(slides[prevIndex]);

        setActiveUI({ thumbs, bullets, counterEl, totalSlides: slides.length, index });

        if (thumbsWrap && thumbs.length && isDesktop() && thumbsWrap.classList.contains('is-ready')) {
          scrollThumbToIndex({ thumbsWrap, thumbByIndex, index, behavior: thumbBehavior });
        }

        if (typeof startAutoswipe === 'function') {
          startAutoswipe();
        }
      }

      function scrollToIndex(i, behavior = 'smooth') {
        const next = clamp(i, 0, slides.length - 1);
        const target = slides[next];
        if (!target) return;
        lockProgrammaticScroll(behavior === 'smooth' ? 450 : 50);
        main.scrollTo({ left: target.offsetLeft, behavior });
        setActive(next, { thumbBehavior: 'auto' });
      }

      // ================================
      // AUTOSWIPE
      // ================================
      const autoplayRaw = root.getAttribute('data-autoplay');
      const autoswipeEnabled = autoplayRaw != null;
      const autoswipeSeconds = autoswipeEnabled
        ? clamp(parseInt(autoplayRaw, 10) || 0, 2, 14)
        : 0;

      const isSliderMode = () =>
        isDesktop() ? root.classList.contains('rev-product-gallery-slider') : true;

      let autoTimer = null;
      let autoRaf = null;
      let autoStartTs = 0;
      let autoPaused = false;

      function setProgress(p) {
        const clamped = Math.min(1, Math.max(0, p));
        root.style.setProperty('--rev-autoswipe-progress', clamped);
      }

      function clearAutoswipe() {
        clearTimeout(autoTimer);
        cancelAnimationFrame(autoRaf);
        autoTimer = null;
        autoRaf = null;
        setProgress(0);
      }

      function pauseAutoswipe(delay = 2500) {
        if (!autoswipeEnabled) return;
        autoPaused = true;
        root.classList.remove('is-autoswiping');
        clearAutoswipe();

        setTimeout(() => {
          autoPaused = false;
          startAutoswipe();
        }, delay);
      }

      function waitForVideo(slide) {
        return new Promise(resolve => {
          const video = slide?.querySelector('video');
          if (!video) return resolve();
          if (video.paused || video.ended) return resolve();

          const done = () => {
            video.removeEventListener('ended', done);
            video.removeEventListener('pause', done);
            resolve();
          };

          video.addEventListener('ended', done, { once: true });
          video.addEventListener('pause', done, { once: true });
        });
      }

      function tickProgress() {
        const elapsed = performance.now() - autoStartTs;
        setProgress(elapsed / (autoswipeSeconds * 1000));
        autoRaf = requestAnimationFrame(tickProgress);
      }

      async function advanceSlide() {
        await waitForVideo(slides[index]);
        if (autoPaused) return;

        scrollToIndex((index + 1) % slides.length, 'smooth');
        startAutoswipe();
      }

      function startAutoswipe() {
        if (
          !autoswipeEnabled ||
          !isSliderMode() ||
          autoPaused ||
          slides.length < 2 ||
          document.hidden
        ) {
          clearAutoswipe();
          root.classList.remove('is-autoswiping');
          return;
        }

        clearAutoswipe();
        root.classList.add('is-autoswiping');

        autoStartTs = performance.now();
        autoRaf = requestAnimationFrame(tickProgress);
        autoTimer = setTimeout(advanceSlide, autoswipeSeconds * 1000);
      }

      if (autoswipeEnabled) {
        // Pause on user intent
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(evt => {
          root.addEventListener(evt, () => pauseAutoswipe(), { passive: true });
        });

        // Pause on navigation buttons
        [btnPrev, btnNext].forEach(btn => {
          btn && btn.addEventListener('click', () => pauseAutoswipe());
        });

        bullets.forEach(b => b.addEventListener('click', () => pauseAutoswipe()));
        thumbs.forEach(t => t.addEventListener('click', () => pauseAutoswipe()));

        document.addEventListener('visibilitychange', () => {
          document.hidden ? clearAutoswipe() : startAutoswipe();
        });

        window.addEventListener('resize', () => {
          clearTimeout(root._revAutoswipeResizeT);
          root._revAutoswipeResizeT = setTimeout(startAutoswipe, 150);
        });
      }

      if (autoswipeEnabled) {
        startAutoswipe();
      }

      thumbs.forEach(t => {
        t.addEventListener('click', () => scrollToIndex(Number(t.dataset.index), 'smooth'));
      });
      bullets.forEach(b => {
        b.addEventListener('click', () => scrollToIndex(Number(b.dataset.index), 'smooth'));
      });
      if (btnPrev) btnPrev.addEventListener('click', () => scrollToIndex(index - 1, 'smooth'));
      if (btnNext) btnNext.addEventListener('click', () => scrollToIndex(index + 1, 'smooth'));

      let raf = null;
      main.addEventListener('scroll', () => {
        if (isProgrammaticScroll) return;
        if (raf) return;

        raf = requestAnimationFrame(() => {
          raf = null;
          const best = nearestIndexByScrollLeft(main, slides);
          setActive(best, { thumbBehavior: 'smooth' });
        });
      }, { passive: true });

      const scheduleReveal = () => requestAnimationFrame(() => applyThumbsHeightAndReveal(root));

      if (thumbsWrap && isDesktop()) {
        thumbsWrap.classList.remove('is-ready');
        thumbsWrap.style.setProperty('--rev-thumbs-h', '0px');
      }

      scheduleReveal();
      window.setTimeout(scheduleReveal, 30);
      window.setTimeout(scheduleReveal, 120);
      window.setTimeout(scheduleReveal, 250);

      root.querySelectorAll('.rev-gallery-main img').forEach(img => {
        if (img.complete) return;
        img.addEventListener('load', scheduleReveal, { once: true });
        img.addEventListener('error', scheduleReveal, { once: true });
      });

      root.querySelectorAll('.rev-gallery-main video').forEach(v => {
        if (v.readyState >= 1) return;
        v.addEventListener('loadedmetadata', scheduleReveal, { once: true });
        v.addEventListener('loadeddata', scheduleReveal, { once: true });
      });

      if ('ResizeObserver' in window) {
        const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
        if (mainViewport) {
          const ro = new ResizeObserver(() => scheduleReveal());
          ro.observe(mainViewport);
        }
      } else {
        window.addEventListener('resize', scheduleReveal);
      }

      setActive(0, { thumbBehavior: 'auto' });
      requestAnimationFrame(() => {
        scrollToIndex(0, 'auto');
        scheduleReveal();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.rev-product-gallery').forEach(init);
    }

    function destroy(root) {
      if (!root) return;
      root.dataset.revGalleryInit = '0';
    }

    return { init, initAll, destroy };
  })();

  (function () {
    function boot(scope) {
      window.RevGallery?.initAll(scope || document);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);

    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  // Trigger Rerender On Variant Change
  document.addEventListener('rev:variant:change', async (e) => {
    const variantId = e.detail?.variantId;
    if (!variantId) return;

    await RevRerender.rerender({
      contextEl: document,
      targets: ['.rev-product-gallery'],
      url: window.location.pathname,
      params: { variant: variantId },
      incomingScopeSelector: 'main'
    });

    window.RevGallery?.initAll(document);
  });

  // ================================
  // Gallery Zoom Desktop
  // ================================
  window.RevGalleryZoom = window.RevGalleryZoom || (() => {
    const MAGNIFICATION = 2.5;
    const OVERLAY_SIZE = 40; // percentage of image
    const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

    function syncPreviewAspectToImage(img, zoomPreview) {
      if (!img || !zoomPreview) return;

      const imgRect = img.getBoundingClientRect();
      if (!imgRect.width || !imgRect.height) return;

      const aspect = imgRect.width / imgRect.height;
      const previewRect = zoomPreview.getBoundingClientRect();
      if (!previewRect.width) return;
      const desiredHeight = Math.round(previewRect.width / aspect);

      zoomPreview.style.setProperty(
        '--rev-zoom-preview-h',
        `${desiredHeight}px`
      );
    }

    function init(root) {
      if (!root || !isDesktop()) return;

      const galleryRoot = root.querySelector('.rev-product-gallery');
      if (!galleryRoot || galleryRoot.dataset.revZoomInit === '1') return;

      const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
      const track = root.querySelector('[data-rev-track-main]');
      const zoomPreview = root.querySelector('.rev-gallery-zoom-preview');
      const zoomOverlay = root.querySelector('.rev-gallery-zoom-overlay');
      const zoomBox = root.querySelector('.rev-gallery-zoom-box');

      if (!mainViewport || !track || !zoomPreview || !zoomOverlay || !zoomBox) return;

      galleryRoot.dataset.revZoomInit = '1';

      const slides = Array.from(track.querySelectorAll('.rev-media[data-index]'));
      if (!slides.length) return;

      // Cache interactive control references for zoom deadzones
      const carouselControls = root.querySelector('.rev-gallery-carousel-controls');
      const zoomButton = root.querySelector('.rev-gallery-button-zoom');
      const linesIndicator = root.querySelector('.rev-gallery-slide-indicator-lines');
      const DEADZONE_PX = 40;

      function isNearControl(el, ev) {
        if (!el || el.offsetParent === null) return false;
        const r = el.getBoundingClientRect();
        return (
          ev.clientX >= r.left - DEADZONE_PX &&
          ev.clientX <= r.right + DEADZONE_PX &&
          ev.clientY >= r.top - DEADZONE_PX &&
          ev.clientY <= r.bottom + DEADZONE_PX
        );
      }

      function getVisibleImage() {
        let bestIndex = 0;
        let bestDist = Infinity;

        for (let i = 0; i < slides.length; i++) {
          const dist = Math.abs(slides[i].offsetLeft - mainViewport.scrollLeft);
          if (dist < bestDist) {
            bestDist = dist;
            bestIndex = i;
          }
        }

        const visibleSlide = slides[bestIndex];
        if (!visibleSlide) return null;

        const img = visibleSlide.querySelector('img');
        const video = visibleSlide.querySelector('video');
        return img || video;
      }

      function getImageUrl(img) {
        if (!img) return null;
        return img.src || img.currentSrc || null;
      }

      mainViewport.addEventListener('mousemove', (e) => {
        // Suppress zoom when mouse is near interactive controls
        if (isNearControl(carouselControls, e) || isNearControl(zoomButton, e) || isNearControl(linesIndicator, e)) {
          zoomPreview.style.display = 'none';
          zoomOverlay.style.display = 'none';
          return;
        }

        const img = getVisibleImage();
        if (!img) return;

        const imgUrl = getImageUrl(img);
        if (!imgUrl) return;

        syncPreviewAspectToImage(img, zoomPreview);
        const imgRect = img.getBoundingClientRect();
        if (
          e.clientX < imgRect.left || e.clientX > imgRect.right ||
          e.clientY < imgRect.top || e.clientY > imgRect.bottom
        ) {
          zoomPreview.style.display = 'none';
          zoomOverlay.style.display = 'none';
          return;
        }

        const x = e.clientX - imgRect.left;
        const y = e.clientY - imgRect.top;
        const xPercent = (x / imgRect.width) * 100;
        const yPercent = (y / imgRect.height) * 100;
        const overlayLeft = Math.max(
          0,
          Math.min(100 - OVERLAY_SIZE, xPercent - OVERLAY_SIZE / 2)
        );
        const overlayTop = Math.max(
          0,
          Math.min(100 - OVERLAY_SIZE, yPercent - OVERLAY_SIZE / 2)
        );

        zoomPreview.style.display = 'block';
        zoomOverlay.style.display = 'block';

        zoomOverlay.style.left = overlayLeft + '%';
        zoomOverlay.style.top = overlayTop + '%';
        zoomOverlay.style.width = OVERLAY_SIZE + '%';
        zoomOverlay.style.height = OVERLAY_SIZE + '%';

        const magnification = 100 / OVERLAY_SIZE;

        const bgX = (overlayLeft / (100 - OVERLAY_SIZE)) * 100;
        const bgY = (overlayTop / (100 - OVERLAY_SIZE)) * 100;

        zoomBox.style.backgroundImage = `url('${imgUrl}')`;
        zoomBox.style.backgroundSize = `${magnification * 100}% ${magnification * 100}%`;
        zoomBox.style.backgroundPosition = `${bgX}% ${bgY}%`;
      });

      mainViewport.addEventListener('mouseleave', () => {
        zoomPreview.style.display = 'none';
        zoomOverlay.style.display = 'none';
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.rev-product-gallery').forEach(gallery => {
        const wrapper = gallery.closest('.rev-product-gallery-wrapper') || gallery.closest('[data-section-id]') || gallery.parentElement;
        if (wrapper) init(wrapper);
      });
    }

    return { init, initAll };
  })();

  (function () {
    function boot(scope) {
      window.RevGalleryZoom?.initAll(scope || document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  // ================================
  // Gallery Zoom Modal Scroll Lock
  // ================================
  (function () {
    function initScrollLock() {
      const zoomModals = document.querySelectorAll('.rev-gallery-zoom-modal');

      zoomModals.forEach(modal => {
        if (modal.dataset.scrollLockInit === '1') return;
        modal.dataset.scrollLockInit = '1';

        let scrollY = 0;

        // When popover opens
        modal.addEventListener('toggle', (e) => {
          if (e.newState === 'open') {
            // Store current scroll position
            scrollY = window.scrollY;

            // Lock body scroll
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';

            // Ensure modal content can scroll
            const content = modal.querySelector('.rev-gallery-zoom-content');
            if (content) {
              content.style.overflowY = 'auto';
              content.style.webkitOverflowScrolling = 'touch';
              content.style.overscrollBehavior = 'contain';
            }
          } else if (e.newState === 'closed') {
            // Restore body scroll
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // Restore scroll position
            window.scrollTo(0, scrollY);
          }
        });

        // Prevent touch events from bubbling to body when touching modal content
        const content = modal.querySelector('.rev-gallery-zoom-content');
        if (content) {
          let startY = 0;

          content.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY;
          }, { passive: true });

          content.addEventListener('touchmove', (e) => {
            const currentY = e.touches[0].clientY;
            const isScrollingUp = currentY > startY;
            const isScrollingDown = currentY < startY;
            const isAtTop = content.scrollTop === 0;
            const isAtBottom = content.scrollHeight - content.scrollTop === content.clientHeight;

            // Only prevent default if we're at scroll boundaries
            // This prevents the bounce/overscroll from affecting the body
            if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
              e.preventDefault();
            }
          }, { passive: false });
        }
      });
    }

    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollLock);
    } else {
      initScrollLock();
    }

    // Re-initialize when sections are loaded
    document.addEventListener('shopify:section:load', initScrollLock);
  })();

  // ================================
  // Mini Slider
  // ================================
  window.RevMiniSlider = window.RevMiniSlider || (() => {
    const instances = new WeakMap();

    function setActiveBullet(bullets, index) {
      bullets.forEach((b, i) => b.classList.toggle('active', i === index));
    }

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function init(root) {
      if (!root) return;
      if (instances.has(root)) return;

      const track = root.querySelector('[data-rev-mini-slider-track]');
      const pagination = root.querySelector('[data-rev-mini-slider-pagination]');
      if (!track || !pagination) return;

      const slides = Array.from(track.children).filter(el => el.classList.contains('rev-mini-slide'));
      const bullets = Array.from(pagination.querySelectorAll('[data-rev-mini-slider-bullet]'));

      const total = slides.length;

      const inst = { stop: () => { }, start: () => { }, goTo: () => { } };
      instances.set(root, inst);

      if (total <= 1) {
        if (bullets.length) setActiveBullet(bullets, 0);
        return;
      }

      const speedSecRaw = track.dataset.revMiniSliderSpeed;
      const speedSec = clamp(Number(speedSecRaw) || 2.5, 0.5, 60);
      const intervalMs = Math.round(speedSec * 1000);

      let index = 0;
      let timer = null;

      function goTo(i, { behavior = 'smooth' } = {}) {
        index = (i + total) % total;
        track.scrollTo({ left: track.clientWidth * index, behavior });

        if (bullets.length) setActiveBullet(bullets, index);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        timer = window.setInterval(() => goTo(index + 1, { behavior: 'smooth' }), intervalMs);
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      bullets.forEach((b, i) => {
        b.addEventListener('click', () => {
          goTo(i, { behavior: 'smooth' });
          start();
        });
      });

      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;

          const w = track.clientWidth || 1;
          const next = clamp(Math.round(track.scrollLeft / w), 0, total - 1);

          if (next !== index) {
            index = next;
            if (bullets.length) setActiveBullet(bullets, index);
          }
        });
      }, { passive: true });

      inst.stop = stop;
      inst.start = start;
      inst.goTo = goTo;

      if (bullets.length) setActiveBullet(bullets, 0);
      goTo(0, { behavior: 'auto' });
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rev-mini-slider]').forEach(init);
    }

    function destroy(root) {
      const inst = instances.get(root);
      if (!inst) return;
      try { inst.stop?.(); } catch (_) { }
      instances.delete(root);
    }

    return { init, initAll, destroy };
  })();

  (function () {
    function boot(scope) {
      window.RevMiniSlider?.initAll(scope || document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  // ================================
  // Popularity Messaging
  // ================================
  (function () {
    if (window.__REV_POPULARITY__) return;
    window.__REV_POPULARITY__ = true;

    const inited = new Set();

    function clampInt(n, fallback) {
      const x = parseInt(n, 10);
      return Number.isFinite(x) ? x : fallback;
    }

    function randInt(min, max) {
      const a = Math.min(min, max);
      const b = Math.max(min, max);
      return Math.floor(Math.random() * (b - a + 1)) + a;
    }

    function initOne(el) {
      if (!el) return;

      const id = el.getAttribute('data-rev-pop-id') || '';

      if (id && inited.has(id)) return;
      if (id) inited.add(id);

      const min = clampInt(el.dataset.revPopMin, 20);
      const max = clampInt(el.dataset.revPopMax, 50);

      const numEl = el.querySelector('[data-rev-pop-number]');
      if (numEl) numEl.textContent = randInt(min, max);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rev-pop]').forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  // ================================
  // RevTimer (Universal, Lean, Configurable)
  // - Supports multiple timers per page (instance-scoped)
  // - Safe with Shopify section re-renders + DOM injections
  // - Modes: fixed end OR evergreen duration (localStorage)
  // - Formats: mmss | dhms | auto
  // - Hide controls (schema-friendly CSV):
  //    data-rev-timer-hide="days,hours"        -> always hide these units
  //    data-rev-timer-hide-zero="days,hours"   -> hide these units when value is 0
  //    data-rev-timer-collapse="true"          -> hide leading zero units (days->hours->mins)
  // ================================
  window.RevTimer = window.RevTimer || (() => {
    const instances = new WeakMap();

    const pad2 = (n) => String(n).padStart(2, '0');

    function getVisitorTimeZone() {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
      } catch (_) {
        return 'UTC';
      }
    }

    function getZonedParts(date, timeZone) {
      const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const parts = dtf.formatToParts(date);
      const out = {};
      for (const p of parts) {
        if (p.type === 'year') out.year = Number(p.value);
        if (p.type === 'month') out.month = Number(p.value);
        if (p.type === 'day') out.day = Number(p.value);
        if (p.type === 'hour') out.hour = Number(p.value);
        if (p.type === 'minute') out.minute = Number(p.value);
        if (p.type === 'second') out.second = Number(p.value);
      }
      return out;
    }

    // Convert "YYYY-MM-DD" + "HH:MM:SS" interpreted in `timeZone` into UTC ms.
    // Handles DST by refining the offset once.
    function zonedWallTimeToUtcMs({ year, month, day, hour, minute, second }, timeZone) {
      // initial guess: treat wall time as UTC
      let guess = Date.UTC(year, month - 1, day, hour, minute, second);

      // find offset between guessed instant and desired zone wall time
      const p1 = getZonedParts(new Date(guess), timeZone);
      const asUtc1 = Date.UTC(p1.year, p1.month - 1, p1.day, p1.hour, p1.minute, p1.second);
      const offset1 = asUtc1 - guess;

      let corrected = Date.UTC(year, month - 1, day, hour, minute, second) - offset1;

      // refine once more for DST boundaries
      const p2 = getZonedParts(new Date(corrected), timeZone);
      const asUtc2 = Date.UTC(p2.year, p2.month - 1, p2.day, p2.hour, p2.minute, p2.second);
      const offset2 = asUtc2 - corrected;

      corrected = Date.UTC(year, month - 1, day, hour, minute, second) - offset2;
      return corrected;
    }

    function parseDateTimeFields(el) {
      const d = (el.getAttribute('data-rev-timer-end-date') || '').trim(); // YYYY-MM-DD
      const t = (el.getAttribute('data-rev-timer-end-time') || '').trim(); // HH:MM:SS
      if (!d || !t) return null;

      const mD = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const mT = t.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!mD || !mT) return null;

      return {
        year: Number(mD[1]),
        month: Number(mD[2]),
        day: Number(mD[3]),
        hour: Number(mT[1]),
        minute: Number(mT[2]),
        second: Number(mT[3] || '0')
      };
    }

    function boolAttr(el, name, fallback = false) {
      const v = el.getAttribute(name);
      if (v == null) return fallback;
      return v === '' || v === 'true' || v === '1';
    }

    function parseCsvSet(el, name) {
      const raw = (el.getAttribute(name) || '').trim().toLowerCase();
      if (!raw) return new Set();
      return new Set(
        raw.split(',')
          .map(s => s.trim())
          .filter(Boolean)
      );
    }

    function parseEndMs(el) {
      // 1) Preferred: date + time + tz
      const fields = parseDateTimeFields(el);
      if (fields) {
        let tz = (el.getAttribute('data-rev-timer-tz') || '').trim();
        if (!tz) tz = 'UTC';
        if (tz === 'visitor') tz = getVisitorTimeZone();

        try {
          return zonedWallTimeToUtcMs(fields, tz);
        } catch (_) {
          // fall back to ISO parsing below
        }
      }

      // 2) Back-compat: ISO / epoch ms in data-rev-timer-end
      const raw = (el.getAttribute('data-rev-timer-end') || '').trim();
      if (!raw) return null;
      if (/^\d{10,}$/.test(raw)) return Number(raw); // epoch ms
      const t = Date.parse(raw);
      return Number.isFinite(t) ? t : null;
    }

    function getEvergreenEndMs(el) {
      const durSec = parseInt(el.getAttribute('data-rev-timer-duration') || '', 10);
      if (!durSec) return null;

      const key = (el.getAttribute('data-rev-timer-key') || '').trim() || el.id || null;

      // No key => works for this page load only (no persistence)
      if (!key) return Date.now() + (durSec * 1000);

      const storageKey = `revTimer_${key}`;
      let end = parseInt(localStorage.getItem(storageKey) || '', 10);

      if (!end || end < Date.now()) {
        end = Date.now() + (durSec * 1000);
        try { localStorage.setItem(storageKey, String(end)); } catch (_) { }
      }

      return end;
    }

    function split(msLeft) {
      const total = Math.max(0, Math.floor(msLeft / 1000));
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const mins = Math.floor((total % 3600) / 60);
      const secs = total % 60;
      return { total, days, hours, mins, secs };
    }

    function formatMmss(parts, pad) {
      const minutesTotal = Math.floor(parts.total / 60); // rolls up days/hours into minutes
      const mm = pad ? pad2(minutesTotal) : String(minutesTotal);
      const ss = pad ? pad2(parts.secs) : String(parts.secs);
      return `${mm}:${ss}`;
    }

    // Single-string DHMS formatter that respects hide/hide-zero/collapse.
    // Guarantees something sensible is shown even if some units are hidden.
    function formatDhms(parts, pad, cfg) {
      const hardHide = cfg.hideSet;
      const hideZero = cfg.hideZeroSet;
      const collapse = cfg.collapse;

      const unitVals = {
        days: parts.days,
        hours: parts.hours,
        mins: parts.mins,
        secs: parts.secs
      };

      function shouldHide(unit) {
        if (hardHide.has(unit)) return true;
        if (hideZero.has(unit) && unitVals[unit] === 0) return true;

        if (collapse) {
          if (unit === 'days') return unitVals.days === 0;
          if (unit === 'hours') return unitVals.days === 0 && unitVals.hours === 0;
          if (unit === 'mins') return unitVals.days === 0 && unitVals.hours === 0 && unitVals.mins === 0;
          // secs never collapsed by default
        }

        return false;
      }

      const d = shouldHide('days') ? null : `${unitVals.days}d`;
      const h = shouldHide('hours') ? null : `${pad ? pad2(unitVals.hours) : unitVals.hours}h`;
      const m = shouldHide('mins') ? null : `${pad ? pad2(unitVals.mins) : unitVals.mins}m`;
      const s = shouldHide('secs') ? null : `${pad ? pad2(unitVals.secs) : unitVals.secs}s`;

      // Ensure at least one unit shows
      const partsOut = [d, h, m, s].filter(Boolean);
      if (partsOut.length) return partsOut.join(' ');

      // If everything got hidden, fall back to MM:SS style seconds
      const mm = pad ? pad2(Math.floor(parts.total / 60)) : String(Math.floor(parts.total / 60));
      const ss = pad ? pad2(parts.secs) : String(parts.secs);
      return `${mm}:${ss}`;
    }

    function applySplitVisibility(root, parts, cfg, formatMode) {
      // Optional wrappers for clean hiding:
      // <span data-rev-timer-unit="days">...</span>
      const wrap = (unit) => root.querySelector(`[data-rev-timer-unit="${unit}"]`);

      const wDays = wrap('days');
      const wHours = wrap('hours');
      const wMins = wrap('mins');
      const wSecs = wrap('secs');

      const hardHide = cfg.hideSet;
      const hideZero = cfg.hideZeroSet;
      const collapse = cfg.collapse;

      // In mmss mode, days/hours are almost always unwanted; recommend leaving them out of markup.
      // But if they exist, we’ll still honor rules.
      const val = {
        days: parts.days,
        hours: parts.hours,
        mins: parts.mins,
        secs: parts.secs
      };

      function shouldHide(unit) {
        if (hardHide.has(unit)) return true;

        // per-unit hide-when-zero (independent; can look odd if you hide hours while days show)
        if (hideZero.has(unit) && val[unit] === 0) return true;

        if (collapse) {
          if (unit === 'days') return val.days === 0;
          if (unit === 'hours') return val.days === 0 && val.hours === 0;
          if (unit === 'mins') return val.days === 0 && val.hours === 0 && val.mins === 0;
        }

        // extra: if format is mmss, hide day/hour wrappers unless user explicitly keeps them
        if (formatMode === 'mmss' && (unit === 'days' || unit === 'hours')) {
          return true;
        }

        return false;
      }

      if (wDays) wDays.style.display = shouldHide('days') ? 'none' : '';
      if (wHours) wHours.style.display = shouldHide('hours') ? 'none' : '';
      if (wMins) wMins.style.display = shouldHide('mins') ? 'none' : '';
      if (wSecs) wSecs.style.display = shouldHide('secs') ? 'none' : '';
    }

    function initOne(el) {
      if (!el || el.nodeType !== 1) return;
      if (instances.has(el)) return;
      const shouldSync = boolAttr(el, 'data-rev-timer-sync', false);
      if (shouldSync) {
        const primaryTimer = Array.from(document.querySelectorAll('[data-rev-timer]'))
          .find(timer => timer !== el && !boolAttr(timer, 'data-rev-timer-sync', false));
        if (primaryTimer && instances.has(primaryTimer)) {
          const primaryData = instances.get(primaryTimer);
          const attrsToCopy = [
            'data-rev-timer-end-date',
            'data-rev-timer-end-time',
            'data-rev-timer-tz',
            'data-rev-timer-duration',
            'data-rev-timer-key',
            'data-rev-timer-format',
            'data-rev-timer-pad',
            'data-rev-timer-collapse',
            'data-rev-timer-hide',
            'data-rev-timer-hide-zero'
          ];
          attrsToCopy.forEach(attr => {
            const val = primaryTimer.getAttribute(attr);
            if (val !== null) {
              el.setAttribute(attr, val);
            }
          });
          if (primaryData.endMs) {
            el._syncedEndMs = primaryData.endMs;
          }
        }
      }
      const out = el.querySelector('[data-rev-timer-out]');
      const ddEl = el.querySelector('[data-rev-timer-dd]');
      const hhEl = el.querySelector('[data-rev-timer-hh]');
      const mmEl = el.querySelector('[data-rev-timer-mm]');
      const ssEl = el.querySelector('[data-rev-timer-ss]');
      const hasSplit = !!(ddEl || hhEl || mmEl || ssEl);
      const formatMode = (el.getAttribute('data-rev-timer-format') || 'auto').trim().toLowerCase();
      const pad = boolAttr(el, 'data-rev-timer-pad', true);
      const cfg = {
        collapse: boolAttr(el, 'data-rev-timer-collapse', false),
        hideSet: parseCsvSet(el, 'data-rev-timer-hide'),
        hideZeroSet: parseCsvSet(el, 'data-rev-timer-hide-zero'),
        expiredText: (el.getAttribute('data-rev-timer-expired-text') || 'Expired').trim(),
        hideExpired: boolAttr(el, 'data-rev-timer-hide-expired', false),
      };
      let endMs = el._syncedEndMs || parseEndMs(el);
      if (!endMs) endMs = getEvergreenEndMs(el);
      if (!endMs) return;
      let lastSec = null;
      function stop() {
        clearInterval(id);
      }
      function render(parts) {
        // Split-field mode
        if (hasSplit) {
          if (formatMode === 'mmss') {
            const minutesTotal = Math.floor(parts.total / 60);
            if (mmEl) mmEl.textContent = pad ? pad2(minutesTotal) : String(minutesTotal);
            if (ssEl) ssEl.textContent = pad ? pad2(parts.secs) : String(parts.secs);
            if (ddEl) ddEl.textContent = String(parts.days);
            if (hhEl) hhEl.textContent = pad ? pad2(parts.hours) : String(parts.hours);
            applySplitVisibility(el, parts, cfg, 'mmss');
            return;
          }
          if (ddEl) ddEl.textContent = String(parts.days);
          if (hhEl) hhEl.textContent = pad ? pad2(parts.hours) : String(parts.hours);
          if (mmEl) mmEl.textContent = pad ? pad2(parts.mins) : String(parts.mins);
          if (ssEl) ssEl.textContent = pad ? pad2(parts.secs) : String(parts.secs);
          applySplitVisibility(el, parts, cfg, formatMode);
          return;
        }
        // Single output
        if (out) {
          if (formatMode === 'mmss') out.textContent = formatMmss(parts, pad);
          else if (formatMode === 'dhms') out.textContent = formatDhms(parts, pad, cfg);
          else out.textContent = formatDhms(parts, pad, cfg);
        }
      }
      function tick() {
        if (!document.contains(el)) return stop();
        const msLeft = endMs - Date.now();
        if (msLeft <= 0) {
          if (cfg.hideExpired) el.style.display = 'none';
          else {
            if (out) out.textContent = cfg.expiredText;
          }
          el.dispatchEvent(new CustomEvent('rev:timer:expired', { bubbles: true }));
          return stop();
        }
        const parts = split(msLeft);
        const sec = parts.total;
        if (sec === lastSec) return;
        lastSec = sec;
        render(parts);
      }
      const id = setInterval(tick, 250);
      instances.set(el, { stop, endMs }); // NEW: Store endMs for syncing
      tick();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rev-timer]').forEach(initOne);
    }

    function boot() {
      initAll(document);

      document.addEventListener('shopify:section:load', (e) => initAll(e.target));

      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          for (const n of m.addedNodes || []) {
            if (n.nodeType !== 1) continue;
            if (n.matches?.('[data-rev-timer]')) initOne(n);
            n.querySelectorAll?.('[data-rev-timer]').forEach(initOne);
          }
        }
      });

      mo.observe(document.body, { childList: true, subtree: true });
      window.__REV_TIMER_OBSERVER__ = mo; // optional debug
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    return { initAll };
  })();

  // ================================
  // Card Slider
  // ================================
  const RevCardSlider = {
    init() {
      document.querySelectorAll('[data-rev-card-slider-container]:not([data-rev-card-slider-init])').forEach(container => {
        this.setupSlider(container);
        container.setAttribute('data-rev-card-slider-init', 'true');
      });
    },
    setupSlider(container) {
      const wrap = container.querySelector('[data-rev-card-slider]');
      const track = container.querySelector('[data-rev-card-slider-track]');
      const prevBtn = container.querySelector('.rev-card-slider-prev');
      const nextBtn = container.querySelector('.rev-card-slider-next');
      const arrowsContainer = container.querySelector('.rev-card-slider-arrows');
      const indicatorContainer = container.querySelector('[data-rev-card-slider-indicator]');
      const items = track.querySelectorAll('.rev-card-slider__item');
      if (!items.length) return;

      let currentIndex = 0;
      let isScrolling = false;
      const totalItems = items.length;

      // Global indicator style (brand DNA) + per-section show/hide
      const indicatorStyle = container.getAttribute('data-rev-indicator-style') || 'dots';
      const showDesktop = container.getAttribute('data-rev-show-indicator') === 'true';
      const showMobile = container.getAttribute('data-rev-show-indicator-mob') === 'true';

      const isMobile = () => window.innerWidth <= 768;

      // Maps global style to card slider CSS class type
      // 'lines' in gallery = 'progress_bar' in card slider (same visual concept)
      const getSliderType = () => {
        if (indicatorStyle === 'lines') return 'progress_bar';
        return indicatorStyle;
      };

      const shouldShow = () => isMobile() ? showMobile : showDesktop;

      // Check if all items fit on screen (no scrolling needed)
      // Uses scroll overflow as ground truth — immune to subpixel rounding issues
      const allItemsVisible = () => wrap.scrollWidth <= wrap.clientWidth + 1;

      // Build indicator based on global style
      const buildIndicator = () => {
        if (!indicatorContainer) return;
        indicatorContainer.innerHTML = '';
        indicatorContainer.className = 'rev-card-slider-indicator';

        if (!shouldShow() || allItemsVisible()) {
          indicatorContainer.style.display = 'none';
          return;
        }

        const type = getSliderType();
        indicatorContainer.style.display = '';
        indicatorContainer.classList.add('rev-card-slider-indicator-' + type);

        const visibleCount = this.getVisibleCount(track, items);
        const pageCount = Math.ceil(totalItems / visibleCount);

        if (type === 'dots' || type === 'squares') {
          for (let i = 0; i < pageCount; i++) {
            const bullet = document.createElement('button');
            bullet.type = 'button';
            bullet.className = 'rev-card-slider-bullet' + (i === 0 ? ' rev-card-slider-bullet-active' : '');
            bullet.dataset.index = i;
            bullet.setAttribute('aria-label', `Go to page ${i + 1}`);
            bullet.addEventListener('click', () => scrollToPage(i));
            indicatorContainer.appendChild(bullet);
          }
        } else if (type === 'counter') {
          indicatorContainer.textContent = `1 / ${pageCount}`;
        } else if (type === 'progress_bar') {
          const fill = document.createElement('div');
          fill.className = 'rev-card-slider-progress-fill';
          fill.style.width = pageCount > 1 ? `${(1 / pageCount) * 100}%` : '100%';
          indicatorContainer.appendChild(fill);
        }
      };

      const getPageIndex = () => {
        const visibleCount = this.getVisibleCount(track, items);
        const maxIndex = totalItems - visibleCount;
        if (currentIndex >= maxIndex) {
          const pageCount = Math.ceil(totalItems / visibleCount);
          return pageCount - 1;
        }
        return Math.floor(currentIndex / visibleCount);
      };

      const updateIndicator = () => {
        if (!indicatorContainer || !shouldShow()) return;
        const type = getSliderType();

        const visibleCount = this.getVisibleCount(track, items);
        const pageCount = Math.ceil(totalItems / visibleCount);
        const pageIndex = getPageIndex();

        if (type === 'dots' || type === 'squares') {
          const bullets = indicatorContainer.querySelectorAll('.rev-card-slider-bullet');
          bullets.forEach((bullet, index) => {
            bullet.classList.toggle('rev-card-slider-bullet-active', index === pageIndex);
          });
        } else if (type === 'counter') {
          indicatorContainer.textContent = `${pageIndex + 1} / ${pageCount}`;
        } else if (type === 'progress_bar') {
          const fill = indicatorContainer.querySelector('.rev-card-slider-progress-fill');
          if (fill) {
            fill.style.width = pageCount > 1 ? `${((pageIndex + 1) / pageCount) * 100}%` : '100%';
          }
        }
      };

      const updateButtons = () => {
        const visibleCount = this.getVisibleCount(track, items);
        const noScroll = allItemsVisible();

        // Hide arrows entirely when all items are visible
        if (arrowsContainer) arrowsContainer.style.display = noScroll ? 'none' : '';

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= totalItems - visibleCount;
      };

      const scrollToIndex = (index) => {
        const item = items[index];
        if (!item) return;
        isScrolling = true;
        wrap.scrollTo({
          left: item.offsetLeft,
          behavior: 'smooth'
        });
        currentIndex = index;
        updateButtons();
        updateIndicator();
        setTimeout(() => {
          isScrolling = false;
        }, 350);
      };

      const scrollToPage = (pageIndex) => {
        const visibleCount = this.getVisibleCount(track, items);
        const targetIndex = Math.min(pageIndex * visibleCount, totalItems - visibleCount);
        scrollToIndex(Math.max(0, targetIndex));
      };

      // Arrow navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const visibleCount = this.getVisibleCount(track, items);
          const currentPage = currentIndex >= (totalItems - visibleCount)
            ? Math.ceil(totalItems / visibleCount) - 1
            : Math.floor(currentIndex / visibleCount);
          const targetPage = Math.max(0, currentPage - 1);
          const targetIndex = targetPage * visibleCount;
          scrollToIndex(targetIndex);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const visibleCount = this.getVisibleCount(track, items);
          const currentPage = currentIndex >= (totalItems - visibleCount)
            ? Math.ceil(totalItems / visibleCount) - 1
            : Math.floor(currentIndex / visibleCount);
          const targetPage = currentPage + 1;
          const maxStartIndex = totalItems - visibleCount;
          const targetIndex = Math.min(targetPage * visibleCount, maxStartIndex);
          scrollToIndex(targetIndex);
        });
      }

      // Sync on scroll
      wrap.addEventListener('scroll', () => {
        if (isScrolling) return;
        const scrollLeft = wrap.scrollLeft;
        const itemWidth = items[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
        const newIndex = Math.round(scrollLeft / itemWidth);
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          updateButtons();
          updateIndicator();
        }
      });

      // Rebuild on resize (debounced) — handles show/hide switching at breakpoints
      let resizeTimeout;
      let lastWasMobile = isMobile();
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          lastWasMobile = isMobile();
          // Always rebuild — visible count changes at any width, not just breakpoints
          buildIndicator();
          updateButtons();
        }, 150);
      });

      // Initial setup
      buildIndicator();
      updateButtons();
    },
    getVisibleCount(track, items) {
      if (!items || !items.length) return 1;
      const trackWidth = track.offsetWidth;
      const itemWidth = items[0].offsetWidth;
      const gap = parseInt(getComputedStyle(track).gap || 0);
      return Math.max(1, Math.floor((trackWidth + gap) / (itemWidth + gap)));
    }
  };
  // Auto-init on DOM ready
  document.addEventListener('DOMContentLoaded', () => RevCardSlider.init());

  // ================================
  // Product Form Sync
  // Synchronizes variant and quantity selectors with form hidden inputs.
  // Bridges the gap between UI controls (outside form) and form submission data (inside form).
  // - Safe with Shopify section re-renders
  // - Scoped to specific containers via data-product-form-sync attribute
  // ================================
  (function () {
    if (window.__REV_PRODUCT_FORM_SYNC__) return;
    window.__REV_PRODUCT_FORM_SYNC__ = true;

    const inited = new WeakSet();

    function initProductFormSync(el) {
      if (!el || el.nodeType !== 1) return;
      if (inited.has(el)) return;
      inited.add(el);

      const form = el.querySelector('form.rev-product-form');
      if (!form) return;

      // ----------------------------------------
      // VARIANT SELECTOR SYNCHRONIZATION
      // ----------------------------------------
      // Listens for 'change' events on the variant selector container.
      // Reads variant configuration from embedded .rev-cfg JSON script.
      // Collects current option values from radio buttons or select dropdowns.
      // Finds matching variant by comparing option1/option2/option3 values.
      // Updates the hidden input inside the form with the matched variant ID.
      // ----------------------------------------
      const variantSelector = el.querySelector('.rev-variant-selector');
      const variantHiddenInput = form.querySelector('[data-rev-variant-id]');

      if (variantSelector && variantHiddenInput) {
        variantSelector.addEventListener('change', function () {
          const cfgScript = variantSelector.querySelector('.rev-cfg');
          if (!cfgScript) return;

          let cfg;
          try {
            cfg = JSON.parse(cfgScript.textContent.trim());
          } catch (e) {
            return;
          }

          // Collect selected option values (supports both radio buttons and dropdowns)
          const selected = [];
          variantSelector.querySelectorAll('.rev-option').forEach(function (optionDiv, idx) {
            const checked = optionDiv.querySelector('input[type="radio"]:checked');
            const selectEl = optionDiv.querySelector('select');
            if (checked) {
              selected[idx] = checked.value;
            } else if (selectEl) {
              selected[idx] = selectEl.value;
            }
          });

          // Find the variant that matches all selected options
          const variant = cfg.variants.find(function (v) {
            return (v.option1 === selected[0] || !selected[0]) &&
              (v.option2 === selected[1] || !selected[1]) &&
              (v.option3 === selected[2] || !selected[2]);
          });

          // Update the hidden input that the form will submit
          if (variant && variant.id) {
            variantHiddenInput.value = variant.id;
          }
        });
      }

      // ----------------------------------------
      // QUANTITY SELECTOR SYNCHRONIZATION
      // ----------------------------------------
      // 1. Find the visible quantity input (number field) outside the form
      // 2. Initialize the hidden quantity input inside the form with current value
      // 3. Listen for both 'change' and 'input' events to catch all user interactions
      // 4. Copy the quantity value to the hidden input on every change
      //
      // The hidden input (data-rev-quantity) is what Shopify's cart API reads on form submit.
      // ----------------------------------------
      const qtySelector = el.querySelector('.rev-qty-selector');
      const qtyHiddenInput = form.querySelector('[data-rev-quantity]');

      if (qtySelector && qtyHiddenInput) {
        const qtyInput = qtySelector.querySelector('input[type="number"]');
        if (qtyInput) {
          // Initialize: ensure hidden input matches visible input on page load
          qtyHiddenInput.value = qtyInput.value || 1;

          // Sync on 'change': triggered by +/- buttons and when input loses focus
          qtyInput.addEventListener('change', function () {
            qtyHiddenInput.value = qtyInput.value || 1;
          });

          // Sync on 'input': triggered during typing for immediate feedback
          qtyInput.addEventListener('input', function () {
            qtyHiddenInput.value = qtyInput.value || 1;
          });
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-product-form-sync]').forEach(initProductFormSync);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  // ================================
  // Video Review Carousel
  // Section: rev-video-review-carousel
  // Purpose: Infinite loop coverflow carousel with auto-advance on video end
  // ================================

  window.RevVideoCarousel = window.RevVideoCarousel || (() => {

    function init(root) {
      if (!root || root.dataset.revVideoCarouselInit === '1') return;

      const track = root.querySelector('[data-rev-video-carousel-track]');
      const originalSlides = Array.from(root.querySelectorAll('.rev-video-review-carousel__slide'));
      const prevBtn = root.querySelector('[data-rev-video-carousel-prev]');
      const nextBtn = root.querySelector('[data-rev-video-carousel-next]');

      if (!track || originalSlides.length === 0) return;

      root.dataset.revVideoCarouselInit = '1';

      let slides = [...originalSlides];
      let currentIndex = 0;
      let isAnimating = false;
      const slideCount = originalSlides.length;

      // Clone slides for infinite loop effect
      // We need enough clones so slides appear on both sides from the start
      if (slideCount >= 1) {
        const clonesNeeded = Math.max(3, Math.ceil(5 / slideCount));

        // Prepend clones (reversed order)
        for (let c = 0; c < clonesNeeded; c++) {
          [...originalSlides].reverse().forEach((slide, i) => {
            const clone = slide.cloneNode(true);
            clone.classList.add('is-clone');
            clone.classList.remove('is-active');
            clone.setAttribute('data-clone', 'prepend');
            clone.setAttribute('data-original-index', slideCount - 1 - i);
            track.insertBefore(clone, track.firstChild);
          });
        }

        // Append clones
        for (let c = 0; c < clonesNeeded; c++) {
          originalSlides.forEach((slide, i) => {
            const clone = slide.cloneNode(true);
            clone.classList.add('is-clone');
            clone.classList.remove('is-active');
            clone.setAttribute('data-clone', 'append');
            clone.setAttribute('data-original-index', i);
            track.appendChild(clone);
          });
        }

        // Update slides array
        slides = Array.from(track.querySelectorAll('.rev-video-review-carousel__slide'));

        // Force preload on cloned videos (browsers may ignore preload on programmatically inserted elements)
        slides.forEach(slide => {
          if (slide.classList.contains('is-clone')) {
            const video = slide.querySelector('video');
            if (video) video.load();
          }
        });

        // Start at the first real slide (after prepended clones)
        currentIndex = clonesNeeded * slideCount;
      }

      // Get slide width including margin
      function getSlideWidth() {
        const slide = slides[0];
        if (!slide) return 280;
        const style = getComputedStyle(slide);
        const width = slide.offsetWidth;
        const marginLeft = parseInt(style.marginLeft) || 0;
        const marginRight = parseInt(style.marginRight) || 0;
        return width + marginLeft + marginRight;
      }

      // Position track to center the current slide
      function positionTrack(animate = true) {
        const slideWidth = getSlideWidth();
        const trackWidth = root.offsetWidth;
        const centerOffset = (trackWidth / 2) - (slideWidth / 2);
        const targetX = -(currentIndex * slideWidth) + centerOffset;

        track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none';
        track.style.transform = `translateX(${targetX}px)`;
      }

      // Update slide classes
      function updateSlideClasses() {
        slides.forEach((slide, i) => {
          slide.classList.remove('is-active');
          if (i === currentIndex) {
            slide.classList.add('is-active');
          }
        });
      }

      // Handle video playback
      function handleVideoPlayback() {
        slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;

          if (i === currentIndex) {
            // Play active video (muted by default)
            video.currentTime = 0;
            video.muted = true;
            slide.setAttribute('data-muted', 'true');
            video.play().catch(() => { });
          } else {
            // Pause non-active videos
            video.pause();
          }
        });
      }

      // Setup video end listeners for auto-advance
      function setupVideoEndListeners() {
        slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;

          video.addEventListener('ended', () => {
            // Only advance if this slide is still active
            if (i === currentIndex) {
              next();
            }
          });
        });
      }

      // Go to specific index
      function goTo(index, animate = true) {
        if (isAnimating) return;

        currentIndex = index;
        updateSlideClasses();
        positionTrack(animate);
        handleVideoPlayback();

        if (animate) {
          isAnimating = true;

          setTimeout(() => {
            isAnimating = false;

            // Handle infinite loop wrap
            const clonesPerSide = (slides.length - slideCount) / 2;

            // If we've scrolled past the end clones, jump back to real slides
            if (currentIndex >= slides.length - clonesPerSide) {
              currentIndex = clonesPerSide + ((currentIndex - clonesPerSide) % slideCount);
              positionTrack(false);
              updateSlideClasses();
            }
            // If we've scrolled past the start clones, jump to end of real slides
            else if (currentIndex < clonesPerSide) {
              currentIndex = slides.length - clonesPerSide - (clonesPerSide - currentIndex);
              positionTrack(false);
              updateSlideClasses();
            }
          }, 520);
        }
      }

      // Next slide
      function next() {
        goTo(currentIndex + 1);
      }

      // Previous slide
      function prev() {
        goTo(currentIndex - 1);
      }

      // Volume toggle setup
      function setupVolumeToggles() {
        slides.forEach((slide) => {
          const volumeBtn = slide.querySelector('[data-rev-volume-toggle]');
          const video = slide.querySelector('video');

          if (!volumeBtn || !video) return;

          slide.setAttribute('data-muted', 'true');

          volumeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isMuted = video.muted;
            video.muted = !isMuted;
            slide.setAttribute('data-muted', isMuted ? 'false' : 'true');
          });
        });
      }

      // Navigation buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', prev);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', next);
      }

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            next();
          } else {
            prev();
          }
        }
      }, { passive: true });

      // Click on non-active slide to navigate
      slides.forEach((slide, i) => {
        slide.addEventListener('click', () => {
          if (i !== currentIndex && !slide.classList.contains('is-active')) {
            goTo(i);
          }
        });
      });

      // Pause on visibility change
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          slides.forEach(slide => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
        } else {
          handleVideoPlayback();
        }
      });

      // Handle resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          positionTrack(false);
        }, 100);
      });

      // Initialize
      setupVolumeToggles();
      setupVideoEndListeners();
      updateSlideClasses();

      // Position track after a brief delay to ensure CSS is applied
      requestAnimationFrame(() => {
        positionTrack(false);
        // Start playing the first video
        setTimeout(handleVideoPlayback, 100);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rev-video-carousel]').forEach(init);
    }

    // Auto-init
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    // Shopify section load
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));

    return { init, initAll };
  })();

  // ================================
  // Bundle Builder
  // Section: rev-bundle-builder
  // Purpose: Bundle & Save interaction handler
  // ================================

  /**
   * RevBundleBuilder - Bundle & Save interaction handler
   * 
   * Handles the complete bundle building experience including:
   * - Item selection and variant picking
   * - Progress tracking and price calculations
   * - Swap modal for alternative products
   * - Cart integration
   */
  const RevBundleBuilder = (function () {
    'use strict';

    // State management
    let state = {
      section: null,
      itemsRequired: 3,
      discountType: 'percent',  // 'percent', 'amount', or 'none'
      discountValue: 0,
      items: new Map(), // itemIndex -> { productId, variantId, price, title, image, options }
      skippedItems: new Set(), // itemIndex values that were skipped
      confirmEnabled: false,
      confirmPending: false
    };

    // DOM Element references
    let els = {};

    // Decode HTML entities from escaped config strings
    function decodeHtml(str) {
      const txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    }

    /**
     * Initialize the bundle builder
     * @param {HTMLElement} sectionEl - The section container element
     */
    function init(sectionEl) {
      if (!sectionEl) return;

      state.section = sectionEl;
      state.itemsRequired = parseInt(sectionEl.dataset.itemsRequired) || 3;
      state.discountType = sectionEl.dataset.discountType || 'percent';
      state.discountValue = parseFloat(sectionEl.dataset.discountValue) || 0;
      state.confirmEnabled = sectionEl.dataset.confirmModal === 'true';

      cacheElements();
      bindEvents();
      updateUI();
      initAutoSelectItems();
    }

    /**
     * Auto-initialize items that start in the selecting state (single product, no alternatives)
     */
    function initAutoSelectItems() {
      state.section.querySelectorAll('[data-auto-select="true"]').forEach(selectingState => {
        const item = selectingState.closest('[data-bundle-item]');
        if (!item) return;

        const activeWrap = item.querySelector('.rev-bundle-builder__variant-wrap:not([style*="display: none"])');
        if (activeWrap) {
          if (typeof initVariantSelectorState === 'function') {
            initVariantSelectorState(activeWrap);
          }
          const selector = activeWrap.querySelector('.rev-variant-selector');
          if (selector) {
            trackVariantChange(item, selector);
          }
        }
      });
    }

    /**
     * Cache DOM element references
     */
    function cacheElements() {
      els = {
        progressBar: state.section.querySelector('[data-progress-fill]'),
        progressCount: state.section.querySelector('[data-progress-count]'),
        progressHint: state.section.querySelector('[data-progress-hint]'),
        bundleItems: state.section.querySelectorAll('[data-bundle-item]'),
        originalPrice: state.section.querySelector('[data-original-price]'),
        bundlePrice: state.section.querySelector('[data-bundle-price]'),
        savingsBadge: state.section.querySelector('[data-savings-badge]'),
        statusCount: state.section.querySelector('[data-status-count]'),
        statusHint: state.section.querySelector('[data-status-hint]'),
        addButton: state.section.querySelector('[data-add-bundle]'),
        confirmModal: state.section.querySelector('[data-confirm-modal-el]'),
        confirmItems: state.section.querySelector('[data-confirm-items]'),
        confirmSubtotal: state.section.querySelector('[data-confirm-subtotal]'),
        confirmDiscount: state.section.querySelector('[data-confirm-discount]'),
        confirmDiscountLabel: state.section.querySelector('[data-confirm-discount-label]'),
        confirmTotal: state.section.querySelector('[data-confirm-total]'),
        confirmAdd: state.section.querySelector('[data-confirm-add]')
      };
    }

    /**
     * Bind all event handlers
     */
    function bindEvents() {
      // Item selection events
      els.bundleItems.forEach(item => {
        const selectBtn = item.querySelector('[data-select-trigger]');
        const confirmBtn = item.querySelector('[data-confirm-trigger]');
        const editBtn = item.querySelector('[data-edit-trigger]');
        const swapBtn = item.querySelector('[data-swap-trigger]');

        if (selectBtn) {
          selectBtn.addEventListener('click', () => showSelectingState(item));
        }

        if (confirmBtn) {
          confirmBtn.addEventListener('click', () => confirmSelection(item));
        }

        if (editBtn) {
          editBtn.addEventListener('click', () => showSelectingState(item));
        }

        if (swapBtn) {
          swapBtn.addEventListener('click', () => {
            // Set updating state (accent color)
            item.dataset.updating = 'true';
            item.dataset.selected = 'false';
            const status = item.querySelector('[data-item-status]');
            if (status) status.textContent = 'UPDATING';
            showItemState(item, 'initial');
          });
        }

        // Listen for variant changes from rev-variant-selector
        item.addEventListener('change', (e) => {
          const input = e.target;
          const selector = input.closest('.rev-variant-selector');
          if (!selector) return;
          trackVariantChange(item, selector);
        });

        // Choice click events (multi-product initial state)
        const choices = item.querySelectorAll('[data-choice-index]');
        choices.forEach(choice => {
          choice.addEventListener('click', () => handleChoiceClick(item, parseInt(choice.dataset.choiceIndex)));
        });

        // Back button (return to choices from selecting state)
        const backBtn = item.querySelector('[data-back-trigger]');
        if (backBtn) {
          backBtn.addEventListener('click', () => showItemState(item, 'initial'));
        }

        // Skip button
        const skipBtn = item.querySelector('[data-skip-trigger]');
        if (skipBtn) {
          skipBtn.addEventListener('click', () => skipItem(item));
        }

        // Unskip (reset) button
        const unskipBtn = item.querySelector('[data-unskip-trigger]');
        if (unskipBtn) {
          unskipBtn.addEventListener('click', () => unskipItem(item));
        }
      });

      // Add to cart button
      if (els.addButton) {
        els.addButton.addEventListener('click', addBundleToCart);
      }

      // Confirm modal events
      state.section.querySelectorAll('[data-confirm-close]').forEach(el => {
        el.addEventListener('click', closeConfirmModal);
      });

      if (els.confirmAdd) {
        els.confirmAdd.addEventListener('click', executeAddToCart);
      }
    }

    /**
     * Show the selecting state for an item
     * @param {HTMLElement} item - The bundle item element
     */
    function showSelectingState(item) {
      const states = item.querySelectorAll('[data-state]');
      states.forEach(s => s.style.display = 'none');

      const selectingState = item.querySelector('[data-state="selecting"]');
      if (selectingState) {
        selectingState.style.display = 'flex';
      }

      // Update status text
      const status = item.querySelector('[data-item-status]');
      if (status) {
        status.textContent = 'IN PROGRESS';
      }

      // Show edit button, hide swap button while selecting
      const editBtn = item.querySelector('[data-edit-trigger]');
      const swapBtn = item.querySelector('[data-swap-trigger]');
      if (editBtn) editBtn.style.display = 'none';
      if (swapBtn) swapBtn.style.display = 'none';

      // Show back button only if item has alternatives (choice list to return to)
      const backBtn = item.querySelector('[data-back-trigger]');
      const cfg = getItemConfig(item);
      if (backBtn) {
        backBtn.style.display = (cfg && cfg.hasAlternatives) ? 'flex' : 'none';
      }

      // Initialize variant selector state (option disabling)
      const activeWrap = item.querySelector('.rev-bundle-builder__variant-wrap:not([style*="display: none"])');
      if (activeWrap) {
        if (typeof initVariantSelectorState === 'function') {
          initVariantSelectorState(activeWrap);
        }
        // Track initial variant from default selections
        const selector = activeWrap.querySelector('.rev-variant-selector');
        if (selector) {
          trackVariantChange(item, selector);
        }
      }
    }

    /**
     * Track variant change from rev-variant-selector
     * @param {HTMLElement} item - The bundle item element
     * @param {HTMLElement} selector - The rev-variant-selector element
     */
    function trackVariantChange(item, selector) {
      const cfgScript = selector.querySelector('.rev-cfg');
      if (!cfgScript) return;

      let config;
      try {
        config = JSON.parse(cfgScript.textContent.trim());
      } catch (e) {
        return;
      }

      // Read selected options from radio inputs and selects
      const selected = [];
      selector.querySelectorAll('[data-option-position]').forEach(el => {
        const pos = parseInt(el.dataset.optionPosition, 10) - 1;
        if (el.type === 'radio' && el.checked) selected[pos] = el.value;
        if (el.tagName === 'SELECT') selected[pos] = el.value;
      });

      // Find matching variant
      const variant = config.variants.find(v =>
        selected.every((val, idx) => val == null || v[`option${idx + 1}`] === val)
      );

      // Store on item element for confirmSelection
      item._bundleVariant = variant || null;
      item._bundleSelectedOptions = selected.filter(Boolean);

      // Update the selecting state image (same approach as quickview)
      // Skip if custom overlay media is in use — Liquid already rendered the correct image
      if (variant && variant.feat_media_url) {
        const bundleItemEl = item.closest('[data-bundle-item]') || item;
        const bundleCfgScript = bundleItemEl.querySelector('.rev-bundle-item-cfg');
        let bundleItemCfg = null;
        if (bundleCfgScript) {
          try { bundleItemCfg = JSON.parse(bundleCfgScript.textContent.trim()); } catch (_) { }
        }
        const overlayEnabled = !!bundleItemCfg?.customInput?.overlayEnabled;
        const overlayMedia = bundleItemCfg?.customInput?.overlayMedia;

        if (!(overlayEnabled && overlayMedia)) {
          const itemImg = item.querySelector('[id^="bundle-item-img-"]');
          if (itemImg) {
            const makeSrc = (url, w) => url.replace(/width=\d+/, `width=${w}`);
            itemImg.srcset = `${makeSrc(variant.feat_media_url, 200)} 200w, ${makeSrc(variant.feat_media_url, 400)} 400w`;
            itemImg.src = makeSrc(variant.feat_media_url, 400);
          }
        }
      }
    }

    /**
     * Confirm the selection for an item
     * @param {HTMLElement} item - The bundle item element
     */
    function confirmSelection(item) {
      const itemIndex = item.dataset.bundleItem;
      const cfg = getItemConfig(item);
      if (!cfg) return;

      // Get tracked variant from rev-variant-selector
      const variant = item._bundleVariant;
      const selectedOptions = item._bundleSelectedOptions || [];

      if (!variant) {
        alert('Please select all options before confirming.');
        return;
      }

      // Validate custom input if required
      const customInputEl = item.querySelector('[data-custom-input]');
      let customInputValue = '';
      let customInputPropertyName = '';
      if (cfg.customInput && cfg.customInput.enabled) {
        customInputValue = customInputEl ? customInputEl.value.trim() : '';
        customInputPropertyName = cfg.customInput.propertyName || 'Personalization';
        if (cfg.customInput.required && !customInputValue) {
          alert('Please fill in the required field before confirming.');
          if (customInputEl) customInputEl.focus();
          return;
        }
      }

      // Get price from bundle config variants
      const bundleVariant = cfg.variants.find(v => v.id === variant.id);
      const price = bundleVariant ? bundleVariant.price : 0;
      const priceFormatted = bundleVariant ? bundleVariant.priceFormatted : '$0.00';

      // Determine the best image: overlay media > variant featured media > product default
      const overlayActive = cfg.customInput && cfg.customInput.overlayEnabled && cfg.customInput.overlayMedia;
      const confirmedImage = overlayActive ? cfg.customInput.overlayMedia : ((variant.feat_media_url) || cfg.productImage);

      // Store selection
      state.items.set(itemIndex, {
        productId: cfg.productId,
        variantId: variant.id,
        price: price,
        priceFormatted: priceFormatted,
        title: cfg.productTitle,
        options: selectedOptions,
        image: confirmedImage,
        customInput: customInputValue,
        customInputPropertyName: customInputPropertyName
      });

      // Update overlay text in both selecting + confirmed views
      item.querySelectorAll('[data-custom-overlay-text]').forEach(function (el) {
        el.textContent = customInputValue || '';
      });

      // Mirror confirmed selection onto DOM for PDP ATC
      item.dataset.bundleSelected = 'true';
      item.dataset.bundleVariantId = String(variant.id);
      item.dataset.bundleProductId = String(cfg.productId || '');
      item.dataset.bundleTitle = String(decodeHtml(cfg.productTitle || ''));
      item.dataset.bundlePriceFormatted = String(priceFormatted || '');

      if (customInputValue && customInputPropertyName) {
        item.dataset.bundleCustomInput = String(customInputValue);
        item.dataset.bundleCustomInputPropertyName = String(customInputPropertyName);
      } else {
        delete item.dataset.bundleCustomInput;
        delete item.dataset.bundleCustomInputPropertyName;
      }

      // Update UI
      item.dataset.selected = 'true';
      item.dataset.updating = 'false';

      const states = item.querySelectorAll('[data-state]');
      states.forEach(s => s.style.display = 'none');

      const confirmedState = item.querySelector('[data-state="confirmed"]');
      if (confirmedState) {
        confirmedState.style.display = 'flex';
      }

      // Update confirmed state content
      const confirmedTitle = item.querySelector('[data-confirmed-title]');
      const confirmedOptions = item.querySelector('[data-confirmed-options]');
      const confirmedPrice = item.querySelector('[data-confirmed-price]');
      const confirmedImg = item.querySelector('[id^="bundle-confirmed-img-"]');

      if (confirmedTitle) confirmedTitle.textContent = decodeHtml(cfg.productTitle);
      if (confirmedOptions) {
        let detailParts = [selectedOptions.join(' / ')];
        if (customInputValue) {
          detailParts.push(customInputValue);
        }
        confirmedOptions.textContent = detailParts.join(' · ');
      }
      if (confirmedPrice) confirmedPrice.textContent = priceFormatted;
      if (confirmedImg) {
        confirmedImg.src = confirmedImage;
        confirmedImg.srcset = '';
      }

      // Update status
      const status = item.querySelector('[data-item-status]');
      if (status) {
        status.textContent = 'CONFIRMED';
      }

      // Show edit button
      const editBtn = item.querySelector('[data-edit-trigger]');
      const swapBtn = item.querySelector('[data-swap-trigger]');
      if (editBtn) editBtn.style.display = 'inline-flex';
      if (swapBtn && cfg.hasAlternatives) swapBtn.style.display = 'inline-flex';

      updateUI();
    }

    /**
     * Skip a bundle item (mark as skipped without selecting a product)
     * @param {HTMLElement} item - The bundle item element
     */
    function skipItem(item) {
      const itemIndex = item.dataset.bundleItem;

      // Remove any existing selection
      if (state.items.has(itemIndex)) {
        state.items.delete(itemIndex);
      }

      // Clear overlay + input
      item.querySelectorAll('[data-custom-overlay-text]').forEach(function (el) {
        el.textContent = '';
      });

      const customInput = item.querySelector('[data-custom-input]');
      if (customInput) customInput.value = '';

      // Clear DOM bundle selection data
      delete item.dataset.bundleSelected;
      delete item.dataset.bundleVariantId;
      delete item.dataset.bundleProductId;
      delete item.dataset.bundleTitle;
      delete item.dataset.bundlePriceFormatted;
      delete item.dataset.bundleCustomInput;
      delete item.dataset.bundleCustomInputPropertyName;

      // Add to skipped set
      state.skippedItems.add(itemIndex);

      // Update data attributes
      item.dataset.selected = 'true';
      item.dataset.skipped = 'true';
      item.dataset.updating = 'false';

      // Show skipped state (use confirmed state container with skipped content)
      const states = item.querySelectorAll('[data-state]');
      states.forEach(s => s.style.display = 'none');

      const skippedState = item.querySelector('[data-state="skipped"]');
      if (skippedState) {
        skippedState.style.display = 'flex';
      }

      // Update status text
      const status = item.querySelector('[data-item-status]');
      if (status) status.textContent = 'SKIPPED';

      // Hide edit/swap buttons, show unskip
      const editBtn = item.querySelector('[data-edit-trigger]');
      const swapBtn = item.querySelector('[data-swap-trigger]');
      const unskipBtn = item.querySelector('[data-unskip-trigger]');
      if (editBtn) editBtn.style.display = 'none';
      if (swapBtn) swapBtn.style.display = 'none';
      if (unskipBtn) unskipBtn.style.display = 'inline-flex';

      updateUI();
    }

    /**
     * Unskip a bundle item (reset back to initial state)
     * @param {HTMLElement} item - The bundle item element
     */
    function unskipItem(item) {
      const itemIndex = item.dataset.bundleItem;

      // Remove from skipped set
      state.skippedItems.delete(itemIndex);

      // Reset data attributes
      item.dataset.selected = 'false';
      item.dataset.skipped = 'false';
      item.dataset.updating = 'false';

      // Clear overlay + input
      item.querySelectorAll('[data-custom-overlay-text]').forEach(function (el) {
        el.textContent = '';
      });

      const customInput = item.querySelector('[data-custom-input]');
      if (customInput) customInput.value = '';

      // Clear DOM bundle selection data
      delete item.dataset.bundleSelected;
      delete item.dataset.bundleVariantId;
      delete item.dataset.bundleProductId;
      delete item.dataset.bundleTitle;
      delete item.dataset.bundlePriceFormatted;
      delete item.dataset.bundleCustomInput;
      delete item.dataset.bundleCustomInputPropertyName;

      // Show initial state
      showItemState(item, 'initial');

      // Update status text
      const status = item.querySelector('[data-item-status]');
      if (status) status.textContent = 'NOT SELECTED';

      // Hide unskip button
      const unskipBtn = item.querySelector('[data-unskip-trigger]');
      if (unskipBtn) unskipBtn.style.display = 'none';

      updateUI();
    }

    /**
     * Show a specific state for an item (generic state switcher)
     * @param {HTMLElement} item - The bundle item element
     * @param {string} stateName - The state name ('initial', 'selecting', 'confirmed')
     */
    function showItemState(item, stateName) {
      const states = item.querySelectorAll('[data-state]');
      states.forEach(s => s.style.display = 'none');

      const targetState = item.querySelector(`[data-state="${stateName}"]`);
      if (targetState) {
        targetState.style.display = 'flex';
      }

      // Reset edit button visibility based on state
      const editBtn = item.querySelector('[data-edit-trigger]');
      if (editBtn) {
        editBtn.style.display = stateName === 'confirmed' ? 'inline-flex' : 'none';
      }
    }

    /**
     * Get the configuration for an item
     * @param {HTMLElement} item - The bundle item element
     * @returns {Object|null} Configuration object or null
     */
    function getItemConfig(item) {
      const script = item.querySelector('.rev-bundle-item-cfg');
      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.error('Failed to parse item config:', e);
        return null;
      }
    }

    /**
     * Get a human-readable discount label
     * @returns {string} e.g. "20%" or "$10.00"
     */
    function getDiscountLabel() {
      if (state.discountType === 'none') return '';
      if (state.discountType === 'percent') {
        return `${state.discountValue}%`;
      }
      return formatMoney(state.discountValue * 100);
    }

    /**
     * Calculate the discount savings in cents
     * @param {number} originalTotal - Total price in cents before discount
     * @returns {number} Savings amount in cents
     */
    function calculateSavings(originalTotal) {
      if (state.discountType === 'none' || state.discountValue <= 0) return 0;

      if (state.discountType === 'percent') {
        return Math.round(originalTotal * (state.discountValue / 100));
      }
      // 'amount' — discountValue is in dollars, convert to cents
      return Math.round(state.discountValue * 100);
    }

    /**
     * Update all UI elements based on current state
     */
    function updateUI() {
      const selectedCount = state.items.size;
      const skippedCount = state.skippedItems.size;
      const completedCount = selectedCount + skippedCount;
      const totalItems = els.bundleItems.length;
      const isComplete = completedCount >= state.itemsRequired;

      // Calculate prices (skipped items contribute $0)
      let originalTotal = 0;
      state.items.forEach(item => {
        originalTotal += item.price;
      });

      const savings = selectedCount > 0 ? calculateSavings(originalTotal) : 0;
      const bundleTotal = originalTotal - savings;
      const discountLabel = getDiscountLabel();

      // Update progress bar
      const progressPercent = Math.min((completedCount / state.itemsRequired) * 100, 100);
      if (els.progressBar) {
        els.progressBar.style.width = `${progressPercent}%`;
      }

      // Update progress count
      if (els.progressCount) {
        els.progressCount.textContent = `${completedCount} / ${state.itemsRequired} Items`;
      }

      // Update progress hint
      if (els.progressHint) {
        const remaining = state.itemsRequired - completedCount;
        if (completedCount === 0) {
          els.progressHint.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg> Select your first item to start building your bundle`;
        } else if (isComplete) {
          const completeMsg = discountLabel ? `${discountLabel} savings applied.` : 'Ready to add to cart.';
          els.progressHint.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg> Bundle Complete! ${completeMsg}`;
        } else {
          const remainingMsg = discountLabel ? `to unlock ${discountLabel} savings` : 'to complete your bundle';
          els.progressHint.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 13V2l8 4-8 4"/><path d="M20.561 10.222a9 9 0 1 1-12.55-5.29"/><path d="M8.002 9.997a5 5 0 1 0 8.9 2.02"/></svg> Add ${remaining} more item${remaining > 1 ? 's' : ''} ${remainingMsg}`;
        }
      }

      // Update prices
      if (els.originalPrice) {
        els.originalPrice.textContent = formatMoney(originalTotal);
      }

      if (els.bundlePrice) {
        els.bundlePrice.textContent = formatMoney(bundleTotal);
      }

      // Update savings badge
      if (els.savingsBadge) {
        if (isComplete && savings > 0) {
          els.savingsBadge.textContent = `Save ${formatMoney(savings)}`;
          els.savingsBadge.style.display = 'inline-block';
        } else {
          els.savingsBadge.style.display = 'none';
        }
      }

      // Update status count
      if (els.statusCount) {
        els.statusCount.textContent = `${completedCount} of ${state.itemsRequired} items selected`;
      }

      // Update add button state
      if (els.addButton) {
        els.addButton.disabled = !isComplete;
      }

      // Update lock state (sequential unlock — selected OR skipped unlocks next)
      const sequentialLock = state.section?.dataset.bundleSequentialLock === 'true';
      if (sequentialLock) {
        els.bundleItems.forEach((item, idx) => {
          if (idx === 0) {
            item.dataset.locked = 'false';
            return;
          }
          const prevItem = els.bundleItems[idx - 1];
          const prevDone = prevItem.dataset.selected === 'true' || prevItem.dataset.skipped === 'true';
          item.dataset.locked = prevDone ? 'false' : 'true';
        });
      } else {
        els.bundleItems.forEach((item) => {
          item.dataset.locked = 'false';
        });
      }
    }

    /**
     * Format a price in cents to a money string
     * @param {number} cents - Price in cents
     * @returns {string} Formatted price string
     */
    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    /**
     * Add the bundle to cart (or show confirm modal first)
     */
    async function addBundleToCart() {
      if ((state.items.size + state.skippedItems.size) < state.itemsRequired) return;

      // If confirm modal is enabled and we haven't confirmed yet, show it
      if (state.confirmEnabled && !state.confirmPending) {
        showConfirmModal();
        return;
      }

      // Reset confirm pending flag
      state.confirmPending = false;

      els.addButton.disabled = true;
      els.addButton.classList.add('loading');
      if (els.confirmAdd) {
        els.confirmAdd.disabled = true;
        els.confirmAdd.classList.add('loading');
      }

      const items = [];
      state.items.forEach((item, index) => {
        // Validate variant ID
        if (!item.variantId) {
          console.error('Missing variantId for item:', index, item);
          return;
        }
        const cartItem = {
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            '_bundle': 'true',
            '_bundle_discount': getDiscountLabel() + (state.discountType === 'amount' ? ' off' : '')
          }
        };

        // Add custom input as line item property if present
        if (item.customInput && item.customInputPropertyName) {
          cartItem.properties[item.customInputPropertyName] = item.customInput;
        }

        items.push(cartItem);
      });

      // Guard against empty items
      if (items.length === 0) {
        console.error('No valid items to add to cart');
        alert('Please select variants for all items before adding to cart.');
        resetButtonState();
        return;
      }

      if (items.length > 1) {
        const bundleGroupId = `group_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
        items.forEach(item => {
          if (!item.properties) {
            item.properties = {};
          }
          item.properties['_bundle_group_id'] = bundleGroupId;
        });
      }

      console.log('Adding bundle to cart:', JSON.stringify(items, null, 2));

      try {
        // Build cart request body — include cart drawer section for one-roundtrip drawer refresh
        const cartBody = { items };
        if (typeof getCartDrawerSectionId === 'function') {
          const cartDrawerSectionId = getCartDrawerSectionId();
          if (cartDrawerSectionId) {
            cartBody.sections = [cartDrawerSectionId];
            cartBody.sections_url = window.location.pathname;
          }
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartBody)
        });

        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || `Failed to add (${res.status})`);
        }

        const parsedState = await res.json();

        // Apply auto-discount if present
        const discountCode = els.addButton.dataset.discountCode;
        if (discountCode && discountCode.trim()) {
          const discountUrl = `/discount/${encodeURIComponent(discountCode.trim())}?redirect=${encodeURIComponent(window.location.pathname)}`;
          await fetch(discountUrl, { method: 'GET', credentials: 'include', redirect: 'follow' })
            .catch(e => console.warn('Failed to apply bundle discount', e));
          await new Promise(r => setTimeout(r, 200));
        }

        // Dispatch cart events for theme integration (matches rev-flare.js)
        document.body.classList.add('rev-item-added');
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true })
        );
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('product-ajax:added', { bubbles: true }));

        // Close confirm modal if it was open
        closeConfirmModal();

        // Reset button and open cart drawer
        resetButtonState();

        const uflCart = document.getElementById('ufl-cart');
        if (uflCart) {
          // RevFlare cart drawer — replicate refreshCartElements(false) behavior
          try {
            const [cartRes, htmlRes] = await Promise.all([
              fetch('/cart.js').then(r => r.json()),
              fetch(window.location.href).then(r => r.text())
            ]);

            if (cartRes.item_count > 0) {
              const htmlDoc = new DOMParser().parseFromString(htmlRes, 'text/html');
              const newContent = htmlDoc.querySelector('#ufl-cart .ufl-cart-content');
              const currentContent = uflCart.querySelector('.ufl-cart-content');

              if (currentContent && newContent) {
                currentContent.innerHTML = newContent.innerHTML;
              }

              // Open drawer (matches openCartDrawer in rev-flare-cart.js)
              uflCart.style.visibility = 'visible';
              uflCart.removeAttribute('inert');
              uflCart.classList.remove('ufl-cart-hidden');
              uflCart.setAttribute('tabindex', '-1');
              uflCart.focus();
            }
          } catch (_) {
            // Non-critical — items are already added
          }
        } else if (typeof revOpenCartDrawer === 'function') {
          // Theme cart drawer
          await revOpenCartDrawer(parsedState.sections);
        } else {
          window.location.href = '/cart';
        }

      } catch (error) {
        console.error('Add to cart error:', error);
        revShowCartError(error.message);
        resetButtonState();
      }
    }

    /**
     * Reset the add buttons to default state
     */
    function resetButtonState() {
      if (els.addButton) {
        els.addButton.disabled = false;
        els.addButton.classList.remove('loading');
      }
      if (els.confirmAdd) {
        els.confirmAdd.disabled = false;
        els.confirmAdd.classList.remove('loading');
      }
    }

    /**
     * Switch an item to a different product (reusable swap logic)
     * @param {HTMLElement} item - The bundle item element
     * @param {Object} newProduct - New product data
     * @param {Object} currentCfg - Current item configuration
     */
    function switchToProduct(item, newProduct, currentCfg) {
      const itemIndex = item.dataset.bundleItem;

      // Remove existing selection
      if (state.items.has(itemIndex)) {
        state.items.delete(itemIndex);
      }

      // Clear overlay + input
      item.querySelectorAll('[data-custom-overlay-text]').forEach(function (el) {
        el.textContent = '';
      });

      const customInput = item.querySelector('[data-custom-input]');
      if (customInput) customInput.value = '';

      // Clear DOM bundle selection data
      delete item.dataset.bundleSelected;
      delete item.dataset.bundleVariantId;
      delete item.dataset.bundleProductId;
      delete item.dataset.bundleTitle;
      delete item.dataset.bundlePriceFormatted;
      delete item.dataset.bundleCustomInput;
      delete item.dataset.bundleCustomInputPropertyName;

      // Update config JSON
      const cfgScript = item.querySelector('.rev-bundle-item-cfg');
      if (cfgScript) {
        const newConfig = {
          productId: newProduct.id,
          productHandle: newProduct.handle,
          productTitle: newProduct.title,
          productUrl: newProduct.url,
          productImage: newProduct.image,
          variants: newProduct.variants,
          options: newProduct.options,
          optionsWithValues: newProduct.optionsWithValues,
          hasAlternatives: true,
          alternatives: currentCfg.alternatives
        };
        cfgScript.textContent = JSON.stringify(newConfig);
      }

      // Update element attributes
      item.dataset.productId = newProduct.id;
      item.dataset.selected = 'false';

      // Update selecting state UI
      const selectingState = item.querySelector('[data-state="selecting"]');
      if (selectingState) {
        const img = selectingState.querySelector('.rev-bundle-builder__item-img');
        if (img) {
          img.src = newProduct.image;
          img.srcset = newProduct.image.replace(/width=\d+/, 'width=200') + ' 200w, ' + newProduct.image + ' 400w';
        }

        const title = selectingState.querySelector('[data-selecting-title]');
        if (title) title.textContent = decodeHtml(newProduct.title);

        // Swap variant-wrap visibility (pre-rendered selectors)
        item.querySelectorAll('.rev-bundle-builder__variant-wrap').forEach(wrap => {
          wrap.style.display = wrap.dataset.variantProduct == newProduct.id ? '' : 'none';
        });

        // Initialize option disabling on the newly shown variant selector
        const activeWrap = item.querySelector('.rev-bundle-builder__variant-wrap[data-variant-product="' + newProduct.id + '"]');
        if (activeWrap && typeof initVariantSelectorState === 'function') {
          initVariantSelectorState(activeWrap);
        }
      }

      // Update confirmed state
      const confirmedState = item.querySelector('[data-state="confirmed"]');
      if (confirmedState) {
        const img = confirmedState.querySelector('.rev-bundle-builder__confirmed-img');
        if (img) {
          img.src = newProduct.image;
          img.srcset = '';
        }

        const title = confirmedState.querySelector('[data-confirmed-title]');
        if (title) title.textContent = decodeHtml(newProduct.title);
      }

      // Update status
      const statusEl = item.querySelector('[data-item-status]');
      if (statusEl) {
        statusEl.textContent = 'NOT SELECTED';
      }

      // Reset tracked variant
      item._bundleVariant = null;
      item._bundleSelectedOptions = null;
    }

    /**
     * Handle click on a product choice in the multi-product initial state
     * @param {HTMLElement} item - The bundle item element
     * @param {number} choiceIndex - Index of the chosen product (0 = current, 1+ = alternative)
     */
    function handleChoiceClick(item, choiceIndex) {
      const cfg = getItemConfig(item);
      if (!cfg) return;

      // Get the chosen product data from the products_list
      // choiceIndex 0 = first product in list (which might not be the current product after swaps)
      const chosenProduct = choiceIndex === 0
        ? { id: cfg.productId, title: cfg.productTitle, image: cfg.productImage, variants: cfg.variants, options: cfg.options, optionsWithValues: cfg.optionsWithValues }
        : cfg.alternatives[choiceIndex - 1];

      if (!chosenProduct) return;

      // If the chosen product is different from the current config, swap to it
      if (chosenProduct.id !== cfg.productId) {
        switchToProduct(item, chosenProduct, cfg);
      }

      // Update the selecting state image and title
      // Skip image swap if custom overlay media is in use
      const selectingState = item.querySelector('[data-state="selecting"]');
      if (selectingState) {
        const overlayEnabled = !!cfg.customInput?.overlayEnabled;
        const overlayMedia = cfg.customInput?.overlayMedia;

        if (!(overlayEnabled && overlayMedia)) {
          const img = selectingState.querySelector('.rev-bundle-builder__item-img');
          if (img) {
            img.src = chosenProduct.image;
            img.srcset = chosenProduct.image.replace(/width=\d+/, 'width=200') + ' 200w, ' + chosenProduct.image + ' 400w';
          }
        }

        const title = selectingState.querySelector('[data-selecting-title]');
        if (title) title.textContent = decodeHtml(chosenProduct.title);

        // Show the correct variant-wrap
        item.querySelectorAll('.rev-bundle-builder__variant-wrap').forEach(wrap => {
          wrap.style.display = wrap.dataset.variantProduct == chosenProduct.id ? '' : 'none';
        });
      }

      showSelectingState(item);
    }

    /**
     * Show the confirmation modal with product review
     */
    function showConfirmModal() {
      populateConfirmModal();
      els.confirmModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    /**
     * Populate the confirmation modal with current selections
     */
    function populateConfirmModal() {
      if (!els.confirmItems) return;

      els.confirmItems.innerHTML = '';

      let originalTotal = 0;

      state.items.forEach((item, itemIndex) => {
        originalTotal += item.price;

        const bundleItemEl = state.section.querySelector(`[data-bundle-item="${itemIndex}"]`);
        const cfg = bundleItemEl ? getItemConfig(bundleItemEl) : null;
        const hasAlts = cfg && cfg.hasAlternatives;

        const row = document.createElement('div');
        row.className = 'rev-bundle-builder__confirm-item';

        let swapHtml = '';
        if (hasAlts) {
          swapHtml = `
                    <button class="rev-bundle-builder__confirm-item-swap" type="button" data-confirm-swap="${itemIndex}">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M7 16l-4-4m0 0l4-4m-4 4h18M17 8l4 4m0 0l-4 4m4-4H3"/>
                        </svg>
                        Swap
                    </button>
                `;
        }

        row.innerHTML = `
                <img src="${item.image}" alt="${item.title}" class="rev-bundle-builder__confirm-item-img" />
                <div class="rev-bundle-builder__confirm-item-info">
                    <p class="rev-bundle-builder__confirm-item-title">${item.title}</p>
                    <p class="rev-bundle-builder__confirm-item-variant">${item.options.join(' / ')}</p>
                </div>
                <span class="rev-bundle-builder__confirm-item-price">${item.priceFormatted}</span>
                ${swapHtml}
            `;

        // Bind swap button if present
        const swapBtn = row.querySelector('[data-confirm-swap]');
        if (swapBtn) {
          swapBtn.addEventListener('click', () => {
            closeConfirmModal();
            const targetItem = state.section.querySelector(`[data-bundle-item="${itemIndex}"]`);
            if (targetItem) {
              showSelectingState(targetItem);

              // ensure accordion is open
              targetItem.classList.add('is-open');

              const trigger = targetItem.querySelector('[data-accordion-trigger]');
              if (trigger) trigger.setAttribute('aria-expanded', 'true');

              // ensure initial state is hidden
              const initialState = targetItem.querySelector('[data-state="initial"]');
              if (initialState) initialState.hidden = true;
            }
          });
        }

        els.confirmItems.appendChild(row);
      });

      // Calculate totals
      const savings = calculateSavings(originalTotal);
      const bundleTotal = originalTotal - savings;

      if (els.confirmSubtotal) {
        els.confirmSubtotal.textContent = formatMoney(originalTotal);
      }
      if (els.confirmDiscountLabel) {
        els.confirmDiscountLabel.textContent = `Bundle Discount (${getDiscountLabel()})`;
      }
      if (els.confirmDiscount) {
        els.confirmDiscount.textContent = '-' + formatMoney(savings);
      }
      if (els.confirmTotal) {
        els.confirmTotal.textContent = formatMoney(bundleTotal);
      }
    }

    /**
     * Close the confirmation modal
     */
    function closeConfirmModal() {
      if (els.confirmModal) {
        els.confirmModal.style.display = 'none';
      }
      document.body.style.overflow = '';
    }

    /**
     * Execute the actual add to cart from the confirm modal
     */
    function executeAddToCart() {
      state.confirmPending = true;
      addBundleToCart();
    }

    // Public API
    return {
      init: init
    };

  })();

  // Make it globally available
  window.RevBundleBuilder = RevBundleBuilder;

  // Auto-init (handles both: script loaded before and after DOMContentLoaded)
  function revBundleBuilderAutoInit() {
    const section = document.querySelector('[data-rev-bundle-builder]');
    if (section) {
      RevBundleBuilder.init(section);
      revInitCharCounters(section);
      revInitPlaceholderCycle(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revBundleBuilderAutoInit);
  } else {
    revBundleBuilderAutoInit();
  }

  // RevFlare Collection Main — Sorting, Filtering, Pagination
  // Uses event delegation so no DOM timing issues and no re-binding needed after rerender.
  (function () {

    // ── Helpers ──

    function debounce(fn, delay) {
      var timer;
      return function () {
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    }

    function getSectionId(el) {
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) return wrapper.id.replace('shopify-section-', '');
      return null;
    }

    function setLoading(section, loading) {
      var products = section.querySelector('[data-rev-collection-products]');
      if (!products) return;
      if (loading) {
        products.classList.add('rev-collection-loading');
      } else {
        products.classList.remove('rev-collection-loading');
      }
    }

    // After rerender or page load, if a swatch is pre-selected (e.g. from filter),
    // show the matching media layer by adding .active directly.
    // Uses the same data-swatch-value / data-option-value link the card already has.
    function syncSwatchMedia(section) {
      section.querySelectorAll('.rev-product-card').forEach(function (card) {
        // Find the active swatch (Liquid sets .rev-card-swatch-active via value.selected)
        var activeSwatch = card.querySelector('.rev-card-swatch-active');
        if (!activeSwatch) return;

        var optionValue = activeSwatch.dataset.optionValue;
        if (!optionValue) return;

        // Find the card media container
        var cardMedia = card.querySelector('.rev-card-media');
        if (!cardMedia) return;

        // Hide all swatch media layers, then show the matching one
        cardMedia.querySelectorAll('.rev-card-swatch-media').forEach(function (m) {
          m.classList.remove('active');
        });
        var target = cardMedia.querySelector('.rev-card-swatch-media[data-swatch-value="' + optionValue + '"]');
        if (target) target.classList.add('active');
      });
    }

    // ── Core AJAX rerender ──

    function rerenderCollection(section, newUrl) {
      var sectionId = getSectionId(section);
      if (!sectionId) {
        window.location.href = newUrl;
        return;
      }

      setLoading(section, true);

      // Update browser URL without reload
      history.pushState({}, '', newUrl);

      // Fetch only this section via Section Rendering API
      var fetchUrl = new URL(newUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Section Rendering API returns the section's HTML directly.
          // Find the new container content to swap in.
          var newContainer = doc.querySelector('.rev-container')
            || doc.querySelector('[data-rev-collection-main] .rev-container');
          var currentContainer = section.querySelector('.rev-container');

          if (currentContainer && newContainer) {
            // Preserve search input value before replacing HTML
            var searchInput = currentContainer.querySelector('[data-rev-collection-search-input]');
            var savedSearchQuery = searchInput ? searchInput.value : '';

            currentContainer.innerHTML = newContainer.innerHTML;

            // Restore search input value and focus after rerender
            if (savedSearchQuery) {
              var restoredInput = currentContainer.querySelector('[data-rev-collection-search-input]');
              if (restoredInput) {
                restoredInput.value = savedSearchQuery;
                restoredInput.focus();
                restoredInput.setSelectionRange(savedSearchQuery.length, savedSearchQuery.length);
              }
              // Re-apply search filter on the fresh content
              if (typeof applyCollectionSearch === 'function') {
                applyCollectionSearch(section, savedSearchQuery);
              }
            }
          }

          setLoading(section, false);

          // Re-init variant selectors on the fresh product cards
          if (typeof initVariantSelectorState === 'function') {
            initVariantSelectorState(section);
          }

          // Sync card media with active collection color filter.
          // Parse URL for color filter values and select matching swatches.
          syncSwatchMedia(section);

          // Re-init infinite scroll if present
          var infiniteTrigger = section.querySelector('[data-rev-infinite-scroll]');
          if (infiniteTrigger) {
            bindInfiniteScroll(infiniteTrigger);
          }

          // Scroll to top of section
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () {
          setLoading(section, false);
          window.location.href = newUrl;
        });
    }

    // ── Price filter form submission ──

    function applyPriceFilters(section, form) {
      var url = new URL(window.location.href);

      // Remove existing price params
      var keysToRemove = [];
      url.searchParams.forEach(function (val, key) {
        if (key.indexOf('filter.v.price') === 0) {
          keysToRemove.push(key);
        }
      });
      keysToRemove.forEach(function (k) { url.searchParams.delete(k); });
      url.searchParams.delete('page');

      // Add current price values (converted to cents)
      form.querySelectorAll('[data-rev-price-filter]').forEach(function (input) {
        if (input.value && input.value !== '') {
          var cents = Math.round(parseFloat(input.value) * 100);
          if (!isNaN(cents) && cents > 0) {
            url.searchParams.set(input.name, cents.toString());
          }
        }
      });

      rerenderCollection(section, url.toString());
    }

    var debouncedPriceApply = debounce(function (section, form) {
      applyPriceFilters(section, form);
    }, 1000);

    // ── Infinite Scroll (needs direct observer binding) ──

    function bindInfiniteScroll(trigger) {
      var isLoading = false;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || isLoading) return;

          var nextUrl = trigger.getAttribute('data-next-url');
          if (!nextUrl) { observer.disconnect(); return; }

          isLoading = true;

          fetch(nextUrl)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-rev-collection-products] .rev-card-grid');
              var currentGrid = trigger.closest('[data-rev-collection-products]').querySelector('.rev-card-grid');

              if (newGrid && currentGrid) {
                while (newGrid.children.length > 0) {
                  currentGrid.appendChild(newGrid.children[0]);
                }
              }

              if (typeof initVariantSelectorState === 'function') {
                var section = trigger.closest('[data-rev-collection-main]');
                if (section) initVariantSelectorState(section);
              }

              var newTrigger = doc.querySelector('[data-rev-infinite-scroll]');
              if (newTrigger) {
                trigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
              } else {
                trigger.removeAttribute('data-next-url');
                observer.disconnect();
              }
              isLoading = false;
            })
            .catch(function () { isLoading = false; });
        });
      }, { rootMargin: '200px' });

      observer.observe(trigger);
    }

    // ══════════════════════════════════════════
    // EVENT DELEGATION — all on document, works
    // regardless of DOM timing or rerender
    // ══════════════════════════════════════════

    // ── Sort dropdown ──
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-rev-sort-select]');
      if (!select) return;

      var section = select.closest('[data-rev-collection-main]');
      if (!section) return;

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');

      rerenderCollection(section, url.toString());
    });

    // ── Filter checkbox ──
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-rev-filter-input][type="checkbox"]');
      if (!input) return;

      var section = input.closest('[data-rev-collection-main]');
      if (!section) return;

      var targetUrl = input.checked
        ? input.getAttribute('data-url-add')
        : input.getAttribute('data-url-remove');

      if (targetUrl) {
        rerenderCollection(section, targetUrl);
      }
    });

    // ── Price range button ──
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rev-price-btn]');
      if (!btn) return;

      var section = btn.closest('[data-rev-collection-main]');
      if (!section) return;

      var url = new URL(window.location.href);
      var minParam = btn.dataset.minParam;
      var maxParam = btn.dataset.maxParam;

      // Toggle: if already active, remove the price filter
      if (btn.classList.contains('rev-collection-filter-price-btn--active')) {
        url.searchParams.delete(minParam);
        url.searchParams.delete(maxParam);
      } else {
        url.searchParams.set(minParam, btn.dataset.min);
        url.searchParams.set(maxParam, btn.dataset.max);
      }

      url.searchParams.delete('page');
      rerenderCollection(section, url.toString());
    });

    // ── Price filter input (debounced) ──
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-rev-price-filter]');
      if (!input) return;

      var section = input.closest('[data-rev-collection-main]');
      var form = input.closest('[data-rev-filter-form]');
      if (section && form) {
        debouncedPriceApply(section, form);
      }
    });

    // ── Filter form submit (price apply button) ──
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-rev-filter-form]');
      if (!form) return;

      e.preventDefault();
      var section = form.closest('[data-rev-collection-main]');
      if (section) applyPriceFilters(section, form);
    });

    // ── Filter drawer toggle ──
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-rev-filter-toggle]');
      if (!toggle) return;

      var section = toggle.closest('[data-rev-collection-main]');
      if (!section) return;

      var sidebar = section.querySelector('[data-rev-filter-sidebar]');
      var overlay = section.querySelector('[data-rev-filter-overlay]');
      if (sidebar) {
        sidebar.classList.add('rev-is-open');
        if (overlay) overlay.classList.add('rev-is-open');
        document.body.style.overflow = 'hidden';
      }
    });

    // ── Filter drawer close ──
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-rev-filter-close]');
      var overlayEl = e.target.closest('[data-rev-filter-overlay]');
      var trigger = closeBtn || overlayEl;
      if (!trigger) return;

      var section = trigger.closest('[data-rev-collection-main]');
      if (!section) return;

      var sidebar = section.querySelector('[data-rev-filter-sidebar]');
      var overlay = section.querySelector('[data-rev-filter-overlay]');
      if (sidebar) sidebar.classList.remove('rev-is-open');
      if (overlay) overlay.classList.remove('rev-is-open');
      document.body.style.overflow = '';
    });

    // ── Active filter pill remove ──
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.rev-collection-active-filter');
      if (!pill) return;
      e.preventDefault();

      var section = pill.closest('[data-rev-collection-main]');
      if (section) rerenderCollection(section, pill.getAttribute('href'));
    });

    // ── Clear all filters ──
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.rev-collection-active-filters__clear');
      if (!link) return;
      e.preventDefault();

      var section = link.closest('[data-rev-collection-main]');
      if (section) rerenderCollection(section, link.getAttribute('href'));
    });

    // ── Pagination links ──
    document.addEventListener('click', function (e) {
      var pageLink = e.target.closest('.rev-pagination__btn[href]');
      if (!pageLink) return;
      e.preventDefault();

      var section = pageLink.closest('[data-rev-collection-main]');
      if (section) rerenderCollection(section, pageLink.getAttribute('href'));
    });

    // ── Load more button ──
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rev-load-more]');
      if (!btn) return;

      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      var label = btn.querySelector('span');
      var originalLabel = label ? label.textContent : 'Load More';
      btn.setAttribute('disabled', 'true');
      if (label) label.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-rev-collection-products] .rev-card-grid');
          var currentGrid = btn.closest('[data-rev-collection-products]').querySelector('.rev-card-grid');

          if (newGrid && currentGrid) {
            while (newGrid.children.length > 0) {
              currentGrid.appendChild(newGrid.children[0]);
            }
          }

          if (typeof initVariantSelectorState === 'function') {
            var section = btn.closest('[data-rev-collection-main]');
            if (section) initVariantSelectorState(section);
          }

          var newBtn = doc.querySelector('[data-rev-load-more]');
          if (newBtn) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.removeAttribute('disabled');
            if (label) label.textContent = originalLabel;
          } else {
            var wrapper = btn.closest('.rev-collection-load-more');
            if (wrapper) wrapper.style.display = 'none';
          }
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          if (label) label.textContent = originalLabel;
        });
    });

    // ── Browser back/forward ──
    window.addEventListener('popstate', function () {
      document.querySelectorAll('[data-rev-collection-main]').forEach(function (section) {
        rerenderCollection(section, window.location.href);
      });
    });

    // ── Init infinite scroll on page load (needs observer, can't delegate) ──
    function initInfiniteScroll() {
      document.querySelectorAll('[data-rev-infinite-scroll]').forEach(function (trigger) {
        if (!trigger._revObserverBound) {
          trigger._revObserverBound = true;
          bindInfiniteScroll(trigger);
        }
      });
    }

    // ── Sync swatch media on page load (handles direct URL with filters) ──
    function initSwatchMediaSync() {
      document.querySelectorAll('[data-rev-collection-main]').forEach(function (section) {
        syncSwatchMedia(section);
      });
    }

    function initAll() {
      initInfiniteScroll();
      initSwatchMediaSync();
    }

    // ── Collection Search ──
    // Fetches ALL products from /collections/{handle}/products.json,
    // caches them, then does client-side fuzzy search across the full set.

    var productCache = {};

    function searchMatch(needle, haystack) {
      needle = needle.toLowerCase();
      haystack = haystack.toLowerCase();
      // Split query into words and check each word is found in the haystack
      var words = needle.split(/\s+/);
      for (var i = 0; i < words.length; i++) {
        if (words[i] && haystack.indexOf(words[i]) === -1) return false;
      }
      return true;
    }

    function fetchAllProducts(handle, callback) {
      if (productCache[handle]) {
        callback(productCache[handle]);
        return;
      }
      var results = [];
      var page = 1;

      function fetchPage() {
        fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!data.products || !data.products.length) {
              productCache[handle] = results;
              callback(results);
            } else {
              results = results.concat(data.products);
              if (data.products.length === 250) {
                page++;
                fetchPage();
              } else {
                productCache[handle] = results;
                callback(results);
              }
            }
          })
          .catch(function () {
            productCache[handle] = results;
            callback(results);
          });
      }
      fetchPage();
    }

    function updateProductCount(section, count, total) {
      var countEls = section.querySelectorAll('[data-rev-product-count]');
      var text = count === total
        ? total + ' ' + (total === 1 ? 'product' : 'products')
        : count + ' of ' + total + ' ' + (total === 1 ? 'product' : 'products');
      countEls.forEach(function (el) { el.textContent = text; });
    }

    function applyCollectionSearch(section, query) {
      var searchWrapper = section.querySelector('[data-rev-collection-search]');
      if (!searchWrapper) return;

      var handle = searchWrapper.getAttribute('data-collection-handle');
      var totalCount = parseInt(searchWrapper.getAttribute('data-products-count'), 10) || 0;

      fetchAllProducts(handle, function (products) {
        var gridItems = section.querySelectorAll('[data-rev-collection-products] .rev-card-grid__item');

        if (!query) {
          gridItems.forEach(function (item) { item.style.display = ''; });
          updateProductCount(section, totalCount, totalCount);
          return;
        }

        var matchedHandles = {};
        products.forEach(function (p) {
          var searchable = [p.title || '', p.product_type || '', p.vendor || '', (p.tags || []).join(' ')].join(' ');
          if (searchMatch(query, searchable)) {
            matchedHandles[p.handle] = true;
          }
        });

        var visibleCount = 0;
        gridItems.forEach(function (item) {
          var card = item.querySelector('[data-product-handle]');
          if (!card) return;
          var cardHandle = card.getAttribute('data-product-handle');
          var isMatch = matchedHandles[cardHandle] ? true : false;
          item.style.display = isMatch ? '' : 'none';
          if (isMatch) visibleCount++;
        });

        updateProductCount(section, visibleCount, totalCount);
      });
    }

    // Prefetch products on first focus
    document.addEventListener('focusin', function (e) {
      var input = e.target.closest('[data-rev-collection-search-input]');
      if (!input) return;
      var searchWrapper = input.closest('[data-rev-collection-search]');
      if (!searchWrapper) return;
      var handle = searchWrapper.getAttribute('data-collection-handle');
      fetchAllProducts(handle, function () { });
    });

    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-rev-collection-search-input]');
      if (!input) return;

      var section = input.closest('[data-rev-collection-main]');
      if (!section) return;

      var query = input.value.trim();

      // If on a paginated page (page 2+), go back to page 1 first
      var currentUrl = new URL(window.location.href);
      var currentPage = currentUrl.searchParams.get('page');
      if (currentPage && currentPage !== '1' && query) {
        var searchWrapper = section.querySelector('[data-rev-collection-search]');
        var handle = searchWrapper ? searchWrapper.getAttribute('data-collection-handle') : '';
        rerenderCollection(section, '/collections/' + handle);
        return;
      }

      applyCollectionSearch(section, query);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

  })();

  // ================================
  // PDP Bundle Builder Accordion
  // ================================

  function revSyncAccordionItem(item) {
    if (!item || !item.classList.contains('rev-bundle-builder__item--accordion')) return;

    const trigger = item.querySelector('[data-accordion-trigger]');
    const initialState = item.querySelector('[data-state="initial"]');
    if (!trigger || !initialState) return;

    const selected = item.dataset.selected === 'true';
    const skipped = item.dataset.skipped === 'true';
    const updating = item.dataset.updating === 'true';

    // Open when item is back in initial selection mode
    const shouldOpen = !selected && !skipped && !updating;

    item.classList.toggle('is-open', shouldOpen);
    trigger.setAttribute('aria-expanded', String(shouldOpen));
    initialState.hidden = !shouldOpen;
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    // Do not toggle when clicking action buttons inside header
    if (
      e.target.closest('[data-edit-trigger]') ||
      e.target.closest('[data-unskip-trigger]') ||
      e.target.closest('[data-swap-trigger]')
    ) {
      return;
    }

    const item = trigger.closest('.rev-bundle-builder__item--accordion');
    if (!item) return;

    const initialState = item.querySelector('[data-state="initial"]');
    if (!initialState) return;

    const isOpen = item.classList.contains('is-open');

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    initialState.hidden = isOpen;
  });

  document.addEventListener('keydown', function (e) {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    trigger.click();
  });

  // After a choice click, let bundle builder change state first, then sync accordion UI
  document.addEventListener('click', function (e) {
    const choice = e.target.closest('.rev-bundle-builder__choice');
    if (!choice) return;

    const item = choice.closest('.rev-bundle-builder__item--accordion');
    if (!item) return;

    requestAnimationFrame(() => {
      revSyncAccordionItem(item);
    });
  });

  // After swap / edit / undo skip, force accordion to resync after bundle JS updates the item
  document.addEventListener('click', function (e) {
    if (
      !e.target.closest('[data-swap-trigger]') &&
      !e.target.closest('[data-edit-trigger]') &&
      !e.target.closest('[data-unskip-trigger]')
    ) {
      return;
    }

    const item = e.target.closest('.rev-bundle-builder__item--accordion');
    if (!item) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        revSyncAccordionItem(item);
      });
    });
  });

  // Initial sync on page load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rev-bundle-builder__item--accordion').forEach(revSyncAccordionItem);
  });

  // ================================
  // PDP Bundle Builder Overlay
  // ================================
  document.addEventListener('input', function (e) {
    const input = e.target.closest('[data-custom-input]');
    if (!input) return;

    const item = input.closest('[data-bundle-item]');
    if (!item) return;

    const value = input.value || '';

    item.querySelectorAll('[data-custom-overlay-text]').forEach(function (el) {
      el.textContent = value;
    });
  });

  /* ================================
  Header Navigation — <rev-header-nav>
  ================================ */

  (function () {
    'use strict';

    if (customElements.get('rev-header-nav')) return;

    class RevHeaderNav extends HTMLElement {
      constructor() {
        super();
        this._sticky = this.dataset.revSticky === 'true';
        this._transparent = this.dataset.revTransparent === 'true';
        this._hoverMenu = this.dataset.revHoverMenu === 'true';
        this._header = null;
        this._placeholder = null;
        this._activeMegamenu = null;
        this._drawer = null;
        this._overlay = null;
        this._headerHeight = 0;
        this._originalPosition = 0;
        this._isSticky = false;
        this._resizeTimeout = null;
        this._boundOnScroll = this._onScroll.bind(this);
        this._boundOnResize = this._onResize.bind(this);
        this._boundCloseAll = this._closeAll.bind(this);
      }

      connectedCallback() {
        if (this._initialized) return;

        // Fast path: children already parsed
        if (this.querySelector('.rev-header')) {
          this._init();
        } else {
          // Wait for children to be parsed/injected
          this._waitObserver = new MutationObserver(() => {
            if (this.querySelector('.rev-header')) {
              this._waitObserver.disconnect();
              this._waitObserver = null;
              this._init();
            }
          });
          this._waitObserver.observe(this, { childList: true, subtree: true });

          // Safety timeout — gives up after 5s rather than waiting forever
          this._waitTimeout = setTimeout(() => {
            if (this._waitObserver) {
              this._waitObserver.disconnect();
              this._waitObserver = null;
              if (this.querySelector('.rev-header')) this._init();
            }
          }, 5000);
        }

        // Re-init when the theme editor reloads this section
        var self = this;
        this._sectionLoadHandler = function (e) {
          if (e.target && (e.target === self || e.target.contains(self))) {
            self._initialized = false;
            self._init();
          }
        };
        document.addEventListener('shopify:section:load', this._sectionLoadHandler);
      }

      _init() {
        if (this._initialized) return;
        this._header = this.querySelector('.rev-header');
        this._placeholder = this.querySelector('.rev-header__placeholder');
        this._drawer = this.querySelector('.rev-header__drawer');
        this._overlay = this.querySelector('.rev-header__overlay');
        this._searchOverlay = this.querySelector('[data-rev-search-overlay]');

        if (!this._header) return;
        this._initialized = true;

        this._bindMegamenuTriggers();
        this._bindMegamenuTabs();
        this._bindHamburger();

        this._bindDrawerClose();
        this._bindOverlay();
        this._bindLocalization();
        this._bindSearch();
        this._bindKeyboard();
        this._initSearchSuggestions();

        if (this._sticky) {
          requestAnimationFrame(() => {
            this._calculateDimensions();
            this._onScroll();
          });
          window.addEventListener('scroll', this._boundOnScroll, { passive: true });
          window.addEventListener('resize', this._boundOnResize, { passive: true });
        }
      }

      disconnectedCallback() {
        if (this._waitObserver) {
          this._waitObserver.disconnect();
          this._waitObserver = null;
        }
        if (this._waitTimeout) {
          clearTimeout(this._waitTimeout);
          this._waitTimeout = null;
        }
        if (this._sectionLoadHandler) {
          document.removeEventListener('shopify:section:load', this._sectionLoadHandler);
          this._sectionLoadHandler = null;
        }
        window.removeEventListener('scroll', this._boundOnScroll);
        window.removeEventListener('resize', this._boundOnResize);
        document.removeEventListener('click', this._boundCloseAll);
      }

      // ============ Measurement ============

      _measureHeader() {
        this._headerHeight = this._header.offsetHeight;
      }

      // ============ Sticky (matches sticky-submenu pattern) ============

      _calculateDimensions() {
        if (!this._header) return;
        var wasSticky = this._isSticky;

        // Temporarily un-stick to get a clean measurement
        if (wasSticky) {
          this._header.classList.remove('is-sticky');
          this._placeholder.style.height = '0px';
        }

        var rect = this._header.getBoundingClientRect();
        this._originalPosition = rect.top + (window.pageYOffset || 0);
        this._headerHeight = rect.height;

        // Re-apply sticky if it was active
        if (wasSticky) {
          this._header.classList.add('is-sticky');
          this._placeholder.style.height = this._headerHeight + 'px';
        }
      }

      _onScroll() {
        if (!this._header || !this._placeholder) return;
        var scrollTop = window.pageYOffset || 0;
        var shouldBeSticky = scrollTop > this._originalPosition;

        if (shouldBeSticky && !this._isSticky) {
          this._placeholder.style.height = this._headerHeight + 'px';
          this._header.classList.add('is-sticky');
          this._isSticky = true;
        } else if (!shouldBeSticky && this._isSticky) {
          this._header.classList.remove('is-sticky');
          this._placeholder.style.height = '0px';
          this._isSticky = false;
        }
      }

      _onResize() {
        clearTimeout(this._resizeTimeout);
        this._resizeTimeout = setTimeout(() => {
          this._calculateDimensions();
          this._onScroll();
        }, 16);
      }

      // ============ Mega Menu (Desktop) ============

      _bindMegamenuTriggers() {
        var self = this;

        // Delegated click handler — survives DOM replacement
        this.addEventListener('click', function (e) {
          var trigger = e.target.closest && e.target.closest('[data-rev-megamenu-trigger]');
          if (!trigger || !self.contains(trigger)) return;

          e.stopPropagation();
          var index = trigger.getAttribute('data-rev-megamenu-trigger');
          var sectionId = self.dataset.revSectionId;
          var panelId = 'rev-megamenu-' + sectionId + '-' + index;
          var panel = self.querySelector('#' + panelId);

          if (!panel) return;

          var isOpen = panel.getAttribute('aria-hidden') === 'false';

          // Close any open panel first
          self._closeMegamenus();

          if (!isOpen) {
            self._openMegamenu(panel, trigger);
          }
        });

        // Delegated hover handler (desktop only, when enabled)
        if (this._hoverMenu) {
          var hoverTimeout = null;
          var closeTimeout = null;

          // Use mouseover (bubbles) instead of mouseenter (doesn't bubble)
          this.addEventListener('mouseover', function (e) {
            if (window.innerWidth < 769) return;

            var trigger = e.target.closest && e.target.closest('[data-rev-megamenu-trigger]');
            var panel = e.target.closest && e.target.closest('.rev-megamenu');

            if (trigger && self.contains(trigger)) {
              // Hovering a trigger — schedule open
              var index = trigger.getAttribute('data-rev-megamenu-trigger');
              var sectionId = self.dataset.revSectionId;
              var panelId = 'rev-megamenu-' + sectionId + '-' + index;
              var targetPanel = self.querySelector('#' + panelId);
              if (!targetPanel) return;

              clearTimeout(closeTimeout);
              clearTimeout(hoverTimeout);
              hoverTimeout = setTimeout(function () {
                self._closeMegamenus();
                self._openMegamenu(targetPanel, trigger);
              }, 150);
            } else if (panel) {
              // Hovering an open panel — keep it open
              clearTimeout(closeTimeout);
            }
          });

          this.addEventListener('mouseout', function (e) {
            if (window.innerWidth < 769) return;

            var trigger = e.target.closest && e.target.closest('[data-rev-megamenu-trigger]');
            var panel = e.target.closest && e.target.closest('.rev-megamenu');

            if (!trigger && !panel) return;

            // Check if we're moving to another trigger or the panel — if so, don't close
            var related = e.relatedTarget;
            if (related && related.closest) {
              if (related.closest('[data-rev-megamenu-trigger]') || related.closest('.rev-megamenu')) {
                return;
              }
            }

            clearTimeout(hoverTimeout);
            closeTimeout = setTimeout(function () {
              self._closeMegamenus();
            }, 200);
          });
        }

        // Close megamenu when clicking outside (host or panels which may be moved to body)
        document.addEventListener('click', function (e) {
          if (self.contains(e.target)) return;
          // Allow clicks inside megamenu panels even if moved
          if (e.target.closest && e.target.closest('.rev-megamenu')) return;
          self._closeMegamenus();
        });
      }

      _openMegamenu(panel, trigger) {
        // Position panel below the header
        var headerRect = this._header.getBoundingClientRect();
        panel.style.top = headerRect.bottom + 'px';

        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        this._activeMegamenu = { panel: panel, trigger: trigger };
        this._header.classList.add('rev-header--megamenu-open');
      }

      _closeMegamenus() {
        var panels = this.querySelectorAll('.rev-megamenu');
        panels.forEach(function (p) {
          p.setAttribute('aria-hidden', 'true');
        });

        var triggers = this.querySelectorAll('[data-rev-megamenu-trigger]');
        triggers.forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });

        this._activeMegamenu = null;
        this._header.classList.remove('rev-header--megamenu-open');
      }

      // ============ Mobile Drawer ============

      _bindHamburger() {
        var self = this;
        this.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('.rev-header__hamburger');
          if (!btn || !self.contains(btn)) return;
          self._openDrawer();
        });
      }

      _bindDrawerClose() {
        var self = this;
        this.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('.rev-header__drawer-close');
          if (!btn || !self.contains(btn)) return;
          self._closeDrawer();
        });
      }

      _bindOverlay() {
        var self = this;
        this.addEventListener('click', function (e) {
          var overlay = e.target.closest && e.target.closest('.rev-header__overlay');
          if (!overlay || !self.contains(overlay)) return;
          self._closeAll();
        });
      }

      _openDrawer() {
        if (!this._drawer) return;
        this._drawer.setAttribute('aria-hidden', 'false');
        if (this._overlay) this._overlay.setAttribute('aria-hidden', 'false');

        // Lock body scroll (iOS-compatible)
        this._scrollY = window.pageYOffset || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + this._scrollY + 'px';
        document.body.style.width = '100%';

        // Set focus to close button
        var closeBtn = this._drawer.querySelector('.rev-header__drawer-close');
        if (closeBtn) closeBtn.focus();

        // Update hamburger state
        var hamburgers = this.querySelectorAll('.rev-header__hamburger');
        hamburgers.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
      }

      _closeDrawer() {
        if (!this._drawer) return;
        // Only restore scroll if drawer was actually open
        if (this._drawer.getAttribute('aria-hidden') === 'true') return;
        this._drawer.setAttribute('aria-hidden', 'true');
        if (this._overlay) this._overlay.setAttribute('aria-hidden', 'true');

        // Restore body scroll
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this._scrollY || 0);

        var hamburgers = this.querySelectorAll('.rev-header__hamburger');
        hamburgers.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      }

      _closeAll() {
        this._closeMegamenus();
        this._closeDrawer();
      }

      // ============ Mega-Menu Tabs ============

      _bindMegamenuTabs() {
        var self = this;
        this.addEventListener('click', function (e) {
          var tab = e.target.closest && e.target.closest('.rev-megamenu__tab');
          if (!tab || !self.contains(tab)) return;

          var container = tab.closest('.rev-megamenu__tabs-container');
          if (!container) return;

          // Deselect all tabs in this container
          var allTabs = container.querySelectorAll('.rev-megamenu__tab');
          allTabs.forEach(function (t) {
            t.setAttribute('aria-selected', 'false');
          });

          // Hide all panels in this container
          var allPanels = container.querySelectorAll('.rev-megamenu__tab-panel');
          allPanels.forEach(function (p) {
            p.hidden = true;
          });

          // Activate clicked tab
          tab.setAttribute('aria-selected', 'true');

          // Show corresponding panel
          var panelId = tab.getAttribute('aria-controls');
          var panel = container.querySelector('#' + panelId);
          if (panel) panel.hidden = false;
        });
      }

      // ============ Localization ============

      _bindLocalization() {
        var disclosures = this.querySelectorAll('[data-rev-localization]');
        if (!disclosures.length) return;

        var self = this;

        disclosures.forEach(function (disclosure) {
          var form = disclosure.closest('form');
          if (!form) return;

          // Option click → update hidden input & submit
          var buttons = disclosure.querySelectorAll('.rev-localization__option-btn');
          buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
              var value = btn.getAttribute('data-value');
              // Find the hidden input (country_code or locale_code)
              var hiddenInput = form.querySelector('input[type="hidden"]');
              if (hiddenInput) {
                hiddenInput.value = value;
                form.submit();
              }
            });
          });

          // Close on click outside
          document.addEventListener('click', function (e) {
            if (!disclosure.contains(e.target)) {
              disclosure.removeAttribute('open');
            }
          });
        });
      }

      // ============ Keyboard ============

      _bindKeyboard() {
        var self = this;
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            self._closeAll();
            self._closeSearchOverlay();
          }
        });
      }

      // ============ Search Overlay ============

      _bindSearch() {
        var self = this;
        if (!this._searchOverlay) return;

        // Delegated toggle button click
        this.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('[data-rev-search-toggle]');
          if (!btn || !self.contains(btn)) return;
          e.stopPropagation();
          if (self._searchOverlay.classList.contains('rev-search-overlay--open')) {
            self._closeSearchOverlay();
          } else {
            self._openSearchOverlay();
          }
        });

        // Delegated close button click (overlay may be moved to body, so listen on document)
        document.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('[data-rev-search-close]');
          if (!btn) return;
          // Make sure this close button belongs to our overlay
          if (!self._searchOverlay || !self._searchOverlay.contains(btn)) return;
          self._closeSearchOverlay();
        });

        // Click outside overlay closes everything
        document.addEventListener('click', function (e) {
          if (!self._searchOverlay.classList.contains('rev-search-overlay--open')) return;
          // Ignore clicks inside the overlay, on toggle buttons, or on persistent bars
          if (self._searchOverlay.contains(e.target)) return;
          if (e.target.closest('[data-rev-search-toggle]')) return;
          if (e.target.closest('[data-rev-search-inline]') || e.target.closest('.rev-header__search-bar')) return;
          self._closeSearchOverlay();
        });

        // Persistent search bars — proxy to overlay
        this._bindPersistentSearch();
      }

      // ============ Cycling Search Suggestions ============

      _initSearchSuggestions() {
        var raw = this.getAttribute('data-rev-search-suggestions');
        if (!raw) return;

        var suggestions = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (suggestions.length === 0) return;

        // Collect ALL search inputs (overlay + persistent)
        var inputs = this.querySelectorAll('input[type="search"]');
        if (!inputs.length) return;

        var currentIndex = 0;
        var charIndex = 0;
        var isTyping = true;
        var isPaused = false;

        // Pause when user focuses any search input
        inputs.forEach(function (input) {
          input.addEventListener('focus', function () {
            isPaused = true;
            inputs.forEach(function (inp) { inp.placeholder = 'Search...'; });
          });
          input.addEventListener('blur', function () {
            if (input.value.length === 0) {
              isPaused = false;
            }
          });
        });

        function setPlaceholder(text) {
          inputs.forEach(function (inp) {
            if (document.activeElement !== inp) {
              inp.placeholder = text;
            }
          });
        }

        function tick() {
          if (isPaused) {
            requestAnimationFrame(function () { setTimeout(tick, 200); });
            return;
          }

          var word = suggestions[currentIndex];

          if (isTyping) {
            charIndex++;
            setPlaceholder(word.substring(0, charIndex));

            if (charIndex >= word.length) {
              isTyping = false;
              setTimeout(tick, 2000);
              return;
            }
            setTimeout(tick, 80);
          } else {
            charIndex--;
            if (charIndex <= 0) {
              isTyping = true;
              currentIndex = (currentIndex + 1) % suggestions.length;
              setTimeout(tick, 300);
              return;
            }
            setPlaceholder(word.substring(0, charIndex));
            setTimeout(tick, 40);
          }
        }

        // Start after a short delay
        setTimeout(tick, 1000);
      }

      _bindPersistentSearch() {
        var self = this;
        var overlayInput = this._searchOverlay.querySelector('input[type="search"]');
        if (!overlayInput) return;

        // Collect all persistent search inputs (inline + bar)
        var persistentInputs = this.querySelectorAll('.rev-header__search-inline input[type="search"], .rev-header__search-bar input[type="search"]');
        if (!persistentInputs.length) return;

        persistentInputs.forEach(function (input) {
          // On focus or input, open overlay and sync
          input.addEventListener('focus', function () {
            if (!self._searchOverlay.classList.contains('rev-search-overlay--open')) {
              self._openSearchOverlay(true); // true = don't focus overlay input
            }
          });

          input.addEventListener('input', function () {
            var query = input.value;
            // Open overlay if not already open
            if (!self._searchOverlay.classList.contains('rev-search-overlay--open')) {
              self._openSearchOverlay(true);
            }
            // Sync to overlay input and trigger its predictive search
            overlayInput.value = query;
            overlayInput.dispatchEvent(new Event('input', { bubbles: true }));
          });

          // Submit on Enter
          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              var query = input.value.trim();
              if (query.length > 0) {
                window.location.href = '/search?q=' + encodeURIComponent(query) + '&options[prefix]=last';
              }
            }
          });
        });

        // When overlay closes, clear persistent inputs too
        this._persistentInputs = persistentInputs;
      }

      _openSearchOverlay(skipFocus) {
        if (!this._searchOverlay) return;
        this._closeAll();

        this._searchOverlay.classList.add('rev-search-overlay--open');
        this._searchOverlay.setAttribute('aria-hidden', 'false');

        // Focus input without scrolling (unless called from persistent bar)
        if (!skipFocus) {
          var input = this._searchOverlay.querySelector('input[type="search"]');
          if (input) {
            setTimeout(function () { input.focus({ preventScroll: true }); }, 100);
          }
        }
      }

      _closeSearchOverlay() {
        if (!this._searchOverlay) return;

        // On mobile bar mode, the overlay is always visible — don't close it,
        // just clear results
        var isMobileBar = this.getAttribute('data-rev-search-mobile') === 'bar' && window.innerWidth <= 768;
        if (isMobileBar) {
          var results = this._searchOverlay.querySelector('.rev-search__results');
          if (results) {
            results.innerHTML = '';
            results.style.display = 'none';
          }
          var searchEl = this._searchOverlay.querySelector('rev-predictive-search');
          if (searchEl) searchEl.classList.remove('rev-search--open');
          return;
        }

        // Move focus out before hiding to avoid aria-hidden warning
        if (this._searchOverlay.contains(document.activeElement)) {
          document.activeElement.blur();
        }

        this._searchOverlay.classList.remove('rev-search-overlay--open');
        this._searchOverlay.setAttribute('aria-hidden', 'true');

        // Clear input and results
        var input = this._searchOverlay.querySelector('input[type="search"]');
        if (input) {
          input.value = '';
        }
        var results = this._searchOverlay.querySelector('.rev-search__results');
        if (results) {
          results.innerHTML = '';
          results.style.display = 'none';
        }
        // Reset aria
        var searchEl = this._searchOverlay.querySelector('rev-predictive-search');
        if (searchEl) {
          searchEl.classList.remove('rev-search--open');
        }

        // Clear persistent search bar inputs
        if (this._persistentInputs) {
          this._persistentInputs.forEach(function (pInput) {
            pInput.value = '';
            var clearBtn = pInput.closest('.rev-search').querySelector('.rev-search__clear');
            if (clearBtn) clearBtn.hidden = true;
          });
        }
      }
    }

    customElements.define('rev-header-nav', RevHeaderNav);
  })();

  /* ================================
  Predictive Search — <rev-predictive-search>
  ================================ */

  (function () {
    'use strict';

    if (customElements.get('rev-predictive-search')) return;

    class RevPredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this._input = null;
        this._results = null;
        this._clearBtn = null;
        this._form = null;
        this._loading = null;
        this._abortController = null;
        this._debounceTimer = null;
        this._isOpen = false;
        this._cachedResults = {};
      }

      connectedCallback() {
        // Persistent variants proxy to the overlay — don't bind fetch logic
        if (this.classList.contains('rev-search--persistent')) return;

        var init = () => {
          if (this._initialized) return;
          this._input = this.querySelector('input[type="search"]');
          this._results = this.querySelector('.rev-search__results');
          this._clearBtn = this.querySelector('.rev-search__clear');
          this._form = this.querySelector('form');
          this._loading = this.querySelector('.rev-search__loading');

          if (!this._input || !this._results) return;
          this._initialized = true;

          this._bindEvents();
        };

        // Allow parser to append children
        requestAnimationFrame(() => {
          if (!this.querySelector('input[type="search"]')) {
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', init);
            } else {
              setTimeout(init, 50);
            }
          } else {
            init();
          }
        });
      }

      disconnectedCallback() {
        if (this._abortController) {
          this._abortController.abort();
        }
        clearTimeout(this._debounceTimer);
      }

      _bindEvents() {
        var self = this;

        // Debounced input
        this._input.addEventListener('input', function () {
          clearTimeout(self._debounceTimer);
          var query = self._input.value.trim();

          // Show/hide clear button
          if (self._clearBtn) {
            self._clearBtn.hidden = query.length === 0;
          }

          if (query.length === 0) {
            self._close();
            return;
          }

          if (query.length < 2) return;

          self._debounceTimer = setTimeout(function () {
            self._fetchResults(query);
          }, 300);
        });

        // Clear button
        if (this._clearBtn) {
          this._clearBtn.addEventListener('click', function () {
            self._input.value = '';
            self._clearBtn.hidden = true;
            self._close();
            self._input.focus();
          });
        }

        // Form submit — let it go to the search page naturally
        this._form.addEventListener('submit', function (e) {
          var query = self._input.value.trim();
          if (query.length === 0) {
            e.preventDefault();
          }
        });

        // Click outside (only for non-overlay variants; overlay parent handles its own)
        if (!this.classList.contains('rev-search--overlay')) {
          document.addEventListener('click', function (e) {
            if (self._isOpen && !self.contains(e.target)) {
              self._close();
            }
          });
        }

        // Keyboard
        this._input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            self._close();
            self._input.blur();
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            self._focusFirstResult();
          }
        });

        // Arrow key navigation inside results
        this._results.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            self._close();
            self._input.focus();
            return;
          }

          var focusable = self._results.querySelectorAll('a, button');
          var current = document.activeElement;
          var index = Array.prototype.indexOf.call(focusable, current);

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (index < focusable.length - 1) {
              focusable[index + 1].focus();
            }
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (index > 0) {
              focusable[index - 1].focus();
            } else {
              self._input.focus();
            }
          }
        });

        // Focus input should reopen results if there are cached ones
        this._input.addEventListener('focus', function () {
          var query = self._input.value.trim();
          if (query.length >= 2 && self._results.innerHTML.trim().length > 0) {
            self._open();
          }
        });
      }

      _fetchResults(query) {
        var self = this;

        // Check cache
        if (this._cachedResults[query]) {
          this._renderResults(this._cachedResults[query]);
          return;
        }

        // Abort previous request
        if (this._abortController) {
          this._abortController.abort();
        }
        this._abortController = new AbortController();

        this._setLoading(true);

        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        var url = root + 'search/suggest?q=' + encodeURIComponent(query)
          + '&resources[type]=product,collection,page,article,query'
          + '&resources[limit]=10'
          + '&resources[limit_scope]=each'
          + '&resources[options][unavailable_products]=last'
          + '&section_id=rev-predictive-search';

        fetch(url, { signal: this._abortController.signal })
          .then(function (response) {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response.text();
          })
          .then(function (text) {
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var section = parsed.querySelector('#shopify-section-rev-predictive-search');
            var html = section ? section.innerHTML : '';

            // Cache it
            self._cachedResults[query] = html;
            self._renderResults(html);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') {
              self._close();
            }
          })
          .finally(function () {
            self._setLoading(false);
          });
      }

      _renderResults(html) {
        this._results.innerHTML = html;
        if (html.trim().length > 0) {
          this._open();
          this._bindTabs();
          this._initProductCards();
        } else {
          this._close();
        }
      }

      _initProductCards() {
        // Re-init variant selectors on injected product cards
        if (typeof initVariantSelectorState === 'function') {
          initVariantSelectorState(this._results);
        }
      }

      _bindTabs() {
        var results = this._results;
        var tabs = results.querySelectorAll('[data-rev-search-tab]');
        if (!tabs.length) return;

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var target = tab.getAttribute('data-rev-search-tab');

            // Deactivate all tabs
            results.querySelectorAll('[data-rev-search-tab]').forEach(function (t) {
              t.classList.remove('rev-search__tab--active');
              t.setAttribute('aria-selected', 'false');
            });

            // Deactivate all panels
            results.querySelectorAll('[data-rev-search-panel]').forEach(function (p) {
              p.classList.remove('rev-search__tab-panel--active');
            });

            // Activate clicked tab + its panel
            tab.classList.add('rev-search__tab--active');
            tab.setAttribute('aria-selected', 'true');
            var panel = results.querySelector('[data-rev-search-panel="' + target + '"]');
            if (panel) {
              panel.classList.add('rev-search__tab-panel--active');
            }
          });
        });
      }

      _open() {
        this._isOpen = true;
        this._results.style.display = 'block';
        this._input.setAttribute('aria-expanded', 'true');
        this.classList.add('rev-search--open');
      }

      _close() {
        this._isOpen = false;
        this._results.style.display = 'none';
        this._input.setAttribute('aria-expanded', 'false');
        this.classList.remove('rev-search--open');
      }

      _setLoading(state) {
        if (this._loading) {
          this._loading.style.display = state ? 'flex' : 'none';
        }
      }

      _focusFirstResult() {
        var first = this._results.querySelector('a, button');
        if (first) {
          first.focus();
        }
      }
    }

    customElements.define('rev-predictive-search', RevPredictiveSearch);
  })();

  // ================================
  // Quiz Klaviyo Email Capture
  // ================================
  (() => {
    class RevQuiz {
      constructor(container) {
        this.container = container;
        this.steps = Array.from(this.container.querySelectorAll('.rev-quiz-step'));
        this.progressBar = this.container.querySelector('.rev-quiz-progress-bar');
        this.stepCurrentEl = this.container.querySelector('.rev-step-current');
        this.stepPercentageEl = this.container.querySelector('.rev-step-percentage');
        this.prevBtn = this.container.querySelector('.rev-quiz-prev');
        this.questionsContainer = this.container.querySelector('.rev-quiz-questions');

        this.currentStep = 0;
        this.answers = {};
        this.resultLink = null;

        this.init();
      }

      init() {
        if (this.steps.length === 0) return;

        this.updateUI();

        // Bind option clicks
        const options = this.container.querySelectorAll('.rev-quiz-option');
        options.forEach(option => {
          option.addEventListener('click', (e) => {
            const stepIndex = parseInt(e.currentTarget.closest('.rev-quiz-step').dataset.step);
            this.answers[stepIndex] = e.currentTarget.dataset.value;

            // If this option has a result link, store it (last one wins)
            const resultLink = e.currentTarget.dataset.resultLink;
            if (resultLink) {
              this.resultLink = resultLink;
            }

            // Remove selected from siblings
            const siblings = e.currentTarget.parentElement.querySelectorAll('.rev-quiz-option');
            siblings.forEach(sib => sib.classList.remove('rev-selected'));

            e.currentTarget.classList.add('rev-selected');

            // Go to next step after a short delay
            setTimeout(() => this.nextStep(), 150);
          });
        });

        // Bind prev button
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.prevStep());
        }

        // Bind lead capture form submit
        const klaviyoForm = this.container.querySelector('.rev-quiz-klaviyo-form');
        if (klaviyoForm) {
          klaviyoForm.addEventListener('submit', (e) => {
            e.preventDefault();

            // Ensure hidden input is populated with selections
            const selectionsInput = klaviyoForm.querySelector('.rev-quiz-selections-input');
            if (selectionsInput) {
              selectionsInput.value = JSON.stringify(this.answers);
            }

            const submitBtn = klaviyoForm.querySelector('button[type="submit"]');
            const originalText = submitBtn.innerHTML;
            submitBtn.innerHTML = '<span>Submitting...</span>';
            submitBtn.disabled = true;

            const klaviyoListId = klaviyoForm.querySelector('input[name="g"]');
            const hasKlaviyo = klaviyoListId && klaviyoListId.value.trim() !== '';
            const emailInput = klaviyoForm.querySelector('input[name="email"]');
            const email = emailInput ? emailInput.value.trim() : '';

            // Format quiz selections for storage
            const formattedSelections = Object.keys(this.answers)
              .map(key => `Step ${parseInt(key) + 1}: ${this.answers[key]}`)
              .join(' | ');

            if (hasKlaviyo) {
              // ── Klaviyo submission ──
              const formData = new URLSearchParams();
              for (const pair of new FormData(klaviyoForm)) {
                formData.append(pair[0], pair[1]);
              }

              fetch(klaviyoForm.action, {
                method: 'POST',
                body: formData,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(res => {
                this.handleLeadCaptureSuccess(klaviyoForm);
              }).catch(err => {
                console.error('Klaviyo submission error', err);
                this.handleLeadCaptureSuccess(klaviyoForm);
              }).finally(() => {
                submitBtn.innerHTML = originalText;
                submitBtn.disabled = false;
              });
            } else {
              // ── No Klaviyo — use Shopify native /contact customer signup ──
              const shopifyData = new URLSearchParams();
              shopifyData.append('form_type', 'customer');
              shopifyData.append('utf8', '✓');
              shopifyData.append('customer[email]', email);
              shopifyData.append('customer[tags]', 'newsletter,quiz');
              if (formattedSelections) {
                shopifyData.append('customer[note]', 'Quiz Selections: ' + formattedSelections);
              }

              fetch('/contact#contact_form', {
                method: 'POST',
                body: shopifyData,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(res => {
                this.handleLeadCaptureSuccess(klaviyoForm);
              }).catch(err => {
                console.error('Shopify customer signup error', err);
                // Still treat as success — redirect or show message
                this.handleLeadCaptureSuccess(klaviyoForm);
              }).finally(() => {
                submitBtn.innerHTML = originalText;
                submitBtn.disabled = false;
              });
            }
          });
        }
      }

      handleLeadCaptureSuccess(form) {
        // If a result link was captured from the user's selection, redirect
        if (this.resultLink) {
          window.location.href = this.resultLink;
          return;
        }

        const step = form.closest('.rev-quiz-step');
        const successMsg = step.querySelector('.rev-quiz-lead-success');
        const leadContent = step.querySelector('.rev-quiz-lead-content');

        if (successMsg) {
          if (leadContent) leadContent.style.display = 'none';
          successMsg.style.display = 'block';

          if (this.progressBar) {
            this.progressBar.style.width = '100%';
          }
          if (this.stepPercentageEl) {
            this.stepPercentageEl.textContent = '100';
          }
          if (this.prevBtn) {
            this.prevBtn.style.display = 'none';
          }
        }
      }

      nextStep() {
        // Before moving, update hidden klaviyo inputs if they exist
        const selectionsInput = this.container.querySelector('.rev-quiz-selections-input');
        if (selectionsInput) {
          // Format answers as string to be stored in Klaviyo
          const formattedAnswers = Object.keys(this.answers)
            .map(key => `Step ${parseInt(key) + 1}: ${this.answers[key]}`)
            .join(' | ');
          selectionsInput.value = formattedAnswers;
        }

        if (this.currentStep < this.steps.length - 1) {
          this.currentStep++;
          this.updateUI();
        }
      }

      prevStep() {
        if (this.currentStep > 0) {
          this.currentStep--;
          this.updateUI();
        }
      }

      updateUI() {
        this.steps.forEach((step, index) => {
          if (index === this.currentStep) {
            step.classList.add('rev-active');
          } else {
            step.classList.remove('rev-active');
          }
        });

        // Progress calculation based on current step
        const progress = (this.currentStep / this.steps.length) * 100;
        if (this.progressBar) {
          this.progressBar.style.width = `${progress}%`;
        }
        if (this.stepCurrentEl) {
          this.stepCurrentEl.textContent = this.currentStep + 1;
        }
        if (this.stepPercentageEl) {
          this.stepPercentageEl.textContent = Math.round(progress);
        }

        if (this.prevBtn) {
          this.prevBtn.style.display = this.currentStep > 0 ? 'inline-flex' : 'none';
        }
      }
    }

    const initQuizzes = () => {
      const quizzes = document.querySelectorAll('.rev-quiz-section:not(.rev-quiz-initialized)');
      quizzes.forEach(quiz => {
        quiz.classList.add('rev-quiz-initialized');
        new RevQuiz(quiz);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuizzes);
    } else {
      initQuizzes();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', initQuizzes);
    }
  })();

} // end duplicate-load guard
